let privacyData = [{
  "value": "北京市",
  "children": [{
    "value": "北京市",
    "area": ["东城区", "西城区", "崇文区", "宣武区", "朝阳区", "丰台区", "石景山区", "海淀区", "门头沟区", "房山区", "通州区", "顺义区", "昌平区", "大兴区", "平谷区", "怀柔区", "密云县", "延庆县"],
    "children": [{
      "value": "东城区",
      "label": "东城区"
    }, {
      "value": "西城区",
      "label": "西城区"
    }, {
      "value": "崇文区",
      "label": "崇文区"
    }, {
      "value": "宣武区",
      "label": "宣武区"
    }, {
      "value": "朝阳区",
      "label": "朝阳区"
    }, {
      "value": "丰台区",
      "label": "丰台区"
    }, {
      "value": "石景山区",
      "label": "石景山区"
    }, {
      "value": "海淀区",
      "label": "海淀区"
    }, {
      "value": "门头沟区",
      "label": "门头沟区"
    }, {
      "value": "房山区",
      "label": "房山区"
    }, {
      "value": "通州区",
      "label": "通州区"
    }, {
      "value": "顺义区",
      "label": "顺义区"
    }, {
      "value": "昌平区",
      "label": "昌平区"
    }, {
      "value": "大兴区",
      "label": "大兴区"
    }, {
      "value": "平谷区",
      "label": "平谷区"
    }, {
      "value": "怀柔区",
      "label": "怀柔区"
    }, {
      "value": "密云县",
      "label": "密云县"
    }, {
      "value": "延庆县",
      "label": "延庆县"
    }],
    "label": "北京市"
  }],
  "label": "北京市"
}, {
  "value": "天津市",
  "children": [{
    "value": "天津市",
    "area": ["和平区", "河东区", "河西区", "南开区", "河北区", "红桥区", "塘沽区", "汉沽区", "大港区", "东丽区", "西青区", "津南区", "北辰区", "武清区", "宝坻区", "宁河县", "静海县", "蓟  县"],
    "children": [{
      "value": "和平区",
      "label": "和平区"
    }, {
      "value": "河东区",
      "label": "河东区"
    }, {
      "value": "河西区",
      "label": "河西区"
    }, {
      "value": "南开区",
      "label": "南开区"
    }, {
      "value": "河北区",
      "label": "河北区"
    }, {
      "value": "红桥区",
      "label": "红桥区"
    }, {
      "value": "塘沽区",
      "label": "塘沽区"
    }, {
      "value": "汉沽区",
      "label": "汉沽区"
    }, {
      "value": "大港区",
      "label": "大港区"
    }, {
      "value": "东丽区",
      "label": "东丽区"
    }, {
      "value": "西青区",
      "label": "西青区"
    }, {
      "value": "津南区",
      "label": "津南区"
    }, {
      "value": "北辰区",
      "label": "北辰区"
    }, {
      "value": "武清区",
      "label": "武清区"
    }, {
      "value": "宝坻区",
      "label": "宝坻区"
    }, {
      "value": "宁河县",
      "label": "宁河县"
    }, {
      "value": "静海县",
      "label": "静海县"
    }, {
      "value": "蓟  县",
      "label": "蓟  县"
    }],
    "label": "天津市"
  }],
  "label": "天津市"
}, {
  "value": "河北省",
  "children": [{
    "value": "石家庄市",
    "area": ["长安区", "桥东区", "桥西区", "新华区", "郊  区", "井陉矿区", "井陉县", "正定县", "栾城县", "行唐县", "灵寿县", "高邑县", "深泽县", "赞皇县", "无极县", "平山县", "元氏县", "赵  县", "辛集市", "藁", "晋州市", "新乐市", "鹿泉市"],
    "children": [{
      "value": "长安区",
      "label": "长安区"
    }, {
      "value": "桥东区",
      "label": "桥东区"
    }, {
      "value": "桥西区",
      "label": "桥西区"
    }, {
      "value": "新华区",
      "label": "新华区"
    }, {
      "value": "郊  区",
      "label": "郊  区"
    }, {
      "value": "井陉矿区",
      "label": "井陉矿区"
    }, {
      "value": "井陉县",
      "label": "井陉县"
    }, {
      "value": "正定县",
      "label": "正定县"
    }, {
      "value": "栾城县",
      "label": "栾城县"
    }, {
      "value": "行唐县",
      "label": "行唐县"
    }, {
      "value": "灵寿县",
      "label": "灵寿县"
    }, {
      "value": "高邑县",
      "label": "高邑县"
    }, {
      "value": "深泽县",
      "label": "深泽县"
    }, {
      "value": "赞皇县",
      "label": "赞皇县"
    }, {
      "value": "无极县",
      "label": "无极县"
    }, {
      "value": "平山县",
      "label": "平山县"
    }, {
      "value": "元氏县",
      "label": "元氏县"
    }, {
      "value": "赵  县",
      "label": "赵  县"
    }, {
      "value": "辛集市",
      "label": "辛集市"
    }, {
      "value": "藁",
      "label": "藁"
    }, {
      "value": "晋州市",
      "label": "晋州市"
    }, {
      "value": "新乐市",
      "label": "新乐市"
    }, {
      "value": "鹿泉市",
      "label": "鹿泉市"
    }],
    "label": "石家庄市"
  }, {
    "value": "唐山市",
    "area": ["路南区", "路北区", "古冶区", "开平区", "新  区", "丰润县", "滦  县", "滦南县", "乐亭县", "迁西县", "玉田县", "唐海县", "遵化市", "丰南市", "迁安市"],
    "children": [{
      "value": "路南区",
      "label": "路南区"
    }, {
      "value": "路北区",
      "label": "路北区"
    }, {
      "value": "古冶区",
      "label": "古冶区"
    }, {
      "value": "开平区",
      "label": "开平区"
    }, {
      "value": "新  区",
      "label": "新  区"
    }, {
      "value": "丰润县",
      "label": "丰润县"
    }, {
      "value": "滦  县",
      "label": "滦  县"
    }, {
      "value": "滦南县",
      "label": "滦南县"
    }, {
      "value": "乐亭县",
      "label": "乐亭县"
    }, {
      "value": "迁西县",
      "label": "迁西县"
    }, {
      "value": "玉田县",
      "label": "玉田县"
    }, {
      "value": "唐海县",
      "label": "唐海县"
    }, {
      "value": "遵化市",
      "label": "遵化市"
    }, {
      "value": "丰南市",
      "label": "丰南市"
    }, {
      "value": "迁安市",
      "label": "迁安市"
    }],
    "label": "唐山市"
  }, {
    "value": "秦皇岛市",
    "area": ["海港区", "山海关区", "北戴河区", "青龙满族自治县", "昌黎县", "抚宁县", "卢龙县"],
    "children": [{
      "value": "海港区",
      "label": "海港区"
    }, {
      "value": "山海关区",
      "label": "山海关区"
    }, {
      "value": "北戴河区",
      "label": "北戴河区"
    }, {
      "value": "青龙满族自治县",
      "label": "青龙满族自治县"
    }, {
      "value": "昌黎县",
      "label": "昌黎县"
    }, {
      "value": "抚宁县",
      "label": "抚宁县"
    }, {
      "value": "卢龙县",
      "label": "卢龙县"
    }],
    "label": "秦皇岛市"
  }, {
    "value": "邯郸市",
    "area": ["邯山区", "丛台区", "复兴区", "峰峰矿区", "邯郸县", "临漳县", "成安县", "大名县", "涉  县", "磁  县", "肥乡县", "永年县", "邱  县", "鸡泽县", "广平县", "馆陶县", "魏  县", "曲周县", "武安市"],
    "children": [{
      "value": "邯山区",
      "label": "邯山区"
    }, {
      "value": "丛台区",
      "label": "丛台区"
    }, {
      "value": "复兴区",
      "label": "复兴区"
    }, {
      "value": "峰峰矿区",
      "label": "峰峰矿区"
    }, {
      "value": "邯郸县",
      "label": "邯郸县"
    }, {
      "value": "临漳县",
      "label": "临漳县"
    }, {
      "value": "成安县",
      "label": "成安县"
    }, {
      "value": "大名县",
      "label": "大名县"
    }, {
      "value": "涉  县",
      "label": "涉  县"
    }, {
      "value": "磁  县",
      "label": "磁  县"
    }, {
      "value": "肥乡县",
      "label": "肥乡县"
    }, {
      "value": "永年县",
      "label": "永年县"
    }, {
      "value": "邱  县",
      "label": "邱  县"
    }, {
      "value": "鸡泽县",
      "label": "鸡泽县"
    }, {
      "value": "广平县",
      "label": "广平县"
    }, {
      "value": "馆陶县",
      "label": "馆陶县"
    }, {
      "value": "魏  县",
      "label": "魏  县"
    }, {
      "value": "曲周县",
      "label": "曲周县"
    }, {
      "value": "武安市",
      "label": "武安市"
    }],
    "label": "邯郸市"
  }, {
    "value": "邢台市",
    "area": ["桥东区", "桥西区", "邢台县", "临城县", "内丘县", "柏乡县", "隆尧县", "任  县", "南和县", "宁晋县", "巨鹿县", "新河县", "广宗县", "平乡县", "威  县", "清河县", "临西县", "南宫市", "沙河市"],
    "children": [{
      "value": "桥东区",
      "label": "桥东区"
    }, {
      "value": "桥西区",
      "label": "桥西区"
    }, {
      "value": "邢台县",
      "label": "邢台县"
    }, {
      "value": "临城县",
      "label": "临城县"
    }, {
      "value": "内丘县",
      "label": "内丘县"
    }, {
      "value": "柏乡县",
      "label": "柏乡县"
    }, {
      "value": "隆尧县",
      "label": "隆尧县"
    }, {
      "value": "任  县",
      "label": "任  县"
    }, {
      "value": "南和县",
      "label": "南和县"
    }, {
      "value": "宁晋县",
      "label": "宁晋县"
    }, {
      "value": "巨鹿县",
      "label": "巨鹿县"
    }, {
      "value": "新河县",
      "label": "新河县"
    }, {
      "value": "广宗县",
      "label": "广宗县"
    }, {
      "value": "平乡县",
      "label": "平乡县"
    }, {
      "value": "威  县",
      "label": "威  县"
    }, {
      "value": "清河县",
      "label": "清河县"
    }, {
      "value": "临西县",
      "label": "临西县"
    }, {
      "value": "南宫市",
      "label": "南宫市"
    }, {
      "value": "沙河市",
      "label": "沙河市"
    }],
    "label": "邢台市"
  }, {
    "value": "保定市",
    "area": ["新市区", "北市区", "南市区", "满城县", "清苑县", "涞水县", "阜平县", "徐水县", "定兴县", "唐  县", "高阳县", "容城县", "涞源县", "望都县", "安新县", "易  县", "曲阳县", "蠡  县", "顺平县", "博野", "雄县", "涿州市", "定州市", "安国市", "高碑店市"],
    "children": [{
      "value": "新市区",
      "label": "新市区"
    }, {
      "value": "北市区",
      "label": "北市区"
    }, {
      "value": "南市区",
      "label": "南市区"
    }, {
      "value": "满城县",
      "label": "满城县"
    }, {
      "value": "清苑县",
      "label": "清苑县"
    }, {
      "value": "涞水县",
      "label": "涞水县"
    }, {
      "value": "阜平县",
      "label": "阜平县"
    }, {
      "value": "徐水县",
      "label": "徐水县"
    }, {
      "value": "定兴县",
      "label": "定兴县"
    }, {
      "value": "唐  县",
      "label": "唐  县"
    }, {
      "value": "高阳县",
      "label": "高阳县"
    }, {
      "value": "容城县",
      "label": "容城县"
    }, {
      "value": "涞源县",
      "label": "涞源县"
    }, {
      "value": "望都县",
      "label": "望都县"
    }, {
      "value": "安新县",
      "label": "安新县"
    }, {
      "value": "易  县",
      "label": "易  县"
    }, {
      "value": "曲阳县",
      "label": "曲阳县"
    }, {
      "value": "蠡  县",
      "label": "蠡  县"
    }, {
      "value": "顺平县",
      "label": "顺平县"
    }, {
      "value": "博野",
      "label": "博野"
    }, {
      "value": "雄县",
      "label": "雄县"
    }, {
      "value": "涿州市",
      "label": "涿州市"
    }, {
      "value": "定州市",
      "label": "定州市"
    }, {
      "value": "安国市",
      "label": "安国市"
    }, {
      "value": "高碑店市",
      "label": "高碑店市"
    }],
    "label": "保定市"
  }, {
    "value": "张家口",
    "area": ["桥东区", "桥西区", "宣化区", "下花园区", "宣化县", "张北县", "康保县", "沽源县", "尚义县", "蔚  县", "阳原县", "怀安县", "万全县", "怀来县", "涿鹿县", "赤城县", "崇礼县"],
    "children": [{
      "value": "桥东区",
      "label": "桥东区"
    }, {
      "value": "桥西区",
      "label": "桥西区"
    }, {
      "value": "宣化区",
      "label": "宣化区"
    }, {
      "value": "下花园区",
      "label": "下花园区"
    }, {
      "value": "宣化县",
      "label": "宣化县"
    }, {
      "value": "张北县",
      "label": "张北县"
    }, {
      "value": "康保县",
      "label": "康保县"
    }, {
      "value": "沽源县",
      "label": "沽源县"
    }, {
      "value": "尚义县",
      "label": "尚义县"
    }, {
      "value": "蔚  县",
      "label": "蔚  县"
    }, {
      "value": "阳原县",
      "label": "阳原县"
    }, {
      "value": "怀安县",
      "label": "怀安县"
    }, {
      "value": "万全县",
      "label": "万全县"
    }, {
      "value": "怀来县",
      "label": "怀来县"
    }, {
      "value": "涿鹿县",
      "label": "涿鹿县"
    }, {
      "value": "赤城县",
      "label": "赤城县"
    }, {
      "value": "崇礼县",
      "label": "崇礼县"
    }],
    "label": "张家口"
  }, {
    "value": "承德市",
    "area": ["双桥区", "双滦区", "鹰手营子矿区", "承德县", "兴隆县", "平泉县", "滦平县", "隆化县", "丰宁满族自治县", "宽城满族自治县", "围场满族蒙古族自治县"],
    "children": [{
      "value": "双桥区",
      "label": "双桥区"
    }, {
      "value": "双滦区",
      "label": "双滦区"
    }, {
      "value": "鹰手营子矿区",
      "label": "鹰手营子矿区"
    }, {
      "value": "承德县",
      "label": "承德县"
    }, {
      "value": "兴隆县",
      "label": "兴隆县"
    }, {
      "value": "平泉县",
      "label": "平泉县"
    }, {
      "value": "滦平县",
      "label": "滦平县"
    }, {
      "value": "隆化县",
      "label": "隆化县"
    }, {
      "value": "丰宁满族自治县",
      "label": "丰宁满族自治县"
    }, {
      "value": "宽城满族自治县",
      "label": "宽城满族自治县"
    }, {
      "value": "围场满族蒙古族自治县",
      "label": "围场满族蒙古族自治县"
    }],
    "label": "承德市"
  }, {
    "value": "沧州市",
    "area": ["新华区", "运河区", "沧  县", "青  县", "东光县", "海兴县", "盐山县", "肃宁县", "南皮县", "吴桥县", "献  县", "孟村回族自治县", "泊头市", "任丘市", "黄骅市", "河间市"],
    "children": [{
      "value": "新华区",
      "label": "新华区"
    }, {
      "value": "运河区",
      "label": "运河区"
    }, {
      "value": "沧  县",
      "label": "沧  县"
    }, {
      "value": "青  县",
      "label": "青  县"
    }, {
      "value": "东光县",
      "label": "东光县"
    }, {
      "value": "海兴县",
      "label": "海兴县"
    }, {
      "value": "盐山县",
      "label": "盐山县"
    }, {
      "value": "肃宁县",
      "label": "肃宁县"
    }, {
      "value": "南皮县",
      "label": "南皮县"
    }, {
      "value": "吴桥县",
      "label": "吴桥县"
    }, {
      "value": "献  县",
      "label": "献  县"
    }, {
      "value": "孟村回族自治县",
      "label": "孟村回族自治县"
    }, {
      "value": "泊头市",
      "label": "泊头市"
    }, {
      "value": "任丘市",
      "label": "任丘市"
    }, {
      "value": "黄骅市",
      "label": "黄骅市"
    }, {
      "value": "河间市",
      "label": "河间市"
    }],
    "label": "沧州市"
  }, {
    "value": "廊坊市",
    "area": ["安次区", "固安县", "永清县", "香河县", "大城县", "文安县", "大厂回族自治县", "霸州市", "三河市"],
    "children": [{
      "value": "安次区",
      "label": "安次区"
    }, {
      "value": "固安县",
      "label": "固安县"
    }, {
      "value": "永清县",
      "label": "永清县"
    }, {
      "value": "香河县",
      "label": "香河县"
    }, {
      "value": "大城县",
      "label": "大城县"
    }, {
      "value": "文安县",
      "label": "文安县"
    }, {
      "value": "大厂回族自治县",
      "label": "大厂回族自治县"
    }, {
      "value": "霸州市",
      "label": "霸州市"
    }, {
      "value": "三河市",
      "label": "三河市"
    }],
    "label": "廊坊市"
  }, {
    "value": "衡水市",
    "area": ["桃城区", "枣强县", "武邑县", "武强县", "饶阳县", "安平县", "故城县", "景  县", "阜城县", "冀州市", "深州市"],
    "children": [{
      "value": "桃城区",
      "label": "桃城区"
    }, {
      "value": "枣强县",
      "label": "枣强县"
    }, {
      "value": "武邑县",
      "label": "武邑县"
    }, {
      "value": "武强县",
      "label": "武强县"
    }, {
      "value": "饶阳县",
      "label": "饶阳县"
    }, {
      "value": "安平县",
      "label": "安平县"
    }, {
      "value": "故城县",
      "label": "故城县"
    }, {
      "value": "景  县",
      "label": "景  县"
    }, {
      "value": "阜城县",
      "label": "阜城县"
    }, {
      "value": "冀州市",
      "label": "冀州市"
    }, {
      "value": "深州市",
      "label": "深州市"
    }],
    "label": "衡水市"
  }],
  "label": "河北省"
}, {
  "value": "山西省",
  "children": [{
    "value": "太原市",
    "area": ["小店区", "迎泽区", "杏花岭区", "尖草坪区", "万柏林区", "晋源区", "清徐县", "阳曲县", "娄烦县", "古交市"],
    "children": [{
      "value": "小店区",
      "label": "小店区"
    }, {
      "value": "迎泽区",
      "label": "迎泽区"
    }, {
      "value": "杏花岭区",
      "label": "杏花岭区"
    }, {
      "value": "尖草坪区",
      "label": "尖草坪区"
    }, {
      "value": "万柏林区",
      "label": "万柏林区"
    }, {
      "value": "晋源区",
      "label": "晋源区"
    }, {
      "value": "清徐县",
      "label": "清徐县"
    }, {
      "value": "阳曲县",
      "label": "阳曲县"
    }, {
      "value": "娄烦县",
      "label": "娄烦县"
    }, {
      "value": "古交市",
      "label": "古交市"
    }],
    "label": "太原市"
  }, {
    "value": "大同市",
    "area": ["城  区", "矿  区", "南郊区", "新荣区", "阳高县", "天镇县", "广灵县", "灵丘县", "浑源县", "左云县", "大同县"],
    "children": [{
      "value": "城  区",
      "label": "城  区"
    }, {
      "value": "矿  区",
      "label": "矿  区"
    }, {
      "value": "南郊区",
      "label": "南郊区"
    }, {
      "value": "新荣区",
      "label": "新荣区"
    }, {
      "value": "阳高县",
      "label": "阳高县"
    }, {
      "value": "天镇县",
      "label": "天镇县"
    }, {
      "value": "广灵县",
      "label": "广灵县"
    }, {
      "value": "灵丘县",
      "label": "灵丘县"
    }, {
      "value": "浑源县",
      "label": "浑源县"
    }, {
      "value": "左云县",
      "label": "左云县"
    }, {
      "value": "大同县",
      "label": "大同县"
    }],
    "label": "大同市"
  }, {
    "value": "阳泉市",
    "area": ["城  区", "矿  区", "郊  区", "平定县", "盂  县"],
    "children": [{
      "value": "城  区",
      "label": "城  区"
    }, {
      "value": "矿  区",
      "label": "矿  区"
    }, {
      "value": "郊  区",
      "label": "郊  区"
    }, {
      "value": "平定县",
      "label": "平定县"
    }, {
      "value": "盂  县",
      "label": "盂  县"
    }],
    "label": "阳泉市"
  }, {
    "value": "长治市",
    "area": ["城  区", "郊  区", "长治县", "襄垣县", "屯留县", "平顺县", "黎城县", "壶关县", "长子县", "武乡县", "沁  县", "沁源县", "潞城市"],
    "children": [{
      "value": "城  区",
      "label": "城  区"
    }, {
      "value": "郊  区",
      "label": "郊  区"
    }, {
      "value": "长治县",
      "label": "长治县"
    }, {
      "value": "襄垣县",
      "label": "襄垣县"
    }, {
      "value": "屯留县",
      "label": "屯留县"
    }, {
      "value": "平顺县",
      "label": "平顺县"
    }, {
      "value": "黎城县",
      "label": "黎城县"
    }, {
      "value": "壶关县",
      "label": "壶关县"
    }, {
      "value": "长子县",
      "label": "长子县"
    }, {
      "value": "武乡县",
      "label": "武乡县"
    }, {
      "value": "沁  县",
      "label": "沁  县"
    }, {
      "value": "沁源县",
      "label": "沁源县"
    }, {
      "value": "潞城市",
      "label": "潞城市"
    }],
    "label": "长治市"
  }, {
    "value": "晋城市",
    "area": ["城  区", "沁水县", "阳城县", "陵川县", "泽州县", "高平市"],
    "children": [{
      "value": "城  区",
      "label": "城  区"
    }, {
      "value": "沁水县",
      "label": "沁水县"
    }, {
      "value": "阳城县",
      "label": "阳城县"
    }, {
      "value": "陵川县",
      "label": "陵川县"
    }, {
      "value": "泽州县",
      "label": "泽州县"
    }, {
      "value": "高平市",
      "label": "高平市"
    }],
    "label": "晋城市"
  }, {
    "value": "朔州市",
    "area": ["朔城区", "平鲁区", "山阴县", "应  县", "右玉县", "怀仁县"],
    "children": [{
      "value": "朔城区",
      "label": "朔城区"
    }, {
      "value": "平鲁区",
      "label": "平鲁区"
    }, {
      "value": "山阴县",
      "label": "山阴县"
    }, {
      "value": "应  县",
      "label": "应  县"
    }, {
      "value": "右玉县",
      "label": "右玉县"
    }, {
      "value": "怀仁县",
      "label": "怀仁县"
    }],
    "label": "朔州市"
  }, {
    "value": "忻州市",
    "area": ["忻府区", "原平市", "定襄县", "五台县", "代  县", "繁峙县", "宁武县", "静乐县", "神池县", "五寨县", "岢岚县", "河曲县", "保德县", "偏关县"],
    "children": [{
      "value": "忻府区",
      "label": "忻府区"
    }, {
      "value": "原平市",
      "label": "原平市"
    }, {
      "value": "定襄县",
      "label": "定襄县"
    }, {
      "value": "五台县",
      "label": "五台县"
    }, {
      "value": "代  县",
      "label": "代  县"
    }, {
      "value": "繁峙县",
      "label": "繁峙县"
    }, {
      "value": "宁武县",
      "label": "宁武县"
    }, {
      "value": "静乐县",
      "label": "静乐县"
    }, {
      "value": "神池县",
      "label": "神池县"
    }, {
      "value": "五寨县",
      "label": "五寨县"
    }, {
      "value": "岢岚县",
      "label": "岢岚县"
    }, {
      "value": "河曲县",
      "label": "河曲县"
    }, {
      "value": "保德县",
      "label": "保德县"
    }, {
      "value": "偏关县",
      "label": "偏关县"
    }],
    "label": "忻州市"
  }, {
    "value": "吕梁市",
    "area": ["离石区", "孝义市", "汾阳市", "文水县", "交城县", "兴  县", "临  县", "柳林县", "石楼县", "岚  县", "方山县", "中阳县", "交口县"],
    "children": [{
      "value": "离石区",
      "label": "离石区"
    }, {
      "value": "孝义市",
      "label": "孝义市"
    }, {
      "value": "汾阳市",
      "label": "汾阳市"
    }, {
      "value": "文水县",
      "label": "文水县"
    }, {
      "value": "交城县",
      "label": "交城县"
    }, {
      "value": "兴  县",
      "label": "兴  县"
    }, {
      "value": "临  县",
      "label": "临  县"
    }, {
      "value": "柳林县",
      "label": "柳林县"
    }, {
      "value": "石楼县",
      "label": "石楼县"
    }, {
      "value": "岚  县",
      "label": "岚  县"
    }, {
      "value": "方山县",
      "label": "方山县"
    }, {
      "value": "中阳县",
      "label": "中阳县"
    }, {
      "value": "交口县",
      "label": "交口县"
    }],
    "label": "吕梁市"
  }, {
    "value": "晋中市",
    "area": ["榆次市", "介休市", "榆社县", "左权县", "和顺县", "昔阳县", "寿阳县", "太谷县", "祁  县", "平遥县", "灵石县"],
    "children": [{
      "value": "榆次市",
      "label": "榆次市"
    }, {
      "value": "介休市",
      "label": "介休市"
    }, {
      "value": "榆社县",
      "label": "榆社县"
    }, {
      "value": "左权县",
      "label": "左权县"
    }, {
      "value": "和顺县",
      "label": "和顺县"
    }, {
      "value": "昔阳县",
      "label": "昔阳县"
    }, {
      "value": "寿阳县",
      "label": "寿阳县"
    }, {
      "value": "太谷县",
      "label": "太谷县"
    }, {
      "value": "祁  县",
      "label": "祁  县"
    }, {
      "value": "平遥县",
      "label": "平遥县"
    }, {
      "value": "灵石县",
      "label": "灵石县"
    }],
    "label": "晋中市"
  }, {
    "value": "临汾市",
    "area": ["临汾市", "侯马市", "霍州市", "曲沃县", "翼城县", "襄汾县", "洪洞县", "古  县", "安泽县", "浮山县", "吉  县", "乡宁县", "蒲  县", "大宁县", "永和县", "隰  县", "汾西县"],
    "children": [{
      "value": "临汾市",
      "label": "临汾市"
    }, {
      "value": "侯马市",
      "label": "侯马市"
    }, {
      "value": "霍州市",
      "label": "霍州市"
    }, {
      "value": "曲沃县",
      "label": "曲沃县"
    }, {
      "value": "翼城县",
      "label": "翼城县"
    }, {
      "value": "襄汾县",
      "label": "襄汾县"
    }, {
      "value": "洪洞县",
      "label": "洪洞县"
    }, {
      "value": "古  县",
      "label": "古  县"
    }, {
      "value": "安泽县",
      "label": "安泽县"
    }, {
      "value": "浮山县",
      "label": "浮山县"
    }, {
      "value": "吉  县",
      "label": "吉  县"
    }, {
      "value": "乡宁县",
      "label": "乡宁县"
    }, {
      "value": "蒲  县",
      "label": "蒲  县"
    }, {
      "value": "大宁县",
      "label": "大宁县"
    }, {
      "value": "永和县",
      "label": "永和县"
    }, {
      "value": "隰  县",
      "label": "隰  县"
    }, {
      "value": "汾西县",
      "label": "汾西县"
    }],
    "label": "临汾市"
  }, {
    "value": "运城市",
    "area": ["运城市", "永济市", "河津市", "芮城县", "临猗县", "万荣县", "新绛县", "稷山县", "闻喜县", "夏  县", "绛  县", "平陆县", "垣曲县"],
    "children": [{
      "value": "运城市",
      "label": "运城市"
    }, {
      "value": "永济市",
      "label": "永济市"
    }, {
      "value": "河津市",
      "label": "河津市"
    }, {
      "value": "芮城县",
      "label": "芮城县"
    }, {
      "value": "临猗县",
      "label": "临猗县"
    }, {
      "value": "万荣县",
      "label": "万荣县"
    }, {
      "value": "新绛县",
      "label": "新绛县"
    }, {
      "value": "稷山县",
      "label": "稷山县"
    }, {
      "value": "闻喜县",
      "label": "闻喜县"
    }, {
      "value": "夏  县",
      "label": "夏  县"
    }, {
      "value": "绛  县",
      "label": "绛  县"
    }, {
      "value": "平陆县",
      "label": "平陆县"
    }, {
      "value": "垣曲县",
      "label": "垣曲县"
    }],
    "label": "运城市"
  }],
  "label": "山西省"
}, {
  "value": "内蒙古",
  "children": [{
    "value": "呼和浩特市",
    "area": ["新城区", "回民区", "玉泉区", "郊  区", "土默特左旗", "托克托县", "和林格尔县", "清水河县", "武川县"],
    "children": [{
      "value": "新城区",
      "label": "新城区"
    }, {
      "value": "回民区",
      "label": "回民区"
    }, {
      "value": "玉泉区",
      "label": "玉泉区"
    }, {
      "value": "郊  区",
      "label": "郊  区"
    }, {
      "value": "土默特左旗",
      "label": "土默特左旗"
    }, {
      "value": "托克托县",
      "label": "托克托县"
    }, {
      "value": "和林格尔县",
      "label": "和林格尔县"
    }, {
      "value": "清水河县",
      "label": "清水河县"
    }, {
      "value": "武川县",
      "label": "武川县"
    }],
    "label": "呼和浩特市"
  }, {
    "value": "包头市",
    "area": ["东河区", "昆都伦区", "青山区", "石拐矿区", "白云矿区", "郊  区", "土默特右旗", "固阳县", "达尔罕茂明安联合旗"],
    "children": [{
      "value": "东河区",
      "label": "东河区"
    }, {
      "value": "昆都伦区",
      "label": "昆都伦区"
    }, {
      "value": "青山区",
      "label": "青山区"
    }, {
      "value": "石拐矿区",
      "label": "石拐矿区"
    }, {
      "value": "白云矿区",
      "label": "白云矿区"
    }, {
      "value": "郊  区",
      "label": "郊  区"
    }, {
      "value": "土默特右旗",
      "label": "土默特右旗"
    }, {
      "value": "固阳县",
      "label": "固阳县"
    }, {
      "value": "达尔罕茂明安联合旗",
      "label": "达尔罕茂明安联合旗"
    }],
    "label": "包头市"
  }, {
    "value": "乌海市",
    "area": ["海勃湾区", "海南区", "乌达区"],
    "children": [{
      "value": "海勃湾区",
      "label": "海勃湾区"
    }, {
      "value": "海南区",
      "label": "海南区"
    }, {
      "value": "乌达区",
      "label": "乌达区"
    }],
    "label": "乌海市"
  }, {
    "value": "赤峰市",
    "area": ["红山区", "元宝山区", "松山区", "阿鲁科尔沁旗", "巴林左旗", "巴林右旗", "林西县", "克什克腾旗", "翁牛特旗", "喀喇沁旗", "宁城县", "敖汉旗"],
    "children": [{
      "value": "红山区",
      "label": "红山区"
    }, {
      "value": "元宝山区",
      "label": "元宝山区"
    }, {
      "value": "松山区",
      "label": "松山区"
    }, {
      "value": "阿鲁科尔沁旗",
      "label": "阿鲁科尔沁旗"
    }, {
      "value": "巴林左旗",
      "label": "巴林左旗"
    }, {
      "value": "巴林右旗",
      "label": "巴林右旗"
    }, {
      "value": "林西县",
      "label": "林西县"
    }, {
      "value": "克什克腾旗",
      "label": "克什克腾旗"
    }, {
      "value": "翁牛特旗",
      "label": "翁牛特旗"
    }, {
      "value": "喀喇沁旗",
      "label": "喀喇沁旗"
    }, {
      "value": "宁城县",
      "label": "宁城县"
    }, {
      "value": "敖汉旗",
      "label": "敖汉旗"
    }],
    "label": "赤峰市"
  }, {
    "value": "呼伦贝尔市",
    "area": ["海拉尔市", "满洲里市", "扎兰屯市", "牙克石市", "根河市", "额尔古纳市", "阿荣旗", "莫力达瓦达斡尔族自治旗", "鄂伦春自治旗", "鄂温克族自治旗", "新巴尔虎右旗", "新巴尔虎左旗", "陈巴尔虎旗"],
    "children": [{
      "value": "海拉尔市",
      "label": "海拉尔市"
    }, {
      "value": "满洲里市",
      "label": "满洲里市"
    }, {
      "value": "扎兰屯市",
      "label": "扎兰屯市"
    }, {
      "value": "牙克石市",
      "label": "牙克石市"
    }, {
      "value": "根河市",
      "label": "根河市"
    }, {
      "value": "额尔古纳市",
      "label": "额尔古纳市"
    }, {
      "value": "阿荣旗",
      "label": "阿荣旗"
    }, {
      "value": "莫力达瓦达斡尔族自治旗",
      "label": "莫力达瓦达斡尔族自治旗"
    }, {
      "value": "鄂伦春自治旗",
      "label": "鄂伦春自治旗"
    }, {
      "value": "鄂温克族自治旗",
      "label": "鄂温克族自治旗"
    }, {
      "value": "新巴尔虎右旗",
      "label": "新巴尔虎右旗"
    }, {
      "value": "新巴尔虎左旗",
      "label": "新巴尔虎左旗"
    }, {
      "value": "陈巴尔虎旗",
      "label": "陈巴尔虎旗"
    }],
    "label": "呼伦贝尔市"
  }, {
    "value": "兴安盟",
    "area": ["乌兰浩特市", "阿尔山市", "科尔沁右翼前旗", "科尔沁右翼中旗", "扎赉特旗", "突泉县"],
    "children": [{
      "value": "乌兰浩特市",
      "label": "乌兰浩特市"
    }, {
      "value": "阿尔山市",
      "label": "阿尔山市"
    }, {
      "value": "科尔沁右翼前旗",
      "label": "科尔沁右翼前旗"
    }, {
      "value": "科尔沁右翼中旗",
      "label": "科尔沁右翼中旗"
    }, {
      "value": "扎赉特旗",
      "label": "扎赉特旗"
    }, {
      "value": "突泉县",
      "label": "突泉县"
    }],
    "label": "兴安盟"
  }, {
    "value": "通辽市",
    "area": ["科尔沁区", "霍林郭勒市", "科尔沁左翼中旗", "科尔沁左翼后旗", "开鲁县", "库伦旗", "奈曼旗", "扎鲁特旗"],
    "children": [{
      "value": "科尔沁区",
      "label": "科尔沁区"
    }, {
      "value": "霍林郭勒市",
      "label": "霍林郭勒市"
    }, {
      "value": "科尔沁左翼中旗",
      "label": "科尔沁左翼中旗"
    }, {
      "value": "科尔沁左翼后旗",
      "label": "科尔沁左翼后旗"
    }, {
      "value": "开鲁县",
      "label": "开鲁县"
    }, {
      "value": "库伦旗",
      "label": "库伦旗"
    }, {
      "value": "奈曼旗",
      "label": "奈曼旗"
    }, {
      "value": "扎鲁特旗",
      "label": "扎鲁特旗"
    }],
    "label": "通辽市"
  }, {
    "value": "锡林郭勒盟",
    "area": ["二连浩特市", "锡林浩特市", "阿巴嘎旗", "苏尼特左旗", "苏尼特右旗", "东乌珠穆沁旗", "西乌珠穆沁旗", "太仆寺旗", "镶黄旗", "正镶白旗", "正蓝旗", "多伦县"],
    "children": [{
      "value": "二连浩特市",
      "label": "二连浩特市"
    }, {
      "value": "锡林浩特市",
      "label": "锡林浩特市"
    }, {
      "value": "阿巴嘎旗",
      "label": "阿巴嘎旗"
    }, {
      "value": "苏尼特左旗",
      "label": "苏尼特左旗"
    }, {
      "value": "苏尼特右旗",
      "label": "苏尼特右旗"
    }, {
      "value": "东乌珠穆沁旗",
      "label": "东乌珠穆沁旗"
    }, {
      "value": "西乌珠穆沁旗",
      "label": "西乌珠穆沁旗"
    }, {
      "value": "太仆寺旗",
      "label": "太仆寺旗"
    }, {
      "value": "镶黄旗",
      "label": "镶黄旗"
    }, {
      "value": "正镶白旗",
      "label": "正镶白旗"
    }, {
      "value": "正蓝旗",
      "label": "正蓝旗"
    }, {
      "value": "多伦县",
      "label": "多伦县"
    }],
    "label": "锡林郭勒盟"
  }, {
    "value": "乌兰察布盟",
    "area": ["集宁市", "丰镇市", "卓资县", "化德县", "商都县", "兴和县", "凉城县", "察哈尔右翼前旗", "察哈尔右翼中旗", "察哈尔右翼后旗", "四子王旗"],
    "children": [{
      "value": "集宁市",
      "label": "集宁市"
    }, {
      "value": "丰镇市",
      "label": "丰镇市"
    }, {
      "value": "卓资县",
      "label": "卓资县"
    }, {
      "value": "化德县",
      "label": "化德县"
    }, {
      "value": "商都县",
      "label": "商都县"
    }, {
      "value": "兴和县",
      "label": "兴和县"
    }, {
      "value": "凉城县",
      "label": "凉城县"
    }, {
      "value": "察哈尔右翼前旗",
      "label": "察哈尔右翼前旗"
    }, {
      "value": "察哈尔右翼中旗",
      "label": "察哈尔右翼中旗"
    }, {
      "value": "察哈尔右翼后旗",
      "label": "察哈尔右翼后旗"
    }, {
      "value": "四子王旗",
      "label": "四子王旗"
    }],
    "label": "乌兰察布盟"
  }, {
    "value": "伊克昭盟",
    "area": ["东胜市", "达拉特旗", "准格尔旗", "鄂托克前旗", "鄂托克旗", "杭锦旗", "乌审旗", "伊金霍洛旗"],
    "children": [{
      "value": "东胜市",
      "label": "东胜市"
    }, {
      "value": "达拉特旗",
      "label": "达拉特旗"
    }, {
      "value": "准格尔旗",
      "label": "准格尔旗"
    }, {
      "value": "鄂托克前旗",
      "label": "鄂托克前旗"
    }, {
      "value": "鄂托克旗",
      "label": "鄂托克旗"
    }, {
      "value": "杭锦旗",
      "label": "杭锦旗"
    }, {
      "value": "乌审旗",
      "label": "乌审旗"
    }, {
      "value": "伊金霍洛旗",
      "label": "伊金霍洛旗"
    }],
    "label": "伊克昭盟"
  }, {
    "value": "巴彦淖尔盟",
    "area": ["临河市", "五原县", "磴口县", "乌拉特前旗", "乌拉特中旗", "乌拉特后旗", "杭锦后旗"],
    "children": [{
      "value": "临河市",
      "label": "临河市"
    }, {
      "value": "五原县",
      "label": "五原县"
    }, {
      "value": "磴口县",
      "label": "磴口县"
    }, {
      "value": "乌拉特前旗",
      "label": "乌拉特前旗"
    }, {
      "value": "乌拉特中旗",
      "label": "乌拉特中旗"
    }, {
      "value": "乌拉特后旗",
      "label": "乌拉特后旗"
    }, {
      "value": "杭锦后旗",
      "label": "杭锦后旗"
    }],
    "label": "巴彦淖尔盟"
  }, {
    "value": "阿拉善盟",
    "area": ["阿拉善左旗", "阿拉善右旗", "额济纳旗"],
    "children": [{
      "value": "阿拉善左旗",
      "label": "阿拉善左旗"
    }, {
      "value": "阿拉善右旗",
      "label": "阿拉善右旗"
    }, {
      "value": "额济纳旗",
      "label": "额济纳旗"
    }],
    "label": "阿拉善盟"
  }],
  "label": "内蒙古"
}, {
  "value": "辽宁省",
  "children": [{
    "value": "沈阳市",
    "area": ["沈河区", "皇姑区", "和平区", "大东区", "铁西区", "苏家屯区", "东陵区", "于洪区", "新民市", "法库县", "辽中县", "康平县", "新城子区", "其他"],
    "children": [{
      "value": "沈河区",
      "label": "沈河区"
    }, {
      "value": "皇姑区",
      "label": "皇姑区"
    }, {
      "value": "和平区",
      "label": "和平区"
    }, {
      "value": "大东区",
      "label": "大东区"
    }, {
      "value": "铁西区",
      "label": "铁西区"
    }, {
      "value": "苏家屯区",
      "label": "苏家屯区"
    }, {
      "value": "东陵区",
      "label": "东陵区"
    }, {
      "value": "于洪区",
      "label": "于洪区"
    }, {
      "value": "新民市",
      "label": "新民市"
    }, {
      "value": "法库县",
      "label": "法库县"
    }, {
      "value": "辽中县",
      "label": "辽中县"
    }, {
      "value": "康平县",
      "label": "康平县"
    }, {
      "value": "新城子区",
      "label": "新城子区"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "沈阳市"
  }, {
    "value": "大连市",
    "area": ["西岗区", "中山区", "沙河口区", "甘井子区", "旅顺口区", "金州区", "瓦房店市", "普兰店市", "庄河市", "长海县", "其他"],
    "children": [{
      "value": "西岗区",
      "label": "西岗区"
    }, {
      "value": "中山区",
      "label": "中山区"
    }, {
      "value": "沙河口区",
      "label": "沙河口区"
    }, {
      "value": "甘井子区",
      "label": "甘井子区"
    }, {
      "value": "旅顺口区",
      "label": "旅顺口区"
    }, {
      "value": "金州区",
      "label": "金州区"
    }, {
      "value": "瓦房店市",
      "label": "瓦房店市"
    }, {
      "value": "普兰店市",
      "label": "普兰店市"
    }, {
      "value": "庄河市",
      "label": "庄河市"
    }, {
      "value": "长海县",
      "label": "长海县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "大连市"
  }, {
    "value": "鞍山市",
    "area": ["铁东区", "铁西区", "立山区", "千山区", "海城市", "台安县", "岫岩满族自治县", "其他"],
    "children": [{
      "value": "铁东区",
      "label": "铁东区"
    }, {
      "value": "铁西区",
      "label": "铁西区"
    }, {
      "value": "立山区",
      "label": "立山区"
    }, {
      "value": "千山区",
      "label": "千山区"
    }, {
      "value": "海城市",
      "label": "海城市"
    }, {
      "value": "台安县",
      "label": "台安县"
    }, {
      "value": "岫岩满族自治县",
      "label": "岫岩满族自治县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "鞍山市"
  }, {
    "value": "抚顺市",
    "area": ["顺城区", "新抚区", "东洲区", "望花区", "抚顺县", "清原满族自治县", "新宾满族自治县", "其他"],
    "children": [{
      "value": "顺城区",
      "label": "顺城区"
    }, {
      "value": "新抚区",
      "label": "新抚区"
    }, {
      "value": "东洲区",
      "label": "东洲区"
    }, {
      "value": "望花区",
      "label": "望花区"
    }, {
      "value": "抚顺县",
      "label": "抚顺县"
    }, {
      "value": "清原满族自治县",
      "label": "清原满族自治县"
    }, {
      "value": "新宾满族自治县",
      "label": "新宾满族自治县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "抚顺市"
  }, {
    "value": "本溪市",
    "area": ["平山区", "明山区", "溪湖区", "南芬区", "本溪满族自治县", "桓仁满族自治县", "其他"],
    "children": [{
      "value": "平山区",
      "label": "平山区"
    }, {
      "value": "明山区",
      "label": "明山区"
    }, {
      "value": "溪湖区",
      "label": "溪湖区"
    }, {
      "value": "南芬区",
      "label": "南芬区"
    }, {
      "value": "本溪满族自治县",
      "label": "本溪满族自治县"
    }, {
      "value": "桓仁满族自治县",
      "label": "桓仁满族自治县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "本溪市"
  }, {
    "value": "丹东市",
    "area": ["振兴区", "元宝区", "振安区", "东港市", "凤城市", "宽甸满族自治县", "其他"],
    "children": [{
      "value": "振兴区",
      "label": "振兴区"
    }, {
      "value": "元宝区",
      "label": "元宝区"
    }, {
      "value": "振安区",
      "label": "振安区"
    }, {
      "value": "东港市",
      "label": "东港市"
    }, {
      "value": "凤城市",
      "label": "凤城市"
    }, {
      "value": "宽甸满族自治县",
      "label": "宽甸满族自治县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "丹东市"
  }, {
    "value": "锦州市",
    "area": ["太和区", "古塔区", "凌河区", "凌海市", "黑山县", "义县", "北宁市", "其他"],
    "children": [{
      "value": "太和区",
      "label": "太和区"
    }, {
      "value": "古塔区",
      "label": "古塔区"
    }, {
      "value": "凌河区",
      "label": "凌河区"
    }, {
      "value": "凌海市",
      "label": "凌海市"
    }, {
      "value": "黑山县",
      "label": "黑山县"
    }, {
      "value": "义县",
      "label": "义县"
    }, {
      "value": "北宁市",
      "label": "北宁市"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "锦州市"
  }, {
    "value": "营口市",
    "area": ["站前区", "西市区", "鲅鱼圈区", "老边区", "大石桥市", "盖州市", "其他"],
    "children": [{
      "value": "站前区",
      "label": "站前区"
    }, {
      "value": "西市区",
      "label": "西市区"
    }, {
      "value": "鲅鱼圈区",
      "label": "鲅鱼圈区"
    }, {
      "value": "老边区",
      "label": "老边区"
    }, {
      "value": "大石桥市",
      "label": "大石桥市"
    }, {
      "value": "盖州市",
      "label": "盖州市"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "营口市"
  }, {
    "value": "阜新市",
    "area": ["海州区", "新邱区", "太平区", "清河门区", "细河区", "彰武县", "阜新蒙古族自治县", "其他"],
    "children": [{
      "value": "海州区",
      "label": "海州区"
    }, {
      "value": "新邱区",
      "label": "新邱区"
    }, {
      "value": "太平区",
      "label": "太平区"
    }, {
      "value": "清河门区",
      "label": "清河门区"
    }, {
      "value": "细河区",
      "label": "细河区"
    }, {
      "value": "彰武县",
      "label": "彰武县"
    }, {
      "value": "阜新蒙古族自治县",
      "label": "阜新蒙古族自治县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "阜新市"
  }, {
    "value": "辽阳市",
    "area": ["白塔区", "文圣区", "宏伟区", "太子河区", "弓长岭区", "灯塔市", "辽阳县", "其他"],
    "children": [{
      "value": "白塔区",
      "label": "白塔区"
    }, {
      "value": "文圣区",
      "label": "文圣区"
    }, {
      "value": "宏伟区",
      "label": "宏伟区"
    }, {
      "value": "太子河区",
      "label": "太子河区"
    }, {
      "value": "弓长岭区",
      "label": "弓长岭区"
    }, {
      "value": "灯塔市",
      "label": "灯塔市"
    }, {
      "value": "辽阳县",
      "label": "辽阳县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "辽阳市"
  }, {
    "value": "盘锦",
    "area": ["双台子区", "兴隆台区", "盘山县", "大洼县", "其他"],
    "children": [{
      "value": "双台子区",
      "label": "双台子区"
    }, {
      "value": "兴隆台区",
      "label": "兴隆台区"
    }, {
      "value": "盘山县",
      "label": "盘山县"
    }, {
      "value": "大洼县",
      "label": "大洼县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "盘锦"
  }, {
    "value": "铁岭市",
    "area": ["银州区", "清河区", "调兵山市", "开原市", "铁岭县", "昌图县", "西丰县", "其他"],
    "children": [{
      "value": "银州区",
      "label": "银州区"
    }, {
      "value": "清河区",
      "label": "清河区"
    }, {
      "value": "调兵山市",
      "label": "调兵山市"
    }, {
      "value": "开原市",
      "label": "开原市"
    }, {
      "value": "铁岭县",
      "label": "铁岭县"
    }, {
      "value": "昌图县",
      "label": "昌图县"
    }, {
      "value": "西丰县",
      "label": "西丰县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "铁岭市"
  }, {
    "value": "朝阳市",
    "area": ["双塔区", "龙城区", "凌源市", "北票市", "朝阳县", "建平县", "喀喇沁左翼蒙古族自治县", "其他"],
    "children": [{
      "value": "双塔区",
      "label": "双塔区"
    }, {
      "value": "龙城区",
      "label": "龙城区"
    }, {
      "value": "凌源市",
      "label": "凌源市"
    }, {
      "value": "北票市",
      "label": "北票市"
    }, {
      "value": "朝阳县",
      "label": "朝阳县"
    }, {
      "value": "建平县",
      "label": "建平县"
    }, {
      "value": "喀喇沁左翼蒙古族自治县",
      "label": "喀喇沁左翼蒙古族自治县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "朝阳市"
  }, {
    "value": "葫芦岛市",
    "area": ["龙港区", "南票区", "连山区", "兴城市", "绥中县", "建昌县", "其他"],
    "children": [{
      "value": "龙港区",
      "label": "龙港区"
    }, {
      "value": "南票区",
      "label": "南票区"
    }, {
      "value": "连山区",
      "label": "连山区"
    }, {
      "value": "兴城市",
      "label": "兴城市"
    }, {
      "value": "绥中县",
      "label": "绥中县"
    }, {
      "value": "建昌县",
      "label": "建昌县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "葫芦岛市"
  }, {
    "value": "其他",
    "area": ["其他"],
    "children": [{
      "value": "其他",
      "label": "其他"
    }],
    "label": "其他"
  }],
  "label": "辽宁省"
}, {
  "value": "吉林省",
  "children": [{
    "value": "长春市",
    "area": ["朝阳区", "宽城区", "二道区", "南关区", "绿园区", "双阳区", "九台市", "榆树市", "德惠市", "农安县", "其他"],
    "children": [{
      "value": "朝阳区",
      "label": "朝阳区"
    }, {
      "value": "宽城区",
      "label": "宽城区"
    }, {
      "value": "二道区",
      "label": "二道区"
    }, {
      "value": "南关区",
      "label": "南关区"
    }, {
      "value": "绿园区",
      "label": "绿园区"
    }, {
      "value": "双阳区",
      "label": "双阳区"
    }, {
      "value": "九台市",
      "label": "九台市"
    }, {
      "value": "榆树市",
      "label": "榆树市"
    }, {
      "value": "德惠市",
      "label": "德惠市"
    }, {
      "value": "农安县",
      "label": "农安县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "长春市"
  }, {
    "value": "吉林市",
    "area": ["船营区", "昌邑区", "龙潭区", "丰满区", "舒兰市", "桦甸市", "蛟河市", "磐石市", "永吉县", "其他"],
    "children": [{
      "value": "船营区",
      "label": "船营区"
    }, {
      "value": "昌邑区",
      "label": "昌邑区"
    }, {
      "value": "龙潭区",
      "label": "龙潭区"
    }, {
      "value": "丰满区",
      "label": "丰满区"
    }, {
      "value": "舒兰市",
      "label": "舒兰市"
    }, {
      "value": "桦甸市",
      "label": "桦甸市"
    }, {
      "value": "蛟河市",
      "label": "蛟河市"
    }, {
      "value": "磐石市",
      "label": "磐石市"
    }, {
      "value": "永吉县",
      "label": "永吉县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "吉林市"
  }, {
    "value": "四平",
    "area": ["铁西区", "铁东区", "公主岭市", "双辽市", "梨树县", "伊通满族自治县", "其他"],
    "children": [{
      "value": "铁西区",
      "label": "铁西区"
    }, {
      "value": "铁东区",
      "label": "铁东区"
    }, {
      "value": "公主岭市",
      "label": "公主岭市"
    }, {
      "value": "双辽市",
      "label": "双辽市"
    }, {
      "value": "梨树县",
      "label": "梨树县"
    }, {
      "value": "伊通满族自治县",
      "label": "伊通满族自治县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "四平"
  }, {
    "value": "辽源市",
    "area": ["龙山区", "西安区", "东辽县", "东丰县", "其他"],
    "children": [{
      "value": "龙山区",
      "label": "龙山区"
    }, {
      "value": "西安区",
      "label": "西安区"
    }, {
      "value": "东辽县",
      "label": "东辽县"
    }, {
      "value": "东丰县",
      "label": "东丰县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "辽源市"
  }, {
    "value": "通化市",
    "area": ["东昌区", "二道江区", "梅河口市", "集安市", "通化县", "辉南县", "柳河县", "其他"],
    "children": [{
      "value": "东昌区",
      "label": "东昌区"
    }, {
      "value": "二道江区",
      "label": "二道江区"
    }, {
      "value": "梅河口市",
      "label": "梅河口市"
    }, {
      "value": "集安市",
      "label": "集安市"
    }, {
      "value": "通化县",
      "label": "通化县"
    }, {
      "value": "辉南县",
      "label": "辉南县"
    }, {
      "value": "柳河县",
      "label": "柳河县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "通化市"
  }, {
    "value": "白山市",
    "area": ["八道江区", "江源区", "临江市", "靖宇县", "抚松县", "长白朝鲜族自治县", "其他"],
    "children": [{
      "value": "八道江区",
      "label": "八道江区"
    }, {
      "value": "江源区",
      "label": "江源区"
    }, {
      "value": "临江市",
      "label": "临江市"
    }, {
      "value": "靖宇县",
      "label": "靖宇县"
    }, {
      "value": "抚松县",
      "label": "抚松县"
    }, {
      "value": "长白朝鲜族自治县",
      "label": "长白朝鲜族自治县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "白山市"
  }, {
    "value": "松原市",
    "area": ["宁江区", "乾安县", "长岭县", "扶余县", "前郭尔罗斯蒙古族自治县", "其他"],
    "children": [{
      "value": "宁江区",
      "label": "宁江区"
    }, {
      "value": "乾安县",
      "label": "乾安县"
    }, {
      "value": "长岭县",
      "label": "长岭县"
    }, {
      "value": "扶余县",
      "label": "扶余县"
    }, {
      "value": "前郭尔罗斯蒙古族自治县",
      "label": "前郭尔罗斯蒙古族自治县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "松原市"
  }, {
    "value": "白城市",
    "area": ["洮北区", "大安市", "洮南市", "镇赉县", "通榆县", "其他"],
    "children": [{
      "value": "洮北区",
      "label": "洮北区"
    }, {
      "value": "大安市",
      "label": "大安市"
    }, {
      "value": "洮南市",
      "label": "洮南市"
    }, {
      "value": "镇赉县",
      "label": "镇赉县"
    }, {
      "value": "通榆县",
      "label": "通榆县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "白城市"
  }, {
    "value": "延边朝鲜族自治州",
    "area": ["延吉市", "图们市", "敦化市", "龙井市", "珲春市", "和龙市", "安图县", "汪清县", "其他"],
    "children": [{
      "value": "延吉市",
      "label": "延吉市"
    }, {
      "value": "图们市",
      "label": "图们市"
    }, {
      "value": "敦化市",
      "label": "敦化市"
    }, {
      "value": "龙井市",
      "label": "龙井市"
    }, {
      "value": "珲春市",
      "label": "珲春市"
    }, {
      "value": "和龙市",
      "label": "和龙市"
    }, {
      "value": "安图县",
      "label": "安图县"
    }, {
      "value": "汪清县",
      "label": "汪清县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "延边朝鲜族自治州"
  }, {
    "value": "其他",
    "area": ["其他"],
    "children": [{
      "value": "其他",
      "label": "其他"
    }],
    "label": "其他"
  }],
  "label": "吉林省"
}, {
  "value": "黑龙江省",
  "children": [{
    "value": "哈尔滨市",
    "area": ["松北区", "道里区", "南岗区", "平房区", "香坊区", "道外区", "呼兰区", "阿城区", "双城市", "尚志市", "五常市", "宾县", "方正县", "通河县", "巴彦县", "延寿县", "木兰县", "依兰县", "其他"],
    "children": [{
      "value": "松北区",
      "label": "松北区"
    }, {
      "value": "道里区",
      "label": "道里区"
    }, {
      "value": "南岗区",
      "label": "南岗区"
    }, {
      "value": "平房区",
      "label": "平房区"
    }, {
      "value": "香坊区",
      "label": "香坊区"
    }, {
      "value": "道外区",
      "label": "道外区"
    }, {
      "value": "呼兰区",
      "label": "呼兰区"
    }, {
      "value": "阿城区",
      "label": "阿城区"
    }, {
      "value": "双城市",
      "label": "双城市"
    }, {
      "value": "尚志市",
      "label": "尚志市"
    }, {
      "value": "五常市",
      "label": "五常市"
    }, {
      "value": "宾县",
      "label": "宾县"
    }, {
      "value": "方正县",
      "label": "方正县"
    }, {
      "value": "通河县",
      "label": "通河县"
    }, {
      "value": "巴彦县",
      "label": "巴彦县"
    }, {
      "value": "延寿县",
      "label": "延寿县"
    }, {
      "value": "木兰县",
      "label": "木兰县"
    }, {
      "value": "依兰县",
      "label": "依兰县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "哈尔滨市"
  }, {
    "value": "齐齐哈尔市",
    "area": ["龙沙区", "昂昂溪区", "铁锋区", "建华区", "富拉尔基区", "碾子山区", "梅里斯达斡尔族区", "讷河市", "富裕县", "拜泉县", "甘南县", "依安县", "克山县", "泰来县", "克东县", "龙江县", "其他"],
    "children": [{
      "value": "龙沙区",
      "label": "龙沙区"
    }, {
      "value": "昂昂溪区",
      "label": "昂昂溪区"
    }, {
      "value": "铁锋区",
      "label": "铁锋区"
    }, {
      "value": "建华区",
      "label": "建华区"
    }, {
      "value": "富拉尔基区",
      "label": "富拉尔基区"
    }, {
      "value": "碾子山区",
      "label": "碾子山区"
    }, {
      "value": "梅里斯达斡尔族区",
      "label": "梅里斯达斡尔族区"
    }, {
      "value": "讷河市",
      "label": "讷河市"
    }, {
      "value": "富裕县",
      "label": "富裕县"
    }, {
      "value": "拜泉县",
      "label": "拜泉县"
    }, {
      "value": "甘南县",
      "label": "甘南县"
    }, {
      "value": "依安县",
      "label": "依安县"
    }, {
      "value": "克山县",
      "label": "克山县"
    }, {
      "value": "泰来县",
      "label": "泰来县"
    }, {
      "value": "克东县",
      "label": "克东县"
    }, {
      "value": "龙江县",
      "label": "龙江县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "齐齐哈尔市"
  }, {
    "value": "鹤岗市",
    "area": ["兴山区", "工农区", "南山区", "兴安区", "向阳区", "东山区", "萝北县", "绥滨县", "其他"],
    "children": [{
      "value": "兴山区",
      "label": "兴山区"
    }, {
      "value": "工农区",
      "label": "工农区"
    }, {
      "value": "南山区",
      "label": "南山区"
    }, {
      "value": "兴安区",
      "label": "兴安区"
    }, {
      "value": "向阳区",
      "label": "向阳区"
    }, {
      "value": "东山区",
      "label": "东山区"
    }, {
      "value": "萝北县",
      "label": "萝北县"
    }, {
      "value": "绥滨县",
      "label": "绥滨县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "鹤岗市"
  }, {
    "value": "双鸭山",
    "area": ["尖山区", "岭东区", "四方台区", "宝山区", "集贤县", "宝清县", "友谊县", "饶河县", "其他"],
    "children": [{
      "value": "尖山区",
      "label": "尖山区"
    }, {
      "value": "岭东区",
      "label": "岭东区"
    }, {
      "value": "四方台区",
      "label": "四方台区"
    }, {
      "value": "宝山区",
      "label": "宝山区"
    }, {
      "value": "集贤县",
      "label": "集贤县"
    }, {
      "value": "宝清县",
      "label": "宝清县"
    }, {
      "value": "友谊县",
      "label": "友谊县"
    }, {
      "value": "饶河县",
      "label": "饶河县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "双鸭山"
  }, {
    "value": "鸡西市",
    "area": ["鸡冠区", "恒山区", "城子河区", "滴道区", "梨树区", "麻山区", "密山市", "虎林市", "鸡东县", "其他"],
    "children": [{
      "value": "鸡冠区",
      "label": "鸡冠区"
    }, {
      "value": "恒山区",
      "label": "恒山区"
    }, {
      "value": "城子河区",
      "label": "城子河区"
    }, {
      "value": "滴道区",
      "label": "滴道区"
    }, {
      "value": "梨树区",
      "label": "梨树区"
    }, {
      "value": "麻山区",
      "label": "麻山区"
    }, {
      "value": "密山市",
      "label": "密山市"
    }, {
      "value": "虎林市",
      "label": "虎林市"
    }, {
      "value": "鸡东县",
      "label": "鸡东县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "鸡西市"
  }, {
    "value": "大庆市",
    "area": ["萨尔图区", "红岗区", "龙凤区", "让胡路区", "大同区", "林甸县", "肇州县", "肇源县", "杜尔伯特蒙古族自治县", "其他"],
    "children": [{
      "value": "萨尔图区",
      "label": "萨尔图区"
    }, {
      "value": "红岗区",
      "label": "红岗区"
    }, {
      "value": "龙凤区",
      "label": "龙凤区"
    }, {
      "value": "让胡路区",
      "label": "让胡路区"
    }, {
      "value": "大同区",
      "label": "大同区"
    }, {
      "value": "林甸县",
      "label": "林甸县"
    }, {
      "value": "肇州县",
      "label": "肇州县"
    }, {
      "value": "肇源县",
      "label": "肇源县"
    }, {
      "value": "杜尔伯特蒙古族自治县",
      "label": "杜尔伯特蒙古族自治县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "大庆市"
  }, {
    "value": "伊春市",
    "area": ["伊春区", "带岭区", "南岔区", "金山屯区", "西林区", "美溪区", "乌马河区", "翠峦区", "友好区", "上甘岭区", "五营区", "红星区", "新青区", "汤旺河区", "乌伊岭区", "铁力市", "嘉荫县", "其他"],
    "children": [{
      "value": "伊春区",
      "label": "伊春区"
    }, {
      "value": "带岭区",
      "label": "带岭区"
    }, {
      "value": "南岔区",
      "label": "南岔区"
    }, {
      "value": "金山屯区",
      "label": "金山屯区"
    }, {
      "value": "西林区",
      "label": "西林区"
    }, {
      "value": "美溪区",
      "label": "美溪区"
    }, {
      "value": "乌马河区",
      "label": "乌马河区"
    }, {
      "value": "翠峦区",
      "label": "翠峦区"
    }, {
      "value": "友好区",
      "label": "友好区"
    }, {
      "value": "上甘岭区",
      "label": "上甘岭区"
    }, {
      "value": "五营区",
      "label": "五营区"
    }, {
      "value": "红星区",
      "label": "红星区"
    }, {
      "value": "新青区",
      "label": "新青区"
    }, {
      "value": "汤旺河区",
      "label": "汤旺河区"
    }, {
      "value": "乌伊岭区",
      "label": "乌伊岭区"
    }, {
      "value": "铁力市",
      "label": "铁力市"
    }, {
      "value": "嘉荫县",
      "label": "嘉荫县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "伊春市"
  }, {
    "value": "牡丹江市",
    "area": ["爱民区", "东安区", "阳明区", "西安区", "绥芬河市", "宁安市", "海林市", "穆棱市", "林口县", "东宁县", "其他"],
    "children": [{
      "value": "爱民区",
      "label": "爱民区"
    }, {
      "value": "东安区",
      "label": "东安区"
    }, {
      "value": "阳明区",
      "label": "阳明区"
    }, {
      "value": "西安区",
      "label": "西安区"
    }, {
      "value": "绥芬河市",
      "label": "绥芬河市"
    }, {
      "value": "宁安市",
      "label": "宁安市"
    }, {
      "value": "海林市",
      "label": "海林市"
    }, {
      "value": "穆棱市",
      "label": "穆棱市"
    }, {
      "value": "林口县",
      "label": "林口县"
    }, {
      "value": "东宁县",
      "label": "东宁县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "牡丹江市"
  }, {
    "value": "佳木斯市",
    "area": ["向阳区", "前进区", "东风区", "郊区", "同江市", "富锦市", "桦川县", "抚远县", "桦南县", "汤原县", "其他"],
    "children": [{
      "value": "向阳区",
      "label": "向阳区"
    }, {
      "value": "前进区",
      "label": "前进区"
    }, {
      "value": "东风区",
      "label": "东风区"
    }, {
      "value": "郊区",
      "label": "郊区"
    }, {
      "value": "同江市",
      "label": "同江市"
    }, {
      "value": "富锦市",
      "label": "富锦市"
    }, {
      "value": "桦川县",
      "label": "桦川县"
    }, {
      "value": "抚远县",
      "label": "抚远县"
    }, {
      "value": "桦南县",
      "label": "桦南县"
    }, {
      "value": "汤原县",
      "label": "汤原县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "佳木斯市"
  }, {
    "value": "七台河市",
    "area": ["桃山区", "新兴区", "茄子河区", "勃利县", "其他"],
    "children": [{
      "value": "桃山区",
      "label": "桃山区"
    }, {
      "value": "新兴区",
      "label": "新兴区"
    }, {
      "value": "茄子河区",
      "label": "茄子河区"
    }, {
      "value": "勃利县",
      "label": "勃利县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "七台河市"
  }, {
    "value": "黑河市",
    "area": ["爱辉区", "北安市", "五大连池市", "逊克县", "嫩江县", "孙吴县", "其他"],
    "children": [{
      "value": "爱辉区",
      "label": "爱辉区"
    }, {
      "value": "北安市",
      "label": "北安市"
    }, {
      "value": "五大连池市",
      "label": "五大连池市"
    }, {
      "value": "逊克县",
      "label": "逊克县"
    }, {
      "value": "嫩江县",
      "label": "嫩江县"
    }, {
      "value": "孙吴县",
      "label": "孙吴县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "黑河市"
  }, {
    "value": "绥化市",
    "area": ["北林区", "安达市", "肇东市", "海伦市", "绥棱县", "兰西县", "明水县", "青冈县", "庆安县", "望奎县", "其他"],
    "children": [{
      "value": "北林区",
      "label": "北林区"
    }, {
      "value": "安达市",
      "label": "安达市"
    }, {
      "value": "肇东市",
      "label": "肇东市"
    }, {
      "value": "海伦市",
      "label": "海伦市"
    }, {
      "value": "绥棱县",
      "label": "绥棱县"
    }, {
      "value": "兰西县",
      "label": "兰西县"
    }, {
      "value": "明水县",
      "label": "明水县"
    }, {
      "value": "青冈县",
      "label": "青冈县"
    }, {
      "value": "庆安县",
      "label": "庆安县"
    }, {
      "value": "望奎县",
      "label": "望奎县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "绥化市"
  }, {
    "value": "大兴安岭地区",
    "area": ["呼玛县", "塔河县", "漠河县", "大兴安岭辖区", "其他"],
    "children": [{
      "value": "呼玛县",
      "label": "呼玛县"
    }, {
      "value": "塔河县",
      "label": "塔河县"
    }, {
      "value": "漠河县",
      "label": "漠河县"
    }, {
      "value": "大兴安岭辖区",
      "label": "大兴安岭辖区"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "大兴安岭地区"
  }, {
    "value": "其他",
    "area": ["其他"],
    "children": [{
      "value": "其他",
      "label": "其他"
    }],
    "label": "其他"
  }],
  "label": "黑龙江省"
}, {
  "value": "上海市",
  "children": [{
    "value": "上海市",
    "area": ["黄浦区", "卢湾区", "徐汇区", "长宁区", "静安区", "普陀区", "闸北区", "虹口区", "杨浦区", "宝山区", "闵行区", "嘉定区", "松江区", "金山区", "青浦区", "南汇区", "奉贤区", "浦东新区", "崇明县", "其他"],
    "children": [{
      "value": "黄浦区",
      "label": "黄浦区"
    }, {
      "value": "卢湾区",
      "label": "卢湾区"
    }, {
      "value": "徐汇区",
      "label": "徐汇区"
    }, {
      "value": "长宁区",
      "label": "长宁区"
    }, {
      "value": "静安区",
      "label": "静安区"
    }, {
      "value": "普陀区",
      "label": "普陀区"
    }, {
      "value": "闸北区",
      "label": "闸北区"
    }, {
      "value": "虹口区",
      "label": "虹口区"
    }, {
      "value": "杨浦区",
      "label": "杨浦区"
    }, {
      "value": "宝山区",
      "label": "宝山区"
    }, {
      "value": "闵行区",
      "label": "闵行区"
    }, {
      "value": "嘉定区",
      "label": "嘉定区"
    }, {
      "value": "松江区",
      "label": "松江区"
    }, {
      "value": "金山区",
      "label": "金山区"
    }, {
      "value": "青浦区",
      "label": "青浦区"
    }, {
      "value": "南汇区",
      "label": "南汇区"
    }, {
      "value": "奉贤区",
      "label": "奉贤区"
    }, {
      "value": "浦东新区",
      "label": "浦东新区"
    }, {
      "value": "崇明县",
      "label": "崇明县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "上海市"
  }],
  "label": "上海市"
}, {
  "value": "江苏省",
  "children": [{
    "value": "南京市",
    "area": ["玄武区", "白下区", "秦淮区", "建邺区", "鼓楼区", "下关区", "栖霞区", "雨花台区", "浦口区", "江宁区", "六合区", "溧水县", "高淳县", "其他"],
    "children": [{
      "value": "玄武区",
      "label": "玄武区"
    }, {
      "value": "白下区",
      "label": "白下区"
    }, {
      "value": "秦淮区",
      "label": "秦淮区"
    }, {
      "value": "建邺区",
      "label": "建邺区"
    }, {
      "value": "鼓楼区",
      "label": "鼓楼区"
    }, {
      "value": "下关区",
      "label": "下关区"
    }, {
      "value": "栖霞区",
      "label": "栖霞区"
    }, {
      "value": "雨花台区",
      "label": "雨花台区"
    }, {
      "value": "浦口区",
      "label": "浦口区"
    }, {
      "value": "江宁区",
      "label": "江宁区"
    }, {
      "value": "六合区",
      "label": "六合区"
    }, {
      "value": "溧水县",
      "label": "溧水县"
    }, {
      "value": "高淳县",
      "label": "高淳县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "南京市"
  }, {
    "value": "苏州市",
    "area": ["金阊区", "平江区", "沧浪区", "虎丘区", "吴中区", "相城区", "常熟市", "张家港市", "昆山市", "吴江市", "太仓市", "其他"],
    "children": [{
      "value": "金阊区",
      "label": "金阊区"
    }, {
      "value": "平江区",
      "label": "平江区"
    }, {
      "value": "沧浪区",
      "label": "沧浪区"
    }, {
      "value": "虎丘区",
      "label": "虎丘区"
    }, {
      "value": "吴中区",
      "label": "吴中区"
    }, {
      "value": "相城区",
      "label": "相城区"
    }, {
      "value": "常熟市",
      "label": "常熟市"
    }, {
      "value": "张家港市",
      "label": "张家港市"
    }, {
      "value": "昆山市",
      "label": "昆山市"
    }, {
      "value": "吴江市",
      "label": "吴江市"
    }, {
      "value": "太仓市",
      "label": "太仓市"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "苏州市"
  }, {
    "value": "无锡市",
    "area": ["崇安区", "南长区", "北塘区", "滨湖区", "锡山区", "惠山区", "江阴市", "宜兴市", "其他"],
    "children": [{
      "value": "崇安区",
      "label": "崇安区"
    }, {
      "value": "南长区",
      "label": "南长区"
    }, {
      "value": "北塘区",
      "label": "北塘区"
    }, {
      "value": "滨湖区",
      "label": "滨湖区"
    }, {
      "value": "锡山区",
      "label": "锡山区"
    }, {
      "value": "惠山区",
      "label": "惠山区"
    }, {
      "value": "江阴市",
      "label": "江阴市"
    }, {
      "value": "宜兴市",
      "label": "宜兴市"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "无锡市"
  }, {
    "value": "常州市",
    "area": ["钟楼区", "天宁区", "戚墅堰区", "新北区", "武进区", "金坛市", "溧阳市", "其他"],
    "children": [{
      "value": "钟楼区",
      "label": "钟楼区"
    }, {
      "value": "天宁区",
      "label": "天宁区"
    }, {
      "value": "戚墅堰区",
      "label": "戚墅堰区"
    }, {
      "value": "新北区",
      "label": "新北区"
    }, {
      "value": "武进区",
      "label": "武进区"
    }, {
      "value": "金坛市",
      "label": "金坛市"
    }, {
      "value": "溧阳市",
      "label": "溧阳市"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "常州市"
  }, {
    "value": "镇江市",
    "area": ["京口区", "润州区", "丹徒区", "丹阳市", "扬中市", "句容市", "其他"],
    "children": [{
      "value": "京口区",
      "label": "京口区"
    }, {
      "value": "润州区",
      "label": "润州区"
    }, {
      "value": "丹徒区",
      "label": "丹徒区"
    }, {
      "value": "丹阳市",
      "label": "丹阳市"
    }, {
      "value": "扬中市",
      "label": "扬中市"
    }, {
      "value": "句容市",
      "label": "句容市"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "镇江市"
  }, {
    "value": "南通市",
    "area": ["崇川区", "港闸区", "通州市", "如皋市", "海门市", "启东市", "海安县", "如东县", "其他"],
    "children": [{
      "value": "崇川区",
      "label": "崇川区"
    }, {
      "value": "港闸区",
      "label": "港闸区"
    }, {
      "value": "通州市",
      "label": "通州市"
    }, {
      "value": "如皋市",
      "label": "如皋市"
    }, {
      "value": "海门市",
      "label": "海门市"
    }, {
      "value": "启东市",
      "label": "启东市"
    }, {
      "value": "海安县",
      "label": "海安县"
    }, {
      "value": "如东县",
      "label": "如东县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "南通市"
  }, {
    "value": "泰州市",
    "area": ["海陵区", "高港区", "姜堰市", "泰兴市", "靖江市", "兴化市", "其他"],
    "children": [{
      "value": "海陵区",
      "label": "海陵区"
    }, {
      "value": "高港区",
      "label": "高港区"
    }, {
      "value": "姜堰市",
      "label": "姜堰市"
    }, {
      "value": "泰兴市",
      "label": "泰兴市"
    }, {
      "value": "靖江市",
      "label": "靖江市"
    }, {
      "value": "兴化市",
      "label": "兴化市"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "泰州市"
  }, {
    "value": "扬州市",
    "area": ["广陵区", "维扬区", "邗江区", "江都市", "仪征市", "高邮市", "宝应县", "其他"],
    "children": [{
      "value": "广陵区",
      "label": "广陵区"
    }, {
      "value": "维扬区",
      "label": "维扬区"
    }, {
      "value": "邗江区",
      "label": "邗江区"
    }, {
      "value": "江都市",
      "label": "江都市"
    }, {
      "value": "仪征市",
      "label": "仪征市"
    }, {
      "value": "高邮市",
      "label": "高邮市"
    }, {
      "value": "宝应县",
      "label": "宝应县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "扬州市"
  }, {
    "value": "盐城市",
    "area": ["亭湖区", "盐都区", "大丰市", "东台市", "建湖县", "射阳县", "阜宁县", "滨海县", "响水县", "其他"],
    "children": [{
      "value": "亭湖区",
      "label": "亭湖区"
    }, {
      "value": "盐都区",
      "label": "盐都区"
    }, {
      "value": "大丰市",
      "label": "大丰市"
    }, {
      "value": "东台市",
      "label": "东台市"
    }, {
      "value": "建湖县",
      "label": "建湖县"
    }, {
      "value": "射阳县",
      "label": "射阳县"
    }, {
      "value": "阜宁县",
      "label": "阜宁县"
    }, {
      "value": "滨海县",
      "label": "滨海县"
    }, {
      "value": "响水县",
      "label": "响水县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "盐城市"
  }, {
    "value": "连云港市",
    "area": ["新浦区", "海州区", "连云区", "东海县", "灌云县", "赣榆县", "灌南县", "其他"],
    "children": [{
      "value": "新浦区",
      "label": "新浦区"
    }, {
      "value": "海州区",
      "label": "海州区"
    }, {
      "value": "连云区",
      "label": "连云区"
    }, {
      "value": "东海县",
      "label": "东海县"
    }, {
      "value": "灌云县",
      "label": "灌云县"
    }, {
      "value": "赣榆县",
      "label": "赣榆县"
    }, {
      "value": "灌南县",
      "label": "灌南县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "连云港市"
  }, {
    "value": "徐州市",
    "area": ["云龙区", "鼓楼区", "九里区", "泉山区", "贾汪区", "邳州市", "新沂市", "铜山县", "睢宁县", "沛县", "丰县", "其他"],
    "children": [{
      "value": "云龙区",
      "label": "云龙区"
    }, {
      "value": "鼓楼区",
      "label": "鼓楼区"
    }, {
      "value": "九里区",
      "label": "九里区"
    }, {
      "value": "泉山区",
      "label": "泉山区"
    }, {
      "value": "贾汪区",
      "label": "贾汪区"
    }, {
      "value": "邳州市",
      "label": "邳州市"
    }, {
      "value": "新沂市",
      "label": "新沂市"
    }, {
      "value": "铜山县",
      "label": "铜山县"
    }, {
      "value": "睢宁县",
      "label": "睢宁县"
    }, {
      "value": "沛县",
      "label": "沛县"
    }, {
      "value": "丰县",
      "label": "丰县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "徐州市"
  }, {
    "value": "淮安市",
    "area": ["清河区", "清浦区", "楚州区", "淮阴区", "涟水县", "洪泽县", "金湖县", "盱眙县", "其他"],
    "children": [{
      "value": "清河区",
      "label": "清河区"
    }, {
      "value": "清浦区",
      "label": "清浦区"
    }, {
      "value": "楚州区",
      "label": "楚州区"
    }, {
      "value": "淮阴区",
      "label": "淮阴区"
    }, {
      "value": "涟水县",
      "label": "涟水县"
    }, {
      "value": "洪泽县",
      "label": "洪泽县"
    }, {
      "value": "金湖县",
      "label": "金湖县"
    }, {
      "value": "盱眙县",
      "label": "盱眙县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "淮安市"
  }, {
    "value": "宿迁市",
    "area": ["宿城区", "宿豫区", "沭阳县", "泗阳县", "泗洪县", "其他"],
    "children": [{
      "value": "宿城区",
      "label": "宿城区"
    }, {
      "value": "宿豫区",
      "label": "宿豫区"
    }, {
      "value": "沭阳县",
      "label": "沭阳县"
    }, {
      "value": "泗阳县",
      "label": "泗阳县"
    }, {
      "value": "泗洪县",
      "label": "泗洪县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "宿迁市"
  }, {
    "value": "其他",
    "area": ["其他"],
    "children": [{
      "value": "其他",
      "label": "其他"
    }],
    "label": "其他"
  }],
  "label": "江苏省"
}, {
  "value": "浙江省",
  "children": [{
    "value": "杭州市",
    "area": ["拱墅区", "西湖区", "上城区", "下城区", "江干区", "滨江区", "余杭区", "萧山区", "建德市", "富阳市", "临安市", "桐庐县", "淳安县", "其他"],
    "children": [{
      "value": "拱墅区",
      "label": "拱墅区"
    }, {
      "value": "西湖区",
      "label": "西湖区"
    }, {
      "value": "上城区",
      "label": "上城区"
    }, {
      "value": "下城区",
      "label": "下城区"
    }, {
      "value": "江干区",
      "label": "江干区"
    }, {
      "value": "滨江区",
      "label": "滨江区"
    }, {
      "value": "余杭区",
      "label": "余杭区"
    }, {
      "value": "萧山区",
      "label": "萧山区"
    }, {
      "value": "建德市",
      "label": "建德市"
    }, {
      "value": "富阳市",
      "label": "富阳市"
    }, {
      "value": "临安市",
      "label": "临安市"
    }, {
      "value": "桐庐县",
      "label": "桐庐县"
    }, {
      "value": "淳安县",
      "label": "淳安县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "杭州市"
  }, {
    "value": "宁波市",
    "area": ["海曙区", "江东区", "江北区", "镇海区", "北仑区", "鄞州区", "余姚市", "慈溪市", "奉化市", "宁海县", "象山县", "其他"],
    "children": [{
      "value": "海曙区",
      "label": "海曙区"
    }, {
      "value": "江东区",
      "label": "江东区"
    }, {
      "value": "江北区",
      "label": "江北区"
    }, {
      "value": "镇海区",
      "label": "镇海区"
    }, {
      "value": "北仑区",
      "label": "北仑区"
    }, {
      "value": "鄞州区",
      "label": "鄞州区"
    }, {
      "value": "余姚市",
      "label": "余姚市"
    }, {
      "value": "慈溪市",
      "label": "慈溪市"
    }, {
      "value": "奉化市",
      "label": "奉化市"
    }, {
      "value": "宁海县",
      "label": "宁海县"
    }, {
      "value": "象山县",
      "label": "象山县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "宁波市"
  }, {
    "value": "温州市",
    "area": ["鹿城区", "龙湾区", "瓯海区", "瑞安市", "乐清市", "永嘉县", "洞头县", "平阳县", "苍南县", "文成县", "泰顺县", "其他"],
    "children": [{
      "value": "鹿城区",
      "label": "鹿城区"
    }, {
      "value": "龙湾区",
      "label": "龙湾区"
    }, {
      "value": "瓯海区",
      "label": "瓯海区"
    }, {
      "value": "瑞安市",
      "label": "瑞安市"
    }, {
      "value": "乐清市",
      "label": "乐清市"
    }, {
      "value": "永嘉县",
      "label": "永嘉县"
    }, {
      "value": "洞头县",
      "label": "洞头县"
    }, {
      "value": "平阳县",
      "label": "平阳县"
    }, {
      "value": "苍南县",
      "label": "苍南县"
    }, {
      "value": "文成县",
      "label": "文成县"
    }, {
      "value": "泰顺县",
      "label": "泰顺县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "温州市"
  }, {
    "value": "嘉兴市",
    "area": ["秀城区", "秀洲区", "海宁市", "平湖市", "桐乡市", "嘉善县", "海盐县", "其他"],
    "children": [{
      "value": "秀城区",
      "label": "秀城区"
    }, {
      "value": "秀洲区",
      "label": "秀洲区"
    }, {
      "value": "海宁市",
      "label": "海宁市"
    }, {
      "value": "平湖市",
      "label": "平湖市"
    }, {
      "value": "桐乡市",
      "label": "桐乡市"
    }, {
      "value": "嘉善县",
      "label": "嘉善县"
    }, {
      "value": "海盐县",
      "label": "海盐县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "嘉兴市"
  }, {
    "value": "湖州市",
    "area": ["吴兴区", "南浔区", "长兴县", "德清县", "安吉县", "其他"],
    "children": [{
      "value": "吴兴区",
      "label": "吴兴区"
    }, {
      "value": "南浔区",
      "label": "南浔区"
    }, {
      "value": "长兴县",
      "label": "长兴县"
    }, {
      "value": "德清县",
      "label": "德清县"
    }, {
      "value": "安吉县",
      "label": "安吉县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "湖州市"
  }, {
    "value": "绍兴市",
    "area": ["越城区", "诸暨市", "上虞市", "嵊州市", "绍兴县", "新昌县", "其他"],
    "children": [{
      "value": "越城区",
      "label": "越城区"
    }, {
      "value": "诸暨市",
      "label": "诸暨市"
    }, {
      "value": "上虞市",
      "label": "上虞市"
    }, {
      "value": "嵊州市",
      "label": "嵊州市"
    }, {
      "value": "绍兴县",
      "label": "绍兴县"
    }, {
      "value": "新昌县",
      "label": "新昌县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "绍兴市"
  }, {
    "value": "金华市",
    "area": ["婺城区", "金东区", "兰溪市", "义乌市", "东阳市", "永康市", "武义县", "浦江县", "磐安县", "其他"],
    "children": [{
      "value": "婺城区",
      "label": "婺城区"
    }, {
      "value": "金东区",
      "label": "金东区"
    }, {
      "value": "兰溪市",
      "label": "兰溪市"
    }, {
      "value": "义乌市",
      "label": "义乌市"
    }, {
      "value": "东阳市",
      "label": "东阳市"
    }, {
      "value": "永康市",
      "label": "永康市"
    }, {
      "value": "武义县",
      "label": "武义县"
    }, {
      "value": "浦江县",
      "label": "浦江县"
    }, {
      "value": "磐安县",
      "label": "磐安县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "金华市"
  }, {
    "value": "衢州市",
    "area": ["柯城区", "衢江区", "江山市", "龙游县", "常山县", "开化县", "其他"],
    "children": [{
      "value": "柯城区",
      "label": "柯城区"
    }, {
      "value": "衢江区",
      "label": "衢江区"
    }, {
      "value": "江山市",
      "label": "江山市"
    }, {
      "value": "龙游县",
      "label": "龙游县"
    }, {
      "value": "常山县",
      "label": "常山县"
    }, {
      "value": "开化县",
      "label": "开化县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "衢州市"
  }, {
    "value": "舟山市",
    "area": ["定海区", "普陀区", "岱山县", "嵊泗县", "其他"],
    "children": [{
      "value": "定海区",
      "label": "定海区"
    }, {
      "value": "普陀区",
      "label": "普陀区"
    }, {
      "value": "岱山县",
      "label": "岱山县"
    }, {
      "value": "嵊泗县",
      "label": "嵊泗县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "舟山市"
  }, {
    "value": "台州市",
    "area": ["椒江区", "黄岩区", "路桥区", "临海市", "温岭市", "玉环县", "天台县", "仙居县", "三门县", "其他"],
    "children": [{
      "value": "椒江区",
      "label": "椒江区"
    }, {
      "value": "黄岩区",
      "label": "黄岩区"
    }, {
      "value": "路桥区",
      "label": "路桥区"
    }, {
      "value": "临海市",
      "label": "临海市"
    }, {
      "value": "温岭市",
      "label": "温岭市"
    }, {
      "value": "玉环县",
      "label": "玉环县"
    }, {
      "value": "天台县",
      "label": "天台县"
    }, {
      "value": "仙居县",
      "label": "仙居县"
    }, {
      "value": "三门县",
      "label": "三门县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "台州市"
  }, {
    "value": "丽水市",
    "area": ["莲都区", "龙泉市", "缙云县", "青田县", "云和县", "遂昌县", "松阳县", "庆元县", "景宁畲族自治县", "其他"],
    "children": [{
      "value": "莲都区",
      "label": "莲都区"
    }, {
      "value": "龙泉市",
      "label": "龙泉市"
    }, {
      "value": "缙云县",
      "label": "缙云县"
    }, {
      "value": "青田县",
      "label": "青田县"
    }, {
      "value": "云和县",
      "label": "云和县"
    }, {
      "value": "遂昌县",
      "label": "遂昌县"
    }, {
      "value": "松阳县",
      "label": "松阳县"
    }, {
      "value": "庆元县",
      "label": "庆元县"
    }, {
      "value": "景宁畲族自治县",
      "label": "景宁畲族自治县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "丽水市"
  }, {
    "value": "其他市",
    "area": ["其他"],
    "children": [{
      "value": "其他",
      "label": "其他"
    }],
    "label": "其他市"
  }],
  "label": "浙江省"
}, {
  "value": "安徽省",
  "children": [{
    "value": "合肥市",
    "area": ["庐阳区", "瑶海区", "蜀山区", "包河区", "长丰县", "肥东县", "肥西县", "其他"],
    "children": [{
      "value": "庐阳区",
      "label": "庐阳区"
    }, {
      "value": "瑶海区",
      "label": "瑶海区"
    }, {
      "value": "蜀山区",
      "label": "蜀山区"
    }, {
      "value": "包河区",
      "label": "包河区"
    }, {
      "value": "长丰县",
      "label": "长丰县"
    }, {
      "value": "肥东县",
      "label": "肥东县"
    }, {
      "value": "肥西县",
      "label": "肥西县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "合肥市"
  }, {
    "value": "芜湖市",
    "area": ["镜湖区", "弋江区", "鸠江区", "三山区", "芜湖县", "南陵县", "繁昌县", "其他"],
    "children": [{
      "value": "镜湖区",
      "label": "镜湖区"
    }, {
      "value": "弋江区",
      "label": "弋江区"
    }, {
      "value": "鸠江区",
      "label": "鸠江区"
    }, {
      "value": "三山区",
      "label": "三山区"
    }, {
      "value": "芜湖县",
      "label": "芜湖县"
    }, {
      "value": "南陵县",
      "label": "南陵县"
    }, {
      "value": "繁昌县",
      "label": "繁昌县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "芜湖市"
  }, {
    "value": "蚌埠市",
    "area": ["蚌山区", "龙子湖区", "禹会区", "淮上区", "怀远县", "固镇县", "五河县", "其他"],
    "children": [{
      "value": "蚌山区",
      "label": "蚌山区"
    }, {
      "value": "龙子湖区",
      "label": "龙子湖区"
    }, {
      "value": "禹会区",
      "label": "禹会区"
    }, {
      "value": "淮上区",
      "label": "淮上区"
    }, {
      "value": "怀远县",
      "label": "怀远县"
    }, {
      "value": "固镇县",
      "label": "固镇县"
    }, {
      "value": "五河县",
      "label": "五河县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "蚌埠市"
  }, {
    "value": "淮南市",
    "area": ["田家庵区", "大通区", "谢家集区", "八公山区", "潘集区", "凤台县", "其他"],
    "children": [{
      "value": "田家庵区",
      "label": "田家庵区"
    }, {
      "value": "大通区",
      "label": "大通区"
    }, {
      "value": "谢家集区",
      "label": "谢家集区"
    }, {
      "value": "八公山区",
      "label": "八公山区"
    }, {
      "value": "潘集区",
      "label": "潘集区"
    }, {
      "value": "凤台县",
      "label": "凤台县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "淮南市"
  }, {
    "value": "马鞍山市",
    "area": ["雨山区", "花山区", "金家庄区", "当涂县", "其他"],
    "children": [{
      "value": "雨山区",
      "label": "雨山区"
    }, {
      "value": "花山区",
      "label": "花山区"
    }, {
      "value": "金家庄区",
      "label": "金家庄区"
    }, {
      "value": "当涂县",
      "label": "当涂县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "马鞍山市"
  }, {
    "value": "淮北市",
    "area": ["相山区", "杜集区", "烈山区", "濉溪县", "其他"],
    "children": [{
      "value": "相山区",
      "label": "相山区"
    }, {
      "value": "杜集区",
      "label": "杜集区"
    }, {
      "value": "烈山区",
      "label": "烈山区"
    }, {
      "value": "濉溪县",
      "label": "濉溪县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "淮北市"
  }, {
    "value": "铜陵市",
    "area": ["铜官山区", "狮子山区", "郊区", "铜陵县", "其他"],
    "children": [{
      "value": "铜官山区",
      "label": "铜官山区"
    }, {
      "value": "狮子山区",
      "label": "狮子山区"
    }, {
      "value": "郊区",
      "label": "郊区"
    }, {
      "value": "铜陵县",
      "label": "铜陵县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "铜陵市"
  }, {
    "value": "安庆市",
    "area": ["迎江区", "大观区", "宜秀区", "桐城市", "宿松县", "枞阳县", "太湖县", "怀宁县", "岳西县", "望江县", "潜山县", "其他"],
    "children": [{
      "value": "迎江区",
      "label": "迎江区"
    }, {
      "value": "大观区",
      "label": "大观区"
    }, {
      "value": "宜秀区",
      "label": "宜秀区"
    }, {
      "value": "桐城市",
      "label": "桐城市"
    }, {
      "value": "宿松县",
      "label": "宿松县"
    }, {
      "value": "枞阳县",
      "label": "枞阳县"
    }, {
      "value": "太湖县",
      "label": "太湖县"
    }, {
      "value": "怀宁县",
      "label": "怀宁县"
    }, {
      "value": "岳西县",
      "label": "岳西县"
    }, {
      "value": "望江县",
      "label": "望江县"
    }, {
      "value": "潜山县",
      "label": "潜山县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "安庆市"
  }, {
    "value": "黄山市",
    "area": ["屯溪区", "黄山区", "徽州区", "休宁县", "歙县", "祁门县", "黟县", "其他"],
    "children": [{
      "value": "屯溪区",
      "label": "屯溪区"
    }, {
      "value": "黄山区",
      "label": "黄山区"
    }, {
      "value": "徽州区",
      "label": "徽州区"
    }, {
      "value": "休宁县",
      "label": "休宁县"
    }, {
      "value": "歙县",
      "label": "歙县"
    }, {
      "value": "祁门县",
      "label": "祁门县"
    }, {
      "value": "黟县",
      "label": "黟县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "黄山市"
  }, {
    "value": "滁州市",
    "area": ["琅琊区", "南谯区", "天长市", "明光市", "全椒县", "来安县", "定远县", "凤阳县", "其他"],
    "children": [{
      "value": "琅琊区",
      "label": "琅琊区"
    }, {
      "value": "南谯区",
      "label": "南谯区"
    }, {
      "value": "天长市",
      "label": "天长市"
    }, {
      "value": "明光市",
      "label": "明光市"
    }, {
      "value": "全椒县",
      "label": "全椒县"
    }, {
      "value": "来安县",
      "label": "来安县"
    }, {
      "value": "定远县",
      "label": "定远县"
    }, {
      "value": "凤阳县",
      "label": "凤阳县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "滁州市"
  }, {
    "value": "阜阳市",
    "area": ["颍州区", "颍东区", "颍泉区", "界首市", "临泉县", "颍上县", "阜南县", "太和县", "其他"],
    "children": [{
      "value": "颍州区",
      "label": "颍州区"
    }, {
      "value": "颍东区",
      "label": "颍东区"
    }, {
      "value": "颍泉区",
      "label": "颍泉区"
    }, {
      "value": "界首市",
      "label": "界首市"
    }, {
      "value": "临泉县",
      "label": "临泉县"
    }, {
      "value": "颍上县",
      "label": "颍上县"
    }, {
      "value": "阜南县",
      "label": "阜南县"
    }, {
      "value": "太和县",
      "label": "太和县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "阜阳市"
  }, {
    "value": "宿州市",
    "area": ["埇桥区", "萧县", "泗县", "砀山县", "灵璧县", "其他"],
    "children": [{
      "value": "埇桥区",
      "label": "埇桥区"
    }, {
      "value": "萧县",
      "label": "萧县"
    }, {
      "value": "泗县",
      "label": "泗县"
    }, {
      "value": "砀山县",
      "label": "砀山县"
    }, {
      "value": "灵璧县",
      "label": "灵璧县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "宿州市"
  }, {
    "value": "巢湖市",
    "area": ["居巢区", "含山县", "无为县", "庐江县", "和县", "其他"],
    "children": [{
      "value": "居巢区",
      "label": "居巢区"
    }, {
      "value": "含山县",
      "label": "含山县"
    }, {
      "value": "无为县",
      "label": "无为县"
    }, {
      "value": "庐江县",
      "label": "庐江县"
    }, {
      "value": "和县",
      "label": "和县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "巢湖市"
  }, {
    "value": "六安市",
    "area": ["金安区", "裕安区", "寿县", "霍山县", "霍邱县", "舒城县", "金寨县", "其他"],
    "children": [{
      "value": "金安区",
      "label": "金安区"
    }, {
      "value": "裕安区",
      "label": "裕安区"
    }, {
      "value": "寿县",
      "label": "寿县"
    }, {
      "value": "霍山县",
      "label": "霍山县"
    }, {
      "value": "霍邱县",
      "label": "霍邱县"
    }, {
      "value": "舒城县",
      "label": "舒城县"
    }, {
      "value": "金寨县",
      "label": "金寨县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "六安市"
  }, {
    "value": "亳州市",
    "area": ["谯城区", "利辛县", "涡阳县", "蒙城县", "其他"],
    "children": [{
      "value": "谯城区",
      "label": "谯城区"
    }, {
      "value": "利辛县",
      "label": "利辛县"
    }, {
      "value": "涡阳县",
      "label": "涡阳县"
    }, {
      "value": "蒙城县",
      "label": "蒙城县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "亳州市"
  }, {
    "value": "池州市",
    "area": ["贵池区", "东至县", "石台县", "青阳县", "其他"],
    "children": [{
      "value": "贵池区",
      "label": "贵池区"
    }, {
      "value": "东至县",
      "label": "东至县"
    }, {
      "value": "石台县",
      "label": "石台县"
    }, {
      "value": "青阳县",
      "label": "青阳县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "池州市"
  }, {
    "value": "宣城市",
    "area": ["宣州区", "宁国市", "广德县", "郎溪县", "泾县", "旌德县", "绩溪县", "其他"],
    "children": [{
      "value": "宣州区",
      "label": "宣州区"
    }, {
      "value": "宁国市",
      "label": "宁国市"
    }, {
      "value": "广德县",
      "label": "广德县"
    }, {
      "value": "郎溪县",
      "label": "郎溪县"
    }, {
      "value": "泾县",
      "label": "泾县"
    }, {
      "value": "旌德县",
      "label": "旌德县"
    }, {
      "value": "绩溪县",
      "label": "绩溪县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "宣城市"
  }, {
    "value": "其他市",
    "area": ["其他"],
    "children": [{
      "value": "其他",
      "label": "其他"
    }],
    "label": "其他市"
  }],
  "label": "安徽省"
}, {
  "value": "福建省",
  "children": [{
    "value": "福州市",
    "area": ["鼓楼区", "台江区", "仓山区", "马尾区", "晋安区", "福清市", "长乐市", "闽侯县", "闽清县", "永泰县", "连江县", "罗源县", "平潭县", "其他"],
    "children": [{
      "value": "鼓楼区",
      "label": "鼓楼区"
    }, {
      "value": "台江区",
      "label": "台江区"
    }, {
      "value": "仓山区",
      "label": "仓山区"
    }, {
      "value": "马尾区",
      "label": "马尾区"
    }, {
      "value": "晋安区",
      "label": "晋安区"
    }, {
      "value": "福清市",
      "label": "福清市"
    }, {
      "value": "长乐市",
      "label": "长乐市"
    }, {
      "value": "闽侯县",
      "label": "闽侯县"
    }, {
      "value": "闽清县",
      "label": "闽清县"
    }, {
      "value": "永泰县",
      "label": "永泰县"
    }, {
      "value": "连江县",
      "label": "连江县"
    }, {
      "value": "罗源县",
      "label": "罗源县"
    }, {
      "value": "平潭县",
      "label": "平潭县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "福州市"
  }, {
    "value": "厦门市",
    "area": ["思明区", "海沧区", "湖里区", "集美区", "同安区", "翔安区", "其他"],
    "children": [{
      "value": "思明区",
      "label": "思明区"
    }, {
      "value": "海沧区",
      "label": "海沧区"
    }, {
      "value": "湖里区",
      "label": "湖里区"
    }, {
      "value": "集美区",
      "label": "集美区"
    }, {
      "value": "同安区",
      "label": "同安区"
    }, {
      "value": "翔安区",
      "label": "翔安区"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "厦门市"
  }, {
    "value": "莆田市",
    "area": ["城厢区", "涵江区", "荔城区", "秀屿区", "仙游县", "其他"],
    "children": [{
      "value": "城厢区",
      "label": "城厢区"
    }, {
      "value": "涵江区",
      "label": "涵江区"
    }, {
      "value": "荔城区",
      "label": "荔城区"
    }, {
      "value": "秀屿区",
      "label": "秀屿区"
    }, {
      "value": "仙游县",
      "label": "仙游县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "莆田市"
  }, {
    "value": "三明市",
    "area": ["梅列区", "三元区", "永安市", "明溪县", "将乐县", "大田县", "宁化县", "建宁县", "沙县", "尤溪县", "清流县", "泰宁县", "其他"],
    "children": [{
      "value": "梅列区",
      "label": "梅列区"
    }, {
      "value": "三元区",
      "label": "三元区"
    }, {
      "value": "永安市",
      "label": "永安市"
    }, {
      "value": "明溪县",
      "label": "明溪县"
    }, {
      "value": "将乐县",
      "label": "将乐县"
    }, {
      "value": "大田县",
      "label": "大田县"
    }, {
      "value": "宁化县",
      "label": "宁化县"
    }, {
      "value": "建宁县",
      "label": "建宁县"
    }, {
      "value": "沙县",
      "label": "沙县"
    }, {
      "value": "尤溪县",
      "label": "尤溪县"
    }, {
      "value": "清流县",
      "label": "清流县"
    }, {
      "value": "泰宁县",
      "label": "泰宁县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "三明市"
  }, {
    "value": "泉州市",
    "area": ["鲤城区", "丰泽区", "洛江区", "泉港区", "石狮市", "晋江市", "南安市", "惠安县", "永春县", "安溪县", "德化县", "金门县", "其他"],
    "children": [{
      "value": "鲤城区",
      "label": "鲤城区"
    }, {
      "value": "丰泽区",
      "label": "丰泽区"
    }, {
      "value": "洛江区",
      "label": "洛江区"
    }, {
      "value": "泉港区",
      "label": "泉港区"
    }, {
      "value": "石狮市",
      "label": "石狮市"
    }, {
      "value": "晋江市",
      "label": "晋江市"
    }, {
      "value": "南安市",
      "label": "南安市"
    }, {
      "value": "惠安县",
      "label": "惠安县"
    }, {
      "value": "永春县",
      "label": "永春县"
    }, {
      "value": "安溪县",
      "label": "安溪县"
    }, {
      "value": "德化县",
      "label": "德化县"
    }, {
      "value": "金门县",
      "label": "金门县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "泉州市"
  }, {
    "value": "漳州市",
    "area": ["芗城区", "龙文区", "龙海市", "平和县", "南靖县", "诏安县", "漳浦县", "华安县", "东山县", "长泰县", "云霄县", "其他"],
    "children": [{
      "value": "芗城区",
      "label": "芗城区"
    }, {
      "value": "龙文区",
      "label": "龙文区"
    }, {
      "value": "龙海市",
      "label": "龙海市"
    }, {
      "value": "平和县",
      "label": "平和县"
    }, {
      "value": "南靖县",
      "label": "南靖县"
    }, {
      "value": "诏安县",
      "label": "诏安县"
    }, {
      "value": "漳浦县",
      "label": "漳浦县"
    }, {
      "value": "华安县",
      "label": "华安县"
    }, {
      "value": "东山县",
      "label": "东山县"
    }, {
      "value": "长泰县",
      "label": "长泰县"
    }, {
      "value": "云霄县",
      "label": "云霄县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "漳州市"
  }, {
    "value": "南平市",
    "area": ["延平区", "建瓯市", "邵武市", "武夷山市", "建阳市", "松溪县", "光泽县", "顺昌县", "浦城县", "政和县", "其他"],
    "children": [{
      "value": "延平区",
      "label": "延平区"
    }, {
      "value": "建瓯市",
      "label": "建瓯市"
    }, {
      "value": "邵武市",
      "label": "邵武市"
    }, {
      "value": "武夷山市",
      "label": "武夷山市"
    }, {
      "value": "建阳市",
      "label": "建阳市"
    }, {
      "value": "松溪县",
      "label": "松溪县"
    }, {
      "value": "光泽县",
      "label": "光泽县"
    }, {
      "value": "顺昌县",
      "label": "顺昌县"
    }, {
      "value": "浦城县",
      "label": "浦城县"
    }, {
      "value": "政和县",
      "label": "政和县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "南平市"
  }, {
    "value": "龙岩市",
    "area": ["新罗区", "漳平市", "长汀县", "武平县", "上杭县", "永定县", "连城县", "其他"],
    "children": [{
      "value": "新罗区",
      "label": "新罗区"
    }, {
      "value": "漳平市",
      "label": "漳平市"
    }, {
      "value": "长汀县",
      "label": "长汀县"
    }, {
      "value": "武平县",
      "label": "武平县"
    }, {
      "value": "上杭县",
      "label": "上杭县"
    }, {
      "value": "永定县",
      "label": "永定县"
    }, {
      "value": "连城县",
      "label": "连城县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "龙岩市"
  }, {
    "value": "宁德市",
    "area": ["蕉城区", "福安市", "福鼎市", "寿宁县", "霞浦县", "柘荣县", "屏南县", "古田县", "周宁县", "其他"],
    "children": [{
      "value": "蕉城区",
      "label": "蕉城区"
    }, {
      "value": "福安市",
      "label": "福安市"
    }, {
      "value": "福鼎市",
      "label": "福鼎市"
    }, {
      "value": "寿宁县",
      "label": "寿宁县"
    }, {
      "value": "霞浦县",
      "label": "霞浦县"
    }, {
      "value": "柘荣县",
      "label": "柘荣县"
    }, {
      "value": "屏南县",
      "label": "屏南县"
    }, {
      "value": "古田县",
      "label": "古田县"
    }, {
      "value": "周宁县",
      "label": "周宁县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "宁德市"
  }, {
    "value": "其他",
    "area": ["其他"],
    "children": [{
      "value": "其他",
      "label": "其他"
    }],
    "label": "其他"
  }],
  "label": "福建省"
}, {
  "value": "江西省",
  "children": [{
    "value": "南昌市",
    "area": ["东湖区", "西湖区", "青云谱区", "湾里区", "青山湖区", "新建县", "南昌县", "进贤县", "安义县", "其他"],
    "children": [{
      "value": "东湖区",
      "label": "东湖区"
    }, {
      "value": "西湖区",
      "label": "西湖区"
    }, {
      "value": "青云谱区",
      "label": "青云谱区"
    }, {
      "value": "湾里区",
      "label": "湾里区"
    }, {
      "value": "青山湖区",
      "label": "青山湖区"
    }, {
      "value": "新建县",
      "label": "新建县"
    }, {
      "value": "南昌县",
      "label": "南昌县"
    }, {
      "value": "进贤县",
      "label": "进贤县"
    }, {
      "value": "安义县",
      "label": "安义县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "南昌市"
  }, {
    "value": "景德镇市",
    "area": ["珠山区", "昌江区", "乐平市", "浮梁县", "其他"],
    "children": [{
      "value": "珠山区",
      "label": "珠山区"
    }, {
      "value": "昌江区",
      "label": "昌江区"
    }, {
      "value": "乐平市",
      "label": "乐平市"
    }, {
      "value": "浮梁县",
      "label": "浮梁县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "景德镇市"
  }, {
    "value": "萍乡市",
    "area": ["安源区", "湘东区", "莲花县", "上栗县", "芦溪县", "其他"],
    "children": [{
      "value": "安源区",
      "label": "安源区"
    }, {
      "value": "湘东区",
      "label": "湘东区"
    }, {
      "value": "莲花县",
      "label": "莲花县"
    }, {
      "value": "上栗县",
      "label": "上栗县"
    }, {
      "value": "芦溪县",
      "label": "芦溪县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "萍乡市"
  }, {
    "value": "九江市",
    "area": ["浔阳区", "庐山区", "瑞昌市", "九江县", "星子县", "武宁县", "彭泽县", "永修县", "修水县", "湖口县", "德安县", "都昌县", "其他"],
    "children": [{
      "value": "浔阳区",
      "label": "浔阳区"
    }, {
      "value": "庐山区",
      "label": "庐山区"
    }, {
      "value": "瑞昌市",
      "label": "瑞昌市"
    }, {
      "value": "九江县",
      "label": "九江县"
    }, {
      "value": "星子县",
      "label": "星子县"
    }, {
      "value": "武宁县",
      "label": "武宁县"
    }, {
      "value": "彭泽县",
      "label": "彭泽县"
    }, {
      "value": "永修县",
      "label": "永修县"
    }, {
      "value": "修水县",
      "label": "修水县"
    }, {
      "value": "湖口县",
      "label": "湖口县"
    }, {
      "value": "德安县",
      "label": "德安县"
    }, {
      "value": "都昌县",
      "label": "都昌县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "九江市"
  }, {
    "value": "新余市",
    "area": ["渝水区", "分宜县", "其他"],
    "children": [{
      "value": "渝水区",
      "label": "渝水区"
    }, {
      "value": "分宜县",
      "label": "分宜县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "新余市"
  }, {
    "value": "鹰潭市",
    "area": ["月湖区", "贵溪市", "余江县", "其他"],
    "children": [{
      "value": "月湖区",
      "label": "月湖区"
    }, {
      "value": "贵溪市",
      "label": "贵溪市"
    }, {
      "value": "余江县",
      "label": "余江县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "鹰潭市"
  }, {
    "value": "赣州市",
    "area": ["章贡区", "瑞金市", "南康市", "石城县", "安远县", "赣县", "宁都县", "寻乌县", "兴国县", "定南县", "上犹县", "于都县", "龙南县", "崇义县", "信丰县", "全南县", "大余县", "会昌县", "其他"],
    "children": [{
      "value": "章贡区",
      "label": "章贡区"
    }, {
      "value": "瑞金市",
      "label": "瑞金市"
    }, {
      "value": "南康市",
      "label": "南康市"
    }, {
      "value": "石城县",
      "label": "石城县"
    }, {
      "value": "安远县",
      "label": "安远县"
    }, {
      "value": "赣县",
      "label": "赣县"
    }, {
      "value": "宁都县",
      "label": "宁都县"
    }, {
      "value": "寻乌县",
      "label": "寻乌县"
    }, {
      "value": "兴国县",
      "label": "兴国县"
    }, {
      "value": "定南县",
      "label": "定南县"
    }, {
      "value": "上犹县",
      "label": "上犹县"
    }, {
      "value": "于都县",
      "label": "于都县"
    }, {
      "value": "龙南县",
      "label": "龙南县"
    }, {
      "value": "崇义县",
      "label": "崇义县"
    }, {
      "value": "信丰县",
      "label": "信丰县"
    }, {
      "value": "全南县",
      "label": "全南县"
    }, {
      "value": "大余县",
      "label": "大余县"
    }, {
      "value": "会昌县",
      "label": "会昌县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "赣州市"
  }, {
    "value": "吉安市",
    "area": ["吉州区", "青原区", "井冈山市", "吉安县", "永丰县", "永新县", "新干县", "泰和县", "峡江县", "遂川县", "安福县", "吉水县", "万安县", "其他"],
    "children": [{
      "value": "吉州区",
      "label": "吉州区"
    }, {
      "value": "青原区",
      "label": "青原区"
    }, {
      "value": "井冈山市",
      "label": "井冈山市"
    }, {
      "value": "吉安县",
      "label": "吉安县"
    }, {
      "value": "永丰县",
      "label": "永丰县"
    }, {
      "value": "永新县",
      "label": "永新县"
    }, {
      "value": "新干县",
      "label": "新干县"
    }, {
      "value": "泰和县",
      "label": "泰和县"
    }, {
      "value": "峡江县",
      "label": "峡江县"
    }, {
      "value": "遂川县",
      "label": "遂川县"
    }, {
      "value": "安福县",
      "label": "安福县"
    }, {
      "value": "吉水县",
      "label": "吉水县"
    }, {
      "value": "万安县",
      "label": "万安县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "吉安市"
  }, {
    "value": "宜春市",
    "area": ["袁州区", "丰城市", "樟树市", "高安市", "铜鼓县", "靖安县", "宜丰县", "奉新县", "万载县", "上高县", "其他"],
    "children": [{
      "value": "袁州区",
      "label": "袁州区"
    }, {
      "value": "丰城市",
      "label": "丰城市"
    }, {
      "value": "樟树市",
      "label": "樟树市"
    }, {
      "value": "高安市",
      "label": "高安市"
    }, {
      "value": "铜鼓县",
      "label": "铜鼓县"
    }, {
      "value": "靖安县",
      "label": "靖安县"
    }, {
      "value": "宜丰县",
      "label": "宜丰县"
    }, {
      "value": "奉新县",
      "label": "奉新县"
    }, {
      "value": "万载县",
      "label": "万载县"
    }, {
      "value": "上高县",
      "label": "上高县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "宜春市"
  }, {
    "value": "抚州市",
    "area": ["临川区", "南丰县", "乐安县", "金溪县", "南城县", "东乡县", "资溪县", "宜黄县", "广昌县", "黎川县", "崇仁县", "其他"],
    "children": [{
      "value": "临川区",
      "label": "临川区"
    }, {
      "value": "南丰县",
      "label": "南丰县"
    }, {
      "value": "乐安县",
      "label": "乐安县"
    }, {
      "value": "金溪县",
      "label": "金溪县"
    }, {
      "value": "南城县",
      "label": "南城县"
    }, {
      "value": "东乡县",
      "label": "东乡县"
    }, {
      "value": "资溪县",
      "label": "资溪县"
    }, {
      "value": "宜黄县",
      "label": "宜黄县"
    }, {
      "value": "广昌县",
      "label": "广昌县"
    }, {
      "value": "黎川县",
      "label": "黎川县"
    }, {
      "value": "崇仁县",
      "label": "崇仁县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "抚州市"
  }, {
    "value": "上饶市",
    "area": ["信州区", "德兴市", "上饶县", "广丰县", "鄱阳县", "婺源县", "铅山县", "余干县", "横峰县", "弋阳县", "玉山县", "万年县", "其他"],
    "children": [{
      "value": "信州区",
      "label": "信州区"
    }, {
      "value": "德兴市",
      "label": "德兴市"
    }, {
      "value": "上饶县",
      "label": "上饶县"
    }, {
      "value": "广丰县",
      "label": "广丰县"
    }, {
      "value": "鄱阳县",
      "label": "鄱阳县"
    }, {
      "value": "婺源县",
      "label": "婺源县"
    }, {
      "value": "铅山县",
      "label": "铅山县"
    }, {
      "value": "余干县",
      "label": "余干县"
    }, {
      "value": "横峰县",
      "label": "横峰县"
    }, {
      "value": "弋阳县",
      "label": "弋阳县"
    }, {
      "value": "玉山县",
      "label": "玉山县"
    }, {
      "value": "万年县",
      "label": "万年县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "上饶市"
  }, {
    "value": "其他",
    "area": ["其他"],
    "children": [{
      "value": "其他",
      "label": "其他"
    }],
    "label": "其他"
  }],
  "label": "江西省"
}, {
  "value": "山东省",
  "children": [{
    "value": "济南市",
    "area": ["市中区", "历下区", "天桥区", "槐荫区", "历城区", "长清区", "章丘市", "平阴县", "济阳县", "商河县", "其他"],
    "children": [{
      "value": "市中区",
      "label": "市中区"
    }, {
      "value": "历下区",
      "label": "历下区"
    }, {
      "value": "天桥区",
      "label": "天桥区"
    }, {
      "value": "槐荫区",
      "label": "槐荫区"
    }, {
      "value": "历城区",
      "label": "历城区"
    }, {
      "value": "长清区",
      "label": "长清区"
    }, {
      "value": "章丘市",
      "label": "章丘市"
    }, {
      "value": "平阴县",
      "label": "平阴县"
    }, {
      "value": "济阳县",
      "label": "济阳县"
    }, {
      "value": "商河县",
      "label": "商河县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "济南市"
  }, {
    "value": "青岛市",
    "area": ["市南区", "市北区", "城阳区", "四方区", "李沧区", "黄岛区", "崂山区", "胶南市", "胶州市", "平度市", "莱西市", "即墨市", "其他"],
    "children": [{
      "value": "市南区",
      "label": "市南区"
    }, {
      "value": "市北区",
      "label": "市北区"
    }, {
      "value": "城阳区",
      "label": "城阳区"
    }, {
      "value": "四方区",
      "label": "四方区"
    }, {
      "value": "李沧区",
      "label": "李沧区"
    }, {
      "value": "黄岛区",
      "label": "黄岛区"
    }, {
      "value": "崂山区",
      "label": "崂山区"
    }, {
      "value": "胶南市",
      "label": "胶南市"
    }, {
      "value": "胶州市",
      "label": "胶州市"
    }, {
      "value": "平度市",
      "label": "平度市"
    }, {
      "value": "莱西市",
      "label": "莱西市"
    }, {
      "value": "即墨市",
      "label": "即墨市"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "青岛市"
  }, {
    "value": "淄博市",
    "area": ["张店区", "临淄区", "淄川区", "博山区", "周村区", "桓台县", "高青县", "沂源县", "其他"],
    "children": [{
      "value": "张店区",
      "label": "张店区"
    }, {
      "value": "临淄区",
      "label": "临淄区"
    }, {
      "value": "淄川区",
      "label": "淄川区"
    }, {
      "value": "博山区",
      "label": "博山区"
    }, {
      "value": "周村区",
      "label": "周村区"
    }, {
      "value": "桓台县",
      "label": "桓台县"
    }, {
      "value": "高青县",
      "label": "高青县"
    }, {
      "value": "沂源县",
      "label": "沂源县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "淄博市"
  }, {
    "value": "枣庄市",
    "area": ["市中区", "山亭区", "峄城区", "台儿庄区", "薛城区", "滕州市", "其他"],
    "children": [{
      "value": "市中区",
      "label": "市中区"
    }, {
      "value": "山亭区",
      "label": "山亭区"
    }, {
      "value": "峄城区",
      "label": "峄城区"
    }, {
      "value": "台儿庄区",
      "label": "台儿庄区"
    }, {
      "value": "薛城区",
      "label": "薛城区"
    }, {
      "value": "滕州市",
      "label": "滕州市"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "枣庄市"
  }, {
    "value": "东营市",
    "area": ["东营区", "河口区", "垦利县", "广饶县", "利津县", "其他"],
    "children": [{
      "value": "东营区",
      "label": "东营区"
    }, {
      "value": "河口区",
      "label": "河口区"
    }, {
      "value": "垦利县",
      "label": "垦利县"
    }, {
      "value": "广饶县",
      "label": "广饶县"
    }, {
      "value": "利津县",
      "label": "利津县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "东营市"
  }, {
    "value": "烟台市",
    "area": ["芝罘区", "福山区", "牟平区", "莱山区", "龙口市", "莱阳市", "莱州市", "招远市", "蓬莱市", "栖霞市", "海阳市", "长岛县", "其他"],
    "children": [{
      "value": "芝罘区",
      "label": "芝罘区"
    }, {
      "value": "福山区",
      "label": "福山区"
    }, {
      "value": "牟平区",
      "label": "牟平区"
    }, {
      "value": "莱山区",
      "label": "莱山区"
    }, {
      "value": "龙口市",
      "label": "龙口市"
    }, {
      "value": "莱阳市",
      "label": "莱阳市"
    }, {
      "value": "莱州市",
      "label": "莱州市"
    }, {
      "value": "招远市",
      "label": "招远市"
    }, {
      "value": "蓬莱市",
      "label": "蓬莱市"
    }, {
      "value": "栖霞市",
      "label": "栖霞市"
    }, {
      "value": "海阳市",
      "label": "海阳市"
    }, {
      "value": "长岛县",
      "label": "长岛县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "烟台市"
  }, {
    "value": "潍坊市",
    "area": ["潍城区", "寒亭区", "坊子区", "奎文区", "青州市", "诸城市", "寿光市", "安丘市", "高密市", "昌邑市", "昌乐县", "临朐县", "其他"],
    "children": [{
      "value": "潍城区",
      "label": "潍城区"
    }, {
      "value": "寒亭区",
      "label": "寒亭区"
    }, {
      "value": "坊子区",
      "label": "坊子区"
    }, {
      "value": "奎文区",
      "label": "奎文区"
    }, {
      "value": "青州市",
      "label": "青州市"
    }, {
      "value": "诸城市",
      "label": "诸城市"
    }, {
      "value": "寿光市",
      "label": "寿光市"
    }, {
      "value": "安丘市",
      "label": "安丘市"
    }, {
      "value": "高密市",
      "label": "高密市"
    }, {
      "value": "昌邑市",
      "label": "昌邑市"
    }, {
      "value": "昌乐县",
      "label": "昌乐县"
    }, {
      "value": "临朐县",
      "label": "临朐县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "潍坊市"
  }, {
    "value": "济宁市",
    "area": ["市中区", "任城区", "曲阜市", "兖州市", "邹城市", "鱼台县", "金乡县", "嘉祥县", "微山县", "汶上县", "泗水县", "梁山县", "其他"],
    "children": [{
      "value": "市中区",
      "label": "市中区"
    }, {
      "value": "任城区",
      "label": "任城区"
    }, {
      "value": "曲阜市",
      "label": "曲阜市"
    }, {
      "value": "兖州市",
      "label": "兖州市"
    }, {
      "value": "邹城市",
      "label": "邹城市"
    }, {
      "value": "鱼台县",
      "label": "鱼台县"
    }, {
      "value": "金乡县",
      "label": "金乡县"
    }, {
      "value": "嘉祥县",
      "label": "嘉祥县"
    }, {
      "value": "微山县",
      "label": "微山县"
    }, {
      "value": "汶上县",
      "label": "汶上县"
    }, {
      "value": "泗水县",
      "label": "泗水县"
    }, {
      "value": "梁山县",
      "label": "梁山县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "济宁市"
  }, {
    "value": "泰安市",
    "area": ["泰山区", "岱岳区", "新泰市", "肥城市", "宁阳县", "东平县", "其他"],
    "children": [{
      "value": "泰山区",
      "label": "泰山区"
    }, {
      "value": "岱岳区",
      "label": "岱岳区"
    }, {
      "value": "新泰市",
      "label": "新泰市"
    }, {
      "value": "肥城市",
      "label": "肥城市"
    }, {
      "value": "宁阳县",
      "label": "宁阳县"
    }, {
      "value": "东平县",
      "label": "东平县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "泰安市"
  }, {
    "value": "威海市",
    "area": ["环翠区", "乳山市", "文登市", "荣成市", "其他"],
    "children": [{
      "value": "环翠区",
      "label": "环翠区"
    }, {
      "value": "乳山市",
      "label": "乳山市"
    }, {
      "value": "文登市",
      "label": "文登市"
    }, {
      "value": "荣成市",
      "label": "荣成市"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "威海市"
  }, {
    "value": "日照市",
    "area": ["东港区", "岚山区", "五莲县", "莒县", "其他"],
    "children": [{
      "value": "东港区",
      "label": "东港区"
    }, {
      "value": "岚山区",
      "label": "岚山区"
    }, {
      "value": "五莲县",
      "label": "五莲县"
    }, {
      "value": "莒县",
      "label": "莒县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "日照市"
  }, {
    "value": "莱芜市",
    "area": ["莱城区", "钢城区", "其他"],
    "children": [{
      "value": "莱城区",
      "label": "莱城区"
    }, {
      "value": "钢城区",
      "label": "钢城区"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "莱芜市"
  }, {
    "value": "临沂市",
    "area": ["兰山区", "罗庄区", "河东区", "沂南县", "郯城县", "沂水县", "苍山县", "费县", "平邑县", "莒南县", "蒙阴县", "临沭县", "其他"],
    "children": [{
      "value": "兰山区",
      "label": "兰山区"
    }, {
      "value": "罗庄区",
      "label": "罗庄区"
    }, {
      "value": "河东区",
      "label": "河东区"
    }, {
      "value": "沂南县",
      "label": "沂南县"
    }, {
      "value": "郯城县",
      "label": "郯城县"
    }, {
      "value": "沂水县",
      "label": "沂水县"
    }, {
      "value": "苍山县",
      "label": "苍山县"
    }, {
      "value": "费县",
      "label": "费县"
    }, {
      "value": "平邑县",
      "label": "平邑县"
    }, {
      "value": "莒南县",
      "label": "莒南县"
    }, {
      "value": "蒙阴县",
      "label": "蒙阴县"
    }, {
      "value": "临沭县",
      "label": "临沭县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "临沂市"
  }, {
    "value": "德州市",
    "area": ["德城区", "乐陵市", "禹城市", "陵县", "宁津县", "齐河县", "武城县", "庆云县", "平原县", "夏津县", "临邑县", "其他"],
    "children": [{
      "value": "德城区",
      "label": "德城区"
    }, {
      "value": "乐陵市",
      "label": "乐陵市"
    }, {
      "value": "禹城市",
      "label": "禹城市"
    }, {
      "value": "陵县",
      "label": "陵县"
    }, {
      "value": "宁津县",
      "label": "宁津县"
    }, {
      "value": "齐河县",
      "label": "齐河县"
    }, {
      "value": "武城县",
      "label": "武城县"
    }, {
      "value": "庆云县",
      "label": "庆云县"
    }, {
      "value": "平原县",
      "label": "平原县"
    }, {
      "value": "夏津县",
      "label": "夏津县"
    }, {
      "value": "临邑县",
      "label": "临邑县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "德州市"
  }, {
    "value": "聊城市",
    "area": ["东昌府区", "临清市", "高唐县", "阳谷县", "茌平县", "莘县", "东阿县", "冠县", "其他"],
    "children": [{
      "value": "东昌府区",
      "label": "东昌府区"
    }, {
      "value": "临清市",
      "label": "临清市"
    }, {
      "value": "高唐县",
      "label": "高唐县"
    }, {
      "value": "阳谷县",
      "label": "阳谷县"
    }, {
      "value": "茌平县",
      "label": "茌平县"
    }, {
      "value": "莘县",
      "label": "莘县"
    }, {
      "value": "东阿县",
      "label": "东阿县"
    }, {
      "value": "冠县",
      "label": "冠县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "聊城市"
  }, {
    "value": "滨州市",
    "area": ["滨城区", "邹平县", "沾化县", "惠民县", "博兴县", "阳信县", "无棣县", "其他"],
    "children": [{
      "value": "滨城区",
      "label": "滨城区"
    }, {
      "value": "邹平县",
      "label": "邹平县"
    }, {
      "value": "沾化县",
      "label": "沾化县"
    }, {
      "value": "惠民县",
      "label": "惠民县"
    }, {
      "value": "博兴县",
      "label": "博兴县"
    }, {
      "value": "阳信县",
      "label": "阳信县"
    }, {
      "value": "无棣县",
      "label": "无棣县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "滨州市"
  }, {
    "value": "菏泽市",
    "area": ["牡丹区", "鄄城县", "单县", "郓城县", "曹县", "定陶县", "巨野县", "东明县", "成武县", "其他"],
    "children": [{
      "value": "牡丹区",
      "label": "牡丹区"
    }, {
      "value": "鄄城县",
      "label": "鄄城县"
    }, {
      "value": "单县",
      "label": "单县"
    }, {
      "value": "郓城县",
      "label": "郓城县"
    }, {
      "value": "曹县",
      "label": "曹县"
    }, {
      "value": "定陶县",
      "label": "定陶县"
    }, {
      "value": "巨野县",
      "label": "巨野县"
    }, {
      "value": "东明县",
      "label": "东明县"
    }, {
      "value": "成武县",
      "label": "成武县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "菏泽市"
  }, {
    "value": "其他",
    "area": ["其他"],
    "children": [{
      "value": "其他",
      "label": "其他"
    }],
    "label": "其他"
  }],
  "label": "山东省"
}, {
  "value": "河南省",
  "children": [{
    "value": "郑州市",
    "area": ["中原区", "金水区", "二七区", "管城回族区", "上街区", "惠济区", "巩义市", "新郑市", "新密市", "登封市", "荥阳市", "中牟县", "其他"],
    "children": [{
      "value": "中原区",
      "label": "中原区"
    }, {
      "value": "金水区",
      "label": "金水区"
    }, {
      "value": "二七区",
      "label": "二七区"
    }, {
      "value": "管城回族区",
      "label": "管城回族区"
    }, {
      "value": "上街区",
      "label": "上街区"
    }, {
      "value": "惠济区",
      "label": "惠济区"
    }, {
      "value": "巩义市",
      "label": "巩义市"
    }, {
      "value": "新郑市",
      "label": "新郑市"
    }, {
      "value": "新密市",
      "label": "新密市"
    }, {
      "value": "登封市",
      "label": "登封市"
    }, {
      "value": "荥阳市",
      "label": "荥阳市"
    }, {
      "value": "中牟县",
      "label": "中牟县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "郑州市"
  }, {
    "value": "开封市",
    "area": ["鼓楼区", "龙亭区", "顺河回族区", "禹王台区", "金明区", "开封县", "尉氏县", "兰考县", "杞县", "通许县", "其他"],
    "children": [{
      "value": "鼓楼区",
      "label": "鼓楼区"
    }, {
      "value": "龙亭区",
      "label": "龙亭区"
    }, {
      "value": "顺河回族区",
      "label": "顺河回族区"
    }, {
      "value": "禹王台区",
      "label": "禹王台区"
    }, {
      "value": "金明区",
      "label": "金明区"
    }, {
      "value": "开封县",
      "label": "开封县"
    }, {
      "value": "尉氏县",
      "label": "尉氏县"
    }, {
      "value": "兰考县",
      "label": "兰考县"
    }, {
      "value": "杞县",
      "label": "杞县"
    }, {
      "value": "通许县",
      "label": "通许县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "开封市"
  }, {
    "value": "洛阳市",
    "area": ["西工区", "老城区", "涧西区", "瀍河回族区", "洛龙区", "吉利区", "偃师市", "孟津县", "汝阳县", "伊川县", "洛宁县", "嵩县", "宜阳县", "新安县", "栾川县", "其他"],
    "children": [{
      "value": "西工区",
      "label": "西工区"
    }, {
      "value": "老城区",
      "label": "老城区"
    }, {
      "value": "涧西区",
      "label": "涧西区"
    }, {
      "value": "瀍河回族区",
      "label": "瀍河回族区"
    }, {
      "value": "洛龙区",
      "label": "洛龙区"
    }, {
      "value": "吉利区",
      "label": "吉利区"
    }, {
      "value": "偃师市",
      "label": "偃师市"
    }, {
      "value": "孟津县",
      "label": "孟津县"
    }, {
      "value": "汝阳县",
      "label": "汝阳县"
    }, {
      "value": "伊川县",
      "label": "伊川县"
    }, {
      "value": "洛宁县",
      "label": "洛宁县"
    }, {
      "value": "嵩县",
      "label": "嵩县"
    }, {
      "value": "宜阳县",
      "label": "宜阳县"
    }, {
      "value": "新安县",
      "label": "新安县"
    }, {
      "value": "栾川县",
      "label": "栾川县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "洛阳市"
  }, {
    "value": "平顶山市",
    "area": ["新华区", "卫东区", "湛河区", "石龙区", "汝州市", "舞钢市", "宝丰县", "叶县", "郏县", "鲁山县", "其他"],
    "children": [{
      "value": "新华区",
      "label": "新华区"
    }, {
      "value": "卫东区",
      "label": "卫东区"
    }, {
      "value": "湛河区",
      "label": "湛河区"
    }, {
      "value": "石龙区",
      "label": "石龙区"
    }, {
      "value": "汝州市",
      "label": "汝州市"
    }, {
      "value": "舞钢市",
      "label": "舞钢市"
    }, {
      "value": "宝丰县",
      "label": "宝丰县"
    }, {
      "value": "叶县",
      "label": "叶县"
    }, {
      "value": "郏县",
      "label": "郏县"
    }, {
      "value": "鲁山县",
      "label": "鲁山县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "平顶山市"
  }, {
    "value": "安阳市",
    "area": ["北关区", "文峰区", "殷都区", "龙安区", "林州市", "安阳县", "滑县", "内黄县", "汤阴县", "其他"],
    "children": [{
      "value": "北关区",
      "label": "北关区"
    }, {
      "value": "文峰区",
      "label": "文峰区"
    }, {
      "value": "殷都区",
      "label": "殷都区"
    }, {
      "value": "龙安区",
      "label": "龙安区"
    }, {
      "value": "林州市",
      "label": "林州市"
    }, {
      "value": "安阳县",
      "label": "安阳县"
    }, {
      "value": "滑县",
      "label": "滑县"
    }, {
      "value": "内黄县",
      "label": "内黄县"
    }, {
      "value": "汤阴县",
      "label": "汤阴县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "安阳市"
  }, {
    "value": "鹤壁市",
    "area": ["淇滨区", "山城区", "鹤山区", "浚县", "淇县", "其他"],
    "children": [{
      "value": "淇滨区",
      "label": "淇滨区"
    }, {
      "value": "山城区",
      "label": "山城区"
    }, {
      "value": "鹤山区",
      "label": "鹤山区"
    }, {
      "value": "浚县",
      "label": "浚县"
    }, {
      "value": "淇县",
      "label": "淇县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "鹤壁市"
  }, {
    "value": "新乡市",
    "area": ["卫滨区", "红旗区", "凤泉区", "牧野区", "卫辉市", "辉县市", "新乡县", "获嘉县", "原阳县", "长垣县", "封丘县", "延津县", "其他"],
    "children": [{
      "value": "卫滨区",
      "label": "卫滨区"
    }, {
      "value": "红旗区",
      "label": "红旗区"
    }, {
      "value": "凤泉区",
      "label": "凤泉区"
    }, {
      "value": "牧野区",
      "label": "牧野区"
    }, {
      "value": "卫辉市",
      "label": "卫辉市"
    }, {
      "value": "辉县市",
      "label": "辉县市"
    }, {
      "value": "新乡县",
      "label": "新乡县"
    }, {
      "value": "获嘉县",
      "label": "获嘉县"
    }, {
      "value": "原阳县",
      "label": "原阳县"
    }, {
      "value": "长垣县",
      "label": "长垣县"
    }, {
      "value": "封丘县",
      "label": "封丘县"
    }, {
      "value": "延津县",
      "label": "延津县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "新乡市"
  }, {
    "value": "焦作市",
    "area": ["解放区", "中站区", "马村区", "山阳区", "沁阳市", "孟州市", "修武县", "温县", "武陟县", "博爱县", "其他"],
    "children": [{
      "value": "解放区",
      "label": "解放区"
    }, {
      "value": "中站区",
      "label": "中站区"
    }, {
      "value": "马村区",
      "label": "马村区"
    }, {
      "value": "山阳区",
      "label": "山阳区"
    }, {
      "value": "沁阳市",
      "label": "沁阳市"
    }, {
      "value": "孟州市",
      "label": "孟州市"
    }, {
      "value": "修武县",
      "label": "修武县"
    }, {
      "value": "温县",
      "label": "温县"
    }, {
      "value": "武陟县",
      "label": "武陟县"
    }, {
      "value": "博爱县",
      "label": "博爱县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "焦作市"
  }, {
    "value": "濮阳市",
    "area": ["华龙区", "濮阳县", "南乐县", "台前县", "清丰县", "范县", "其他"],
    "children": [{
      "value": "华龙区",
      "label": "华龙区"
    }, {
      "value": "濮阳县",
      "label": "濮阳县"
    }, {
      "value": "南乐县",
      "label": "南乐县"
    }, {
      "value": "台前县",
      "label": "台前县"
    }, {
      "value": "清丰县",
      "label": "清丰县"
    }, {
      "value": "范县",
      "label": "范县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "濮阳市"
  }, {
    "value": "许昌市",
    "area": ["魏都区", "禹州市", "长葛市", "许昌县", "鄢陵县", "襄城县", "其他"],
    "children": [{
      "value": "魏都区",
      "label": "魏都区"
    }, {
      "value": "禹州市",
      "label": "禹州市"
    }, {
      "value": "长葛市",
      "label": "长葛市"
    }, {
      "value": "许昌县",
      "label": "许昌县"
    }, {
      "value": "鄢陵县",
      "label": "鄢陵县"
    }, {
      "value": "襄城县",
      "label": "襄城县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "许昌市"
  }, {
    "value": "漯河市",
    "area": ["源汇区", "郾城区", "召陵区", "临颍县", "舞阳县", "其他"],
    "children": [{
      "value": "源汇区",
      "label": "源汇区"
    }, {
      "value": "郾城区",
      "label": "郾城区"
    }, {
      "value": "召陵区",
      "label": "召陵区"
    }, {
      "value": "临颍县",
      "label": "临颍县"
    }, {
      "value": "舞阳县",
      "label": "舞阳县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "漯河市"
  }, {
    "value": "三门峡市",
    "area": ["湖滨区", "义马市", "灵宝市", "渑池县", "卢氏县", "陕县", "其他"],
    "children": [{
      "value": "湖滨区",
      "label": "湖滨区"
    }, {
      "value": "义马市",
      "label": "义马市"
    }, {
      "value": "灵宝市",
      "label": "灵宝市"
    }, {
      "value": "渑池县",
      "label": "渑池县"
    }, {
      "value": "卢氏县",
      "label": "卢氏县"
    }, {
      "value": "陕县",
      "label": "陕县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "三门峡市"
  }, {
    "value": "南阳市",
    "area": ["卧龙区", "宛城区", "邓州市", "桐柏县", "方城县", "淅川县", "镇平县", "唐河县", "南召县", "内乡县", "新野县", "社旗县", "西峡县", "其他"],
    "children": [{
      "value": "卧龙区",
      "label": "卧龙区"
    }, {
      "value": "宛城区",
      "label": "宛城区"
    }, {
      "value": "邓州市",
      "label": "邓州市"
    }, {
      "value": "桐柏县",
      "label": "桐柏县"
    }, {
      "value": "方城县",
      "label": "方城县"
    }, {
      "value": "淅川县",
      "label": "淅川县"
    }, {
      "value": "镇平县",
      "label": "镇平县"
    }, {
      "value": "唐河县",
      "label": "唐河县"
    }, {
      "value": "南召县",
      "label": "南召县"
    }, {
      "value": "内乡县",
      "label": "内乡县"
    }, {
      "value": "新野县",
      "label": "新野县"
    }, {
      "value": "社旗县",
      "label": "社旗县"
    }, {
      "value": "西峡县",
      "label": "西峡县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "南阳市"
  }, {
    "value": "商丘市",
    "area": ["梁园区", "睢阳区", "永城市", "宁陵县", "虞城县", "民权县", "夏邑县", "柘城县", "睢县", "其他"],
    "children": [{
      "value": "梁园区",
      "label": "梁园区"
    }, {
      "value": "睢阳区",
      "label": "睢阳区"
    }, {
      "value": "永城市",
      "label": "永城市"
    }, {
      "value": "宁陵县",
      "label": "宁陵县"
    }, {
      "value": "虞城县",
      "label": "虞城县"
    }, {
      "value": "民权县",
      "label": "民权县"
    }, {
      "value": "夏邑县",
      "label": "夏邑县"
    }, {
      "value": "柘城县",
      "label": "柘城县"
    }, {
      "value": "睢县",
      "label": "睢县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "商丘市"
  }, {
    "value": "信阳市",
    "area": ["浉河区", "平桥区", "潢川县", "淮滨县", "息县", "新县", "商城县", "固始县", "罗山县", "光山县", "其他"],
    "children": [{
      "value": "浉河区",
      "label": "浉河区"
    }, {
      "value": "平桥区",
      "label": "平桥区"
    }, {
      "value": "潢川县",
      "label": "潢川县"
    }, {
      "value": "淮滨县",
      "label": "淮滨县"
    }, {
      "value": "息县",
      "label": "息县"
    }, {
      "value": "新县",
      "label": "新县"
    }, {
      "value": "商城县",
      "label": "商城县"
    }, {
      "value": "固始县",
      "label": "固始县"
    }, {
      "value": "罗山县",
      "label": "罗山县"
    }, {
      "value": "光山县",
      "label": "光山县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "信阳市"
  }, {
    "value": "周口市",
    "area": ["川汇区", "项城市", "商水县", "淮阳县", "太康县", "鹿邑县", "西华县", "扶沟县", "沈丘县", "郸城县", "其他"],
    "children": [{
      "value": "川汇区",
      "label": "川汇区"
    }, {
      "value": "项城市",
      "label": "项城市"
    }, {
      "value": "商水县",
      "label": "商水县"
    }, {
      "value": "淮阳县",
      "label": "淮阳县"
    }, {
      "value": "太康县",
      "label": "太康县"
    }, {
      "value": "鹿邑县",
      "label": "鹿邑县"
    }, {
      "value": "西华县",
      "label": "西华县"
    }, {
      "value": "扶沟县",
      "label": "扶沟县"
    }, {
      "value": "沈丘县",
      "label": "沈丘县"
    }, {
      "value": "郸城县",
      "label": "郸城县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "周口市"
  }, {
    "value": "驻马店市",
    "area": ["驿城区", "确山县", "新蔡县", "上蔡县", "西平县", "泌阳县", "平舆县", "汝南县", "遂平县", "正阳县", "其他"],
    "children": [{
      "value": "驿城区",
      "label": "驿城区"
    }, {
      "value": "确山县",
      "label": "确山县"
    }, {
      "value": "新蔡县",
      "label": "新蔡县"
    }, {
      "value": "上蔡县",
      "label": "上蔡县"
    }, {
      "value": "西平县",
      "label": "西平县"
    }, {
      "value": "泌阳县",
      "label": "泌阳县"
    }, {
      "value": "平舆县",
      "label": "平舆县"
    }, {
      "value": "汝南县",
      "label": "汝南县"
    }, {
      "value": "遂平县",
      "label": "遂平县"
    }, {
      "value": "正阳县",
      "label": "正阳县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "驻马店市"
  }, {
    "value": "焦作市",
    "area": ["济源市", "其他"],
    "children": [{
      "value": "济源市",
      "label": "济源市"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "焦作市"
  }, {
    "value": "其他",
    "area": ["其他"],
    "children": [{
      "value": "其他",
      "label": "其他"
    }],
    "label": "其他"
  }],
  "label": "河南省"
}, {
  "value": "湖北省",
  "children": [{
    "value": "武汉市",
    "area": ["江岸区", "武昌区", "江汉区", "硚口区", "汉阳区", "青山区", "洪山区", "东西湖区", "汉南区", "蔡甸区", "江夏区", "黄陂区", "新洲区", "其他"],
    "children": [{
      "value": "江岸区",
      "label": "江岸区"
    }, {
      "value": "武昌区",
      "label": "武昌区"
    }, {
      "value": "江汉区",
      "label": "江汉区"
    }, {
      "value": "硚口区",
      "label": "硚口区"
    }, {
      "value": "汉阳区",
      "label": "汉阳区"
    }, {
      "value": "青山区",
      "label": "青山区"
    }, {
      "value": "洪山区",
      "label": "洪山区"
    }, {
      "value": "东西湖区",
      "label": "东西湖区"
    }, {
      "value": "汉南区",
      "label": "汉南区"
    }, {
      "value": "蔡甸区",
      "label": "蔡甸区"
    }, {
      "value": "江夏区",
      "label": "江夏区"
    }, {
      "value": "黄陂区",
      "label": "黄陂区"
    }, {
      "value": "新洲区",
      "label": "新洲区"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "武汉市"
  }, {
    "value": "黄石市",
    "area": ["黄石港区", "西塞山区", "下陆区", "铁山区", "大冶市", "阳新县", "其他"],
    "children": [{
      "value": "黄石港区",
      "label": "黄石港区"
    }, {
      "value": "西塞山区",
      "label": "西塞山区"
    }, {
      "value": "下陆区",
      "label": "下陆区"
    }, {
      "value": "铁山区",
      "label": "铁山区"
    }, {
      "value": "大冶市",
      "label": "大冶市"
    }, {
      "value": "阳新县",
      "label": "阳新县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "黄石市"
  }, {
    "value": "十堰市",
    "area": ["张湾区", "茅箭区", "丹江口市", "郧县", "竹山县", "房县", "郧西县", "竹溪县", "其他"],
    "children": [{
      "value": "张湾区",
      "label": "张湾区"
    }, {
      "value": "茅箭区",
      "label": "茅箭区"
    }, {
      "value": "丹江口市",
      "label": "丹江口市"
    }, {
      "value": "郧县",
      "label": "郧县"
    }, {
      "value": "竹山县",
      "label": "竹山县"
    }, {
      "value": "房县",
      "label": "房县"
    }, {
      "value": "郧西县",
      "label": "郧西县"
    }, {
      "value": "竹溪县",
      "label": "竹溪县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "十堰市"
  }, {
    "value": "荆州市",
    "area": ["沙市区", "荆州区", "洪湖市", "石首市", "松滋市", "监利县", "公安县", "江陵县", "其他"],
    "children": [{
      "value": "沙市区",
      "label": "沙市区"
    }, {
      "value": "荆州区",
      "label": "荆州区"
    }, {
      "value": "洪湖市",
      "label": "洪湖市"
    }, {
      "value": "石首市",
      "label": "石首市"
    }, {
      "value": "松滋市",
      "label": "松滋市"
    }, {
      "value": "监利县",
      "label": "监利县"
    }, {
      "value": "公安县",
      "label": "公安县"
    }, {
      "value": "江陵县",
      "label": "江陵县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "荆州市"
  }, {
    "value": "宜昌市",
    "area": ["西陵区", "伍家岗区", "点军区", "猇亭区", "夷陵区", "宜都市", "当阳市", "枝江市", "秭归县", "远安县", "兴山县", "五峰土家族自治县", "长阳土家族自治县", "其他"],
    "children": [{
      "value": "西陵区",
      "label": "西陵区"
    }, {
      "value": "伍家岗区",
      "label": "伍家岗区"
    }, {
      "value": "点军区",
      "label": "点军区"
    }, {
      "value": "猇亭区",
      "label": "猇亭区"
    }, {
      "value": "夷陵区",
      "label": "夷陵区"
    }, {
      "value": "宜都市",
      "label": "宜都市"
    }, {
      "value": "当阳市",
      "label": "当阳市"
    }, {
      "value": "枝江市",
      "label": "枝江市"
    }, {
      "value": "秭归县",
      "label": "秭归县"
    }, {
      "value": "远安县",
      "label": "远安县"
    }, {
      "value": "兴山县",
      "label": "兴山县"
    }, {
      "value": "五峰土家族自治县",
      "label": "五峰土家族自治县"
    }, {
      "value": "长阳土家族自治县",
      "label": "长阳土家族自治县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "宜昌市"
  }, {
    "value": "襄樊市",
    "area": ["襄城区", "樊城区", "襄阳区", "老河口市", "枣阳市", "宜城市", "南漳县", "谷城县", "保康县", "其他"],
    "children": [{
      "value": "襄城区",
      "label": "襄城区"
    }, {
      "value": "樊城区",
      "label": "樊城区"
    }, {
      "value": "襄阳区",
      "label": "襄阳区"
    }, {
      "value": "老河口市",
      "label": "老河口市"
    }, {
      "value": "枣阳市",
      "label": "枣阳市"
    }, {
      "value": "宜城市",
      "label": "宜城市"
    }, {
      "value": "南漳县",
      "label": "南漳县"
    }, {
      "value": "谷城县",
      "label": "谷城县"
    }, {
      "value": "保康县",
      "label": "保康县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "襄樊市"
  }, {
    "value": "鄂州市",
    "area": ["鄂城区", "华容区", "梁子湖区", "其他"],
    "children": [{
      "value": "鄂城区",
      "label": "鄂城区"
    }, {
      "value": "华容区",
      "label": "华容区"
    }, {
      "value": "梁子湖区",
      "label": "梁子湖区"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "鄂州市"
  }, {
    "value": "荆门市",
    "area": ["东宝区", "掇刀区", "钟祥市", "京山县", "沙洋县", "其他"],
    "children": [{
      "value": "东宝区",
      "label": "东宝区"
    }, {
      "value": "掇刀区",
      "label": "掇刀区"
    }, {
      "value": "钟祥市",
      "label": "钟祥市"
    }, {
      "value": "京山县",
      "label": "京山县"
    }, {
      "value": "沙洋县",
      "label": "沙洋县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "荆门市"
  }, {
    "value": "孝感市",
    "area": ["孝南区", "应城市", "安陆市", "汉川市", "云梦县", "大悟县", "孝昌县", "其他"],
    "children": [{
      "value": "孝南区",
      "label": "孝南区"
    }, {
      "value": "应城市",
      "label": "应城市"
    }, {
      "value": "安陆市",
      "label": "安陆市"
    }, {
      "value": "汉川市",
      "label": "汉川市"
    }, {
      "value": "云梦县",
      "label": "云梦县"
    }, {
      "value": "大悟县",
      "label": "大悟县"
    }, {
      "value": "孝昌县",
      "label": "孝昌县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "孝感市"
  }, {
    "value": "黄冈市",
    "area": ["黄州区", "麻城市", "武穴市", "红安县", "罗田县", "浠水县", "蕲春县", "黄梅县", "英山县", "团风县", "其他"],
    "children": [{
      "value": "黄州区",
      "label": "黄州区"
    }, {
      "value": "麻城市",
      "label": "麻城市"
    }, {
      "value": "武穴市",
      "label": "武穴市"
    }, {
      "value": "红安县",
      "label": "红安县"
    }, {
      "value": "罗田县",
      "label": "罗田县"
    }, {
      "value": "浠水县",
      "label": "浠水县"
    }, {
      "value": "蕲春县",
      "label": "蕲春县"
    }, {
      "value": "黄梅县",
      "label": "黄梅县"
    }, {
      "value": "英山县",
      "label": "英山县"
    }, {
      "value": "团风县",
      "label": "团风县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "黄冈市"
  }, {
    "value": "咸宁市",
    "area": ["咸安区", "赤壁市", "嘉鱼县", "通山县", "崇阳县", "通城县", "其他"],
    "children": [{
      "value": "咸安区",
      "label": "咸安区"
    }, {
      "value": "赤壁市",
      "label": "赤壁市"
    }, {
      "value": "嘉鱼县",
      "label": "嘉鱼县"
    }, {
      "value": "通山县",
      "label": "通山县"
    }, {
      "value": "崇阳县",
      "label": "崇阳县"
    }, {
      "value": "通城县",
      "label": "通城县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "咸宁市"
  }, {
    "value": "随州市",
    "area": ["曾都区", "广水市", "其他"],
    "children": [{
      "value": "曾都区",
      "label": "曾都区"
    }, {
      "value": "广水市",
      "label": "广水市"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "随州市"
  }, {
    "value": "恩施土家族苗族自治州",
    "area": ["恩施市", "利川市", "建始县", "来凤县", "巴东县", "鹤峰县", "宣恩县", "咸丰县", "其他"],
    "children": [{
      "value": "恩施市",
      "label": "恩施市"
    }, {
      "value": "利川市",
      "label": "利川市"
    }, {
      "value": "建始县",
      "label": "建始县"
    }, {
      "value": "来凤县",
      "label": "来凤县"
    }, {
      "value": "巴东县",
      "label": "巴东县"
    }, {
      "value": "鹤峰县",
      "label": "鹤峰县"
    }, {
      "value": "宣恩县",
      "label": "宣恩县"
    }, {
      "value": "咸丰县",
      "label": "咸丰县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "恩施土家族苗族自治州"
  }, {
    "value": "仙桃市",
    "area": ["仙桃"],
    "children": [{
      "value": "仙桃",
      "label": "仙桃"
    }],
    "label": "仙桃市"
  }, {
    "value": "天门市",
    "area": ["天门"],
    "children": [{
      "value": "天门",
      "label": "天门"
    }],
    "label": "天门市"
  }, {
    "value": "潜江市",
    "area": ["潜江"],
    "children": [{
      "value": "潜江",
      "label": "潜江"
    }],
    "label": "潜江市"
  }, {
    "value": "神农架林区",
    "area": ["神农架林区"],
    "children": [{
      "value": "神农架林区",
      "label": "神农架林区"
    }],
    "label": "神农架林区"
  }, {
    "value": "其他",
    "area": ["其他"],
    "children": [{
      "value": "其他",
      "label": "其他"
    }],
    "label": "其他"
  }],
  "label": "湖北省"
}, {
  "value": "湖南省",
  "children": [{
    "value": "长沙市",
    "area": ["岳麓区", "芙蓉区", "天心区", "开福区", "雨花区", "浏阳市", "长沙县", "望城县", "宁乡县", "其他"],
    "children": [{
      "value": "岳麓区",
      "label": "岳麓区"
    }, {
      "value": "芙蓉区",
      "label": "芙蓉区"
    }, {
      "value": "天心区",
      "label": "天心区"
    }, {
      "value": "开福区",
      "label": "开福区"
    }, {
      "value": "雨花区",
      "label": "雨花区"
    }, {
      "value": "浏阳市",
      "label": "浏阳市"
    }, {
      "value": "长沙县",
      "label": "长沙县"
    }, {
      "value": "望城县",
      "label": "望城县"
    }, {
      "value": "宁乡县",
      "label": "宁乡县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "长沙市"
  }, {
    "value": "株洲市",
    "area": ["天元区", "荷塘区", "芦淞区", "石峰区", "醴陵市", "株洲县", "炎陵县", "茶陵县", "攸县", "其他"],
    "children": [{
      "value": "天元区",
      "label": "天元区"
    }, {
      "value": "荷塘区",
      "label": "荷塘区"
    }, {
      "value": "芦淞区",
      "label": "芦淞区"
    }, {
      "value": "石峰区",
      "label": "石峰区"
    }, {
      "value": "醴陵市",
      "label": "醴陵市"
    }, {
      "value": "株洲县",
      "label": "株洲县"
    }, {
      "value": "炎陵县",
      "label": "炎陵县"
    }, {
      "value": "茶陵县",
      "label": "茶陵县"
    }, {
      "value": "攸县",
      "label": "攸县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "株洲市"
  }, {
    "value": "湘潭市",
    "area": ["岳塘区", "雨湖区", "湘乡市", "韶山市", "湘潭县", "其他"],
    "children": [{
      "value": "岳塘区",
      "label": "岳塘区"
    }, {
      "value": "雨湖区",
      "label": "雨湖区"
    }, {
      "value": "湘乡市",
      "label": "湘乡市"
    }, {
      "value": "韶山市",
      "label": "韶山市"
    }, {
      "value": "湘潭县",
      "label": "湘潭县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "湘潭市"
  }, {
    "value": "衡阳市",
    "area": ["雁峰区", "珠晖区", "石鼓区", "蒸湘区", "南岳区", "耒阳市", "常宁市", "衡阳县", "衡东县", "衡山县", "衡南县", "祁东县", "其他"],
    "children": [{
      "value": "雁峰区",
      "label": "雁峰区"
    }, {
      "value": "珠晖区",
      "label": "珠晖区"
    }, {
      "value": "石鼓区",
      "label": "石鼓区"
    }, {
      "value": "蒸湘区",
      "label": "蒸湘区"
    }, {
      "value": "南岳区",
      "label": "南岳区"
    }, {
      "value": "耒阳市",
      "label": "耒阳市"
    }, {
      "value": "常宁市",
      "label": "常宁市"
    }, {
      "value": "衡阳县",
      "label": "衡阳县"
    }, {
      "value": "衡东县",
      "label": "衡东县"
    }, {
      "value": "衡山县",
      "label": "衡山县"
    }, {
      "value": "衡南县",
      "label": "衡南县"
    }, {
      "value": "祁东县",
      "label": "祁东县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "衡阳市"
  }, {
    "value": "邵阳市",
    "area": ["双清区", "大祥区", "北塔区", "武冈市", "邵东县", "洞口县", "新邵县", "绥宁县", "新宁县", "邵阳县", "隆回县", "城步苗族自治县", "其他"],
    "children": [{
      "value": "双清区",
      "label": "双清区"
    }, {
      "value": "大祥区",
      "label": "大祥区"
    }, {
      "value": "北塔区",
      "label": "北塔区"
    }, {
      "value": "武冈市",
      "label": "武冈市"
    }, {
      "value": "邵东县",
      "label": "邵东县"
    }, {
      "value": "洞口县",
      "label": "洞口县"
    }, {
      "value": "新邵县",
      "label": "新邵县"
    }, {
      "value": "绥宁县",
      "label": "绥宁县"
    }, {
      "value": "新宁县",
      "label": "新宁县"
    }, {
      "value": "邵阳县",
      "label": "邵阳县"
    }, {
      "value": "隆回县",
      "label": "隆回县"
    }, {
      "value": "城步苗族自治县",
      "label": "城步苗族自治县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "邵阳市"
  }, {
    "value": "岳阳市",
    "area": ["岳阳楼区", "云溪区", "君山区", "临湘市", "汨罗市", "岳阳县", "湘阴县", "平江县", "华容县", "其他"],
    "children": [{
      "value": "岳阳楼区",
      "label": "岳阳楼区"
    }, {
      "value": "云溪区",
      "label": "云溪区"
    }, {
      "value": "君山区",
      "label": "君山区"
    }, {
      "value": "临湘市",
      "label": "临湘市"
    }, {
      "value": "汨罗市",
      "label": "汨罗市"
    }, {
      "value": "岳阳县",
      "label": "岳阳县"
    }, {
      "value": "湘阴县",
      "label": "湘阴县"
    }, {
      "value": "平江县",
      "label": "平江县"
    }, {
      "value": "华容县",
      "label": "华容县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "岳阳市"
  }, {
    "value": "常德市",
    "area": ["武陵区", "鼎城区", "津市市", "澧县", "临澧县", "桃源县", "汉寿县", "安乡县", "石门县", "其他"],
    "children": [{
      "value": "武陵区",
      "label": "武陵区"
    }, {
      "value": "鼎城区",
      "label": "鼎城区"
    }, {
      "value": "津市市",
      "label": "津市市"
    }, {
      "value": "澧县",
      "label": "澧县"
    }, {
      "value": "临澧县",
      "label": "临澧县"
    }, {
      "value": "桃源县",
      "label": "桃源县"
    }, {
      "value": "汉寿县",
      "label": "汉寿县"
    }, {
      "value": "安乡县",
      "label": "安乡县"
    }, {
      "value": "石门县",
      "label": "石门县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "常德市"
  }, {
    "value": "张家界市",
    "area": ["永定区", "武陵源区", "慈利县", "桑植县", "其他"],
    "children": [{
      "value": "永定区",
      "label": "永定区"
    }, {
      "value": "武陵源区",
      "label": "武陵源区"
    }, {
      "value": "慈利县",
      "label": "慈利县"
    }, {
      "value": "桑植县",
      "label": "桑植县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "张家界市"
  }, {
    "value": "益阳市",
    "area": ["赫山区", "资阳区", "沅江市", "桃江县", "南县", "安化县", "其他"],
    "children": [{
      "value": "赫山区",
      "label": "赫山区"
    }, {
      "value": "资阳区",
      "label": "资阳区"
    }, {
      "value": "沅江市",
      "label": "沅江市"
    }, {
      "value": "桃江县",
      "label": "桃江县"
    }, {
      "value": "南县",
      "label": "南县"
    }, {
      "value": "安化县",
      "label": "安化县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "益阳市"
  }, {
    "value": "郴州市",
    "area": ["北湖区", "苏仙区", "资兴市", "宜章县", "汝城县", "安仁县", "嘉禾县", "临武县", "桂东县", "永兴县", "桂阳县", "其他"],
    "children": [{
      "value": "北湖区",
      "label": "北湖区"
    }, {
      "value": "苏仙区",
      "label": "苏仙区"
    }, {
      "value": "资兴市",
      "label": "资兴市"
    }, {
      "value": "宜章县",
      "label": "宜章县"
    }, {
      "value": "汝城县",
      "label": "汝城县"
    }, {
      "value": "安仁县",
      "label": "安仁县"
    }, {
      "value": "嘉禾县",
      "label": "嘉禾县"
    }, {
      "value": "临武县",
      "label": "临武县"
    }, {
      "value": "桂东县",
      "label": "桂东县"
    }, {
      "value": "永兴县",
      "label": "永兴县"
    }, {
      "value": "桂阳县",
      "label": "桂阳县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "郴州市"
  }, {
    "value": "永州市",
    "area": ["冷水滩区", "零陵区", "祁阳县", "蓝山县", "宁远县", "新田县", "东安县", "江永县", "道县", "双牌县", "江华瑶族自治县", "其他"],
    "children": [{
      "value": "冷水滩区",
      "label": "冷水滩区"
    }, {
      "value": "零陵区",
      "label": "零陵区"
    }, {
      "value": "祁阳县",
      "label": "祁阳县"
    }, {
      "value": "蓝山县",
      "label": "蓝山县"
    }, {
      "value": "宁远县",
      "label": "宁远县"
    }, {
      "value": "新田县",
      "label": "新田县"
    }, {
      "value": "东安县",
      "label": "东安县"
    }, {
      "value": "江永县",
      "label": "江永县"
    }, {
      "value": "道县",
      "label": "道县"
    }, {
      "value": "双牌县",
      "label": "双牌县"
    }, {
      "value": "江华瑶族自治县",
      "label": "江华瑶族自治县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "永州市"
  }, {
    "value": "怀化市",
    "area": ["鹤城区", "洪江市", "会同县", "沅陵县", "辰溪县", "溆浦县", "中方县", "新晃侗族自治县", "芷江侗族自治县", "通道侗族自治县", "靖州苗族侗族自治县", "麻阳苗族自治县", "其他"],
    "children": [{
      "value": "鹤城区",
      "label": "鹤城区"
    }, {
      "value": "洪江市",
      "label": "洪江市"
    }, {
      "value": "会同县",
      "label": "会同县"
    }, {
      "value": "沅陵县",
      "label": "沅陵县"
    }, {
      "value": "辰溪县",
      "label": "辰溪县"
    }, {
      "value": "溆浦县",
      "label": "溆浦县"
    }, {
      "value": "中方县",
      "label": "中方县"
    }, {
      "value": "新晃侗族自治县",
      "label": "新晃侗族自治县"
    }, {
      "value": "芷江侗族自治县",
      "label": "芷江侗族自治县"
    }, {
      "value": "通道侗族自治县",
      "label": "通道侗族自治县"
    }, {
      "value": "靖州苗族侗族自治县",
      "label": "靖州苗族侗族自治县"
    }, {
      "value": "麻阳苗族自治县",
      "label": "麻阳苗族自治县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "怀化市"
  }, {
    "value": "娄底市",
    "area": ["娄星区", "冷水江市", "涟源市", "新化县", "双峰县", "其他"],
    "children": [{
      "value": "娄星区",
      "label": "娄星区"
    }, {
      "value": "冷水江市",
      "label": "冷水江市"
    }, {
      "value": "涟源市",
      "label": "涟源市"
    }, {
      "value": "新化县",
      "label": "新化县"
    }, {
      "value": "双峰县",
      "label": "双峰县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "娄底市"
  }, {
    "value": "湘西土家族苗族自治州",
    "area": ["吉首市", "古丈县", "龙山县", "永顺县", "凤凰县", "泸溪县", "保靖县", "花垣县", "其他"],
    "children": [{
      "value": "吉首市",
      "label": "吉首市"
    }, {
      "value": "古丈县",
      "label": "古丈县"
    }, {
      "value": "龙山县",
      "label": "龙山县"
    }, {
      "value": "永顺县",
      "label": "永顺县"
    }, {
      "value": "凤凰县",
      "label": "凤凰县"
    }, {
      "value": "泸溪县",
      "label": "泸溪县"
    }, {
      "value": "保靖县",
      "label": "保靖县"
    }, {
      "value": "花垣县",
      "label": "花垣县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "湘西土家族苗族自治州"
  }, {
    "value": "其他",
    "area": ["其他"],
    "children": [{
      "value": "其他",
      "label": "其他"
    }],
    "label": "其他"
  }],
  "label": "湖南省"
}, {
  "value": "广东省",
  "children": [{
    "value": "广州市",
    "area": ["越秀区", "荔湾区", "海珠区", "天河区", "白云区", "黄埔区", "番禺区", "花都区", "南沙区", "萝岗区", "增城市", "从化市", "其他"],
    "children": [{
      "value": "越秀区",
      "label": "越秀区"
    }, {
      "value": "荔湾区",
      "label": "荔湾区"
    }, {
      "value": "海珠区",
      "label": "海珠区"
    }, {
      "value": "天河区",
      "label": "天河区"
    }, {
      "value": "白云区",
      "label": "白云区"
    }, {
      "value": "黄埔区",
      "label": "黄埔区"
    }, {
      "value": "番禺区",
      "label": "番禺区"
    }, {
      "value": "花都区",
      "label": "花都区"
    }, {
      "value": "南沙区",
      "label": "南沙区"
    }, {
      "value": "萝岗区",
      "label": "萝岗区"
    }, {
      "value": "增城市",
      "label": "增城市"
    }, {
      "value": "从化市",
      "label": "从化市"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "广州市"
  }, {
    "value": "深圳市",
    "area": ["福田区", "罗湖区", "南山区", "宝安区", "龙岗区", "盐田区", "其他"],
    "children": [{
      "value": "福田区",
      "label": "福田区"
    }, {
      "value": "罗湖区",
      "label": "罗湖区"
    }, {
      "value": "南山区",
      "label": "南山区"
    }, {
      "value": "宝安区",
      "label": "宝安区"
    }, {
      "value": "龙岗区",
      "label": "龙岗区"
    }, {
      "value": "盐田区",
      "label": "盐田区"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "深圳市"
  }, {
    "value": "东莞市",
    "area": ["莞城", "常平", "塘厦", "塘厦", "塘厦", "其他"],
    "children": [{
      "value": "莞城",
      "label": "莞城"
    }, {
      "value": "常平",
      "label": "常平"
    }, {
      "value": "塘厦",
      "label": "塘厦"
    }, {
      "value": "塘厦",
      "label": "塘厦"
    }, {
      "value": "塘厦",
      "label": "塘厦"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "东莞市"
  }, {
    "value": "中山市",
    "area": ["中山"],
    "children": [{
      "value": "中山",
      "label": "中山"
    }],
    "label": "中山市"
  }, {
    "value": "潮州市",
    "area": ["湘桥区", "潮安县", "饶平县", "其他"],
    "children": [{
      "value": "湘桥区",
      "label": "湘桥区"
    }, {
      "value": "潮安县",
      "label": "潮安县"
    }, {
      "value": "饶平县",
      "label": "饶平县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "潮州市"
  }, {
    "value": "揭阳市",
    "area": ["榕城区", "揭东县", "揭西县", "惠来县", "普宁市", "其他"],
    "children": [{
      "value": "榕城区",
      "label": "榕城区"
    }, {
      "value": "揭东县",
      "label": "揭东县"
    }, {
      "value": "揭西县",
      "label": "揭西县"
    }, {
      "value": "惠来县",
      "label": "惠来县"
    }, {
      "value": "普宁市",
      "label": "普宁市"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "揭阳市"
  }, {
    "value": "云浮市",
    "area": ["云城区", "新兴县", "郁南县", "云安县", "罗定市", "其他"],
    "children": [{
      "value": "云城区",
      "label": "云城区"
    }, {
      "value": "新兴县",
      "label": "新兴县"
    }, {
      "value": "郁南县",
      "label": "郁南县"
    }, {
      "value": "云安县",
      "label": "云安县"
    }, {
      "value": "罗定市",
      "label": "罗定市"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "云浮市"
  }, {
    "value": "珠海市",
    "area": ["香洲区", "斗门区", "金湾区", "其他"],
    "children": [{
      "value": "香洲区",
      "label": "香洲区"
    }, {
      "value": "斗门区",
      "label": "斗门区"
    }, {
      "value": "金湾区",
      "label": "金湾区"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "珠海市"
  }, {
    "value": "汕头市",
    "area": ["金平区", "濠江区", "龙湖区", "潮阳区", "潮南区", "澄海区", "南澳县", "其他"],
    "children": [{
      "value": "金平区",
      "label": "金平区"
    }, {
      "value": "濠江区",
      "label": "濠江区"
    }, {
      "value": "龙湖区",
      "label": "龙湖区"
    }, {
      "value": "潮阳区",
      "label": "潮阳区"
    }, {
      "value": "潮南区",
      "label": "潮南区"
    }, {
      "value": "澄海区",
      "label": "澄海区"
    }, {
      "value": "南澳县",
      "label": "南澳县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "汕头市"
  }, {
    "value": "韶关市",
    "area": ["浈江区", "武江区", "曲江区", "乐昌市", "南雄市", "始兴县", "仁化县", "翁源县", "新丰县", "乳源瑶族自治县", "其他"],
    "children": [{
      "value": "浈江区",
      "label": "浈江区"
    }, {
      "value": "武江区",
      "label": "武江区"
    }, {
      "value": "曲江区",
      "label": "曲江区"
    }, {
      "value": "乐昌市",
      "label": "乐昌市"
    }, {
      "value": "南雄市",
      "label": "南雄市"
    }, {
      "value": "始兴县",
      "label": "始兴县"
    }, {
      "value": "仁化县",
      "label": "仁化县"
    }, {
      "value": "翁源县",
      "label": "翁源县"
    }, {
      "value": "新丰县",
      "label": "新丰县"
    }, {
      "value": "乳源瑶族自治县",
      "label": "乳源瑶族自治县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "韶关市"
  }, {
    "value": "佛山市",
    "area": ["禅城区", "南海区", "顺德区", "三水区", "高明区", "其他"],
    "children": [{
      "value": "禅城区",
      "label": "禅城区"
    }, {
      "value": "南海区",
      "label": "南海区"
    }, {
      "value": "顺德区",
      "label": "顺德区"
    }, {
      "value": "三水区",
      "label": "三水区"
    }, {
      "value": "高明区",
      "label": "高明区"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "佛山市"
  }, {
    "value": "江门市",
    "area": ["蓬江区", "江海区", "新会区", "恩平市", "台山市", "开平市", "鹤山市", "其他"],
    "children": [{
      "value": "蓬江区",
      "label": "蓬江区"
    }, {
      "value": "江海区",
      "label": "江海区"
    }, {
      "value": "新会区",
      "label": "新会区"
    }, {
      "value": "恩平市",
      "label": "恩平市"
    }, {
      "value": "台山市",
      "label": "台山市"
    }, {
      "value": "开平市",
      "label": "开平市"
    }, {
      "value": "鹤山市",
      "label": "鹤山市"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "江门市"
  }, {
    "value": "湛江市",
    "area": ["赤坎区", "霞山区", "坡头区", "麻章区", "吴川市", "廉江市", "雷州市", "遂溪县", "徐闻县", "其他"],
    "children": [{
      "value": "赤坎区",
      "label": "赤坎区"
    }, {
      "value": "霞山区",
      "label": "霞山区"
    }, {
      "value": "坡头区",
      "label": "坡头区"
    }, {
      "value": "麻章区",
      "label": "麻章区"
    }, {
      "value": "吴川市",
      "label": "吴川市"
    }, {
      "value": "廉江市",
      "label": "廉江市"
    }, {
      "value": "雷州市",
      "label": "雷州市"
    }, {
      "value": "遂溪县",
      "label": "遂溪县"
    }, {
      "value": "徐闻县",
      "label": "徐闻县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "湛江市"
  }, {
    "value": "茂名市",
    "area": ["茂南区", "茂港区", "化州市", "信宜市", "高州市", "电白县", "其他"],
    "children": [{
      "value": "茂南区",
      "label": "茂南区"
    }, {
      "value": "茂港区",
      "label": "茂港区"
    }, {
      "value": "化州市",
      "label": "化州市"
    }, {
      "value": "信宜市",
      "label": "信宜市"
    }, {
      "value": "高州市",
      "label": "高州市"
    }, {
      "value": "电白县",
      "label": "电白县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "茂名市"
  }, {
    "value": "肇庆市",
    "area": ["端州区", "鼎湖区", "高要市", "四会市", "广宁县", "怀集县", "封开县", "德庆县", "其他"],
    "children": [{
      "value": "端州区",
      "label": "端州区"
    }, {
      "value": "鼎湖区",
      "label": "鼎湖区"
    }, {
      "value": "高要市",
      "label": "高要市"
    }, {
      "value": "四会市",
      "label": "四会市"
    }, {
      "value": "广宁县",
      "label": "广宁县"
    }, {
      "value": "怀集县",
      "label": "怀集县"
    }, {
      "value": "封开县",
      "label": "封开县"
    }, {
      "value": "德庆县",
      "label": "德庆县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "肇庆市"
  }, {
    "value": "惠州市",
    "area": ["惠城区", "惠阳区", "博罗县", "惠东县", "龙门县", "其他"],
    "children": [{
      "value": "惠城区",
      "label": "惠城区"
    }, {
      "value": "惠阳区",
      "label": "惠阳区"
    }, {
      "value": "博罗县",
      "label": "博罗县"
    }, {
      "value": "惠东县",
      "label": "惠东县"
    }, {
      "value": "龙门县",
      "label": "龙门县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "惠州市"
  }, {
    "value": "梅州市",
    "area": ["梅江区", "兴宁市", "梅县", "大埔县", "丰顺县", "五华县", "平远县", "蕉岭县", "其他"],
    "children": [{
      "value": "梅江区",
      "label": "梅江区"
    }, {
      "value": "兴宁市",
      "label": "兴宁市"
    }, {
      "value": "梅县",
      "label": "梅县"
    }, {
      "value": "大埔县",
      "label": "大埔县"
    }, {
      "value": "丰顺县",
      "label": "丰顺县"
    }, {
      "value": "五华县",
      "label": "五华县"
    }, {
      "value": "平远县",
      "label": "平远县"
    }, {
      "value": "蕉岭县",
      "label": "蕉岭县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "梅州市"
  }, {
    "value": "汕尾市",
    "area": ["城区", "陆丰市", "海丰县", "陆河县", "其他"],
    "children": [{
      "value": "城区",
      "label": "城区"
    }, {
      "value": "陆丰市",
      "label": "陆丰市"
    }, {
      "value": "海丰县",
      "label": "海丰县"
    }, {
      "value": "陆河县",
      "label": "陆河县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "汕尾市"
  }, {
    "value": "河源市",
    "area": ["源城区", "紫金县", "龙川县", "连平县", "和平县", "东源县", "其他"],
    "children": [{
      "value": "源城区",
      "label": "源城区"
    }, {
      "value": "紫金县",
      "label": "紫金县"
    }, {
      "value": "龙川县",
      "label": "龙川县"
    }, {
      "value": "连平县",
      "label": "连平县"
    }, {
      "value": "和平县",
      "label": "和平县"
    }, {
      "value": "东源县",
      "label": "东源县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "河源市"
  }, {
    "value": "阳江市",
    "area": ["江城区", "阳春市", "阳西县", "阳东县", "其他"],
    "children": [{
      "value": "江城区",
      "label": "江城区"
    }, {
      "value": "阳春市",
      "label": "阳春市"
    }, {
      "value": "阳西县",
      "label": "阳西县"
    }, {
      "value": "阳东县",
      "label": "阳东县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "阳江市"
  }, {
    "value": "清远市",
    "area": ["清城区", "英德市", "连州市", "佛冈县", "阳山县", "清新县", "连山壮族瑶族自治县", "连南瑶族自治县", "其他"],
    "children": [{
      "value": "清城区",
      "label": "清城区"
    }, {
      "value": "英德市",
      "label": "英德市"
    }, {
      "value": "连州市",
      "label": "连州市"
    }, {
      "value": "佛冈县",
      "label": "佛冈县"
    }, {
      "value": "阳山县",
      "label": "阳山县"
    }, {
      "value": "清新县",
      "label": "清新县"
    }, {
      "value": "连山壮族瑶族自治县",
      "label": "连山壮族瑶族自治县"
    }, {
      "value": "连南瑶族自治县",
      "label": "连南瑶族自治县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "清远市"
  }],
  "label": "广东省"
}, {
  "value": "广西",
  "children": [{
    "value": "南宁市",
    "area": ["青秀区", "兴宁区", "西乡塘区", "良庆区", "江南区", "邕宁区", "武鸣县", "隆安县", "马山县", "上林县", "宾阳县", "横县", "其他"],
    "children": [{
      "value": "青秀区",
      "label": "青秀区"
    }, {
      "value": "兴宁区",
      "label": "兴宁区"
    }, {
      "value": "西乡塘区",
      "label": "西乡塘区"
    }, {
      "value": "良庆区",
      "label": "良庆区"
    }, {
      "value": "江南区",
      "label": "江南区"
    }, {
      "value": "邕宁区",
      "label": "邕宁区"
    }, {
      "value": "武鸣县",
      "label": "武鸣县"
    }, {
      "value": "隆安县",
      "label": "隆安县"
    }, {
      "value": "马山县",
      "label": "马山县"
    }, {
      "value": "上林县",
      "label": "上林县"
    }, {
      "value": "宾阳县",
      "label": "宾阳县"
    }, {
      "value": "横县",
      "label": "横县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "南宁市"
  }, {
    "value": "柳州市",
    "area": ["城中区", "鱼峰区", "柳北区", "柳南区", "柳江县", "柳城县", "鹿寨县", "融安县", "融水苗族自治县", "三江侗族自治县", "其他"],
    "children": [{
      "value": "城中区",
      "label": "城中区"
    }, {
      "value": "鱼峰区",
      "label": "鱼峰区"
    }, {
      "value": "柳北区",
      "label": "柳北区"
    }, {
      "value": "柳南区",
      "label": "柳南区"
    }, {
      "value": "柳江县",
      "label": "柳江县"
    }, {
      "value": "柳城县",
      "label": "柳城县"
    }, {
      "value": "鹿寨县",
      "label": "鹿寨县"
    }, {
      "value": "融安县",
      "label": "融安县"
    }, {
      "value": "融水苗族自治县",
      "label": "融水苗族自治县"
    }, {
      "value": "三江侗族自治县",
      "label": "三江侗族自治县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "柳州市"
  }, {
    "value": "桂林市",
    "area": ["象山区", "秀峰区", "叠彩区", "七星区", "雁山区", "阳朔县", "临桂县", "灵川县", "全州县", "平乐县", "兴安县", "灌阳县", "荔浦县", "资源县", "永福县", "龙胜各族自治县", "恭城瑶族自治县", "其他"],
    "children": [{
      "value": "象山区",
      "label": "象山区"
    }, {
      "value": "秀峰区",
      "label": "秀峰区"
    }, {
      "value": "叠彩区",
      "label": "叠彩区"
    }, {
      "value": "七星区",
      "label": "七星区"
    }, {
      "value": "雁山区",
      "label": "雁山区"
    }, {
      "value": "阳朔县",
      "label": "阳朔县"
    }, {
      "value": "临桂县",
      "label": "临桂县"
    }, {
      "value": "灵川县",
      "label": "灵川县"
    }, {
      "value": "全州县",
      "label": "全州县"
    }, {
      "value": "平乐县",
      "label": "平乐县"
    }, {
      "value": "兴安县",
      "label": "兴安县"
    }, {
      "value": "灌阳县",
      "label": "灌阳县"
    }, {
      "value": "荔浦县",
      "label": "荔浦县"
    }, {
      "value": "资源县",
      "label": "资源县"
    }, {
      "value": "永福县",
      "label": "永福县"
    }, {
      "value": "龙胜各族自治县",
      "label": "龙胜各族自治县"
    }, {
      "value": "恭城瑶族自治县",
      "label": "恭城瑶族自治县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "桂林市"
  }, {
    "value": "梧州市",
    "area": ["万秀区", "蝶山区", "长洲区", "岑溪市", "苍梧县", "藤县", "蒙山县", "其他"],
    "children": [{
      "value": "万秀区",
      "label": "万秀区"
    }, {
      "value": "蝶山区",
      "label": "蝶山区"
    }, {
      "value": "长洲区",
      "label": "长洲区"
    }, {
      "value": "岑溪市",
      "label": "岑溪市"
    }, {
      "value": "苍梧县",
      "label": "苍梧县"
    }, {
      "value": "藤县",
      "label": "藤县"
    }, {
      "value": "蒙山县",
      "label": "蒙山县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "梧州市"
  }, {
    "value": "北海市",
    "area": ["海城区", "银海区", "铁山港区", "合浦县", "其他"],
    "children": [{
      "value": "海城区",
      "label": "海城区"
    }, {
      "value": "银海区",
      "label": "银海区"
    }, {
      "value": "铁山港区",
      "label": "铁山港区"
    }, {
      "value": "合浦县",
      "label": "合浦县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "北海市"
  }, {
    "value": "防城港市",
    "area": ["港口区", "防城区", "东兴市", "上思县", "其他"],
    "children": [{
      "value": "港口区",
      "label": "港口区"
    }, {
      "value": "防城区",
      "label": "防城区"
    }, {
      "value": "东兴市",
      "label": "东兴市"
    }, {
      "value": "上思县",
      "label": "上思县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "防城港市"
  }, {
    "value": "钦州市",
    "area": ["钦南区", "钦北区", "灵山县", "浦北县", "其他"],
    "children": [{
      "value": "钦南区",
      "label": "钦南区"
    }, {
      "value": "钦北区",
      "label": "钦北区"
    }, {
      "value": "灵山县",
      "label": "灵山县"
    }, {
      "value": "浦北县",
      "label": "浦北县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "钦州市"
  }, {
    "value": "贵港市",
    "area": ["港北区", "港南区", "覃塘区", "桂平市", "平南县", "其他"],
    "children": [{
      "value": "港北区",
      "label": "港北区"
    }, {
      "value": "港南区",
      "label": "港南区"
    }, {
      "value": "覃塘区",
      "label": "覃塘区"
    }, {
      "value": "桂平市",
      "label": "桂平市"
    }, {
      "value": "平南县",
      "label": "平南县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "贵港市"
  }, {
    "value": "玉林市",
    "area": ["玉州区", "北流市", "容县", "陆川县", "博白县", "兴业县", "其他"],
    "children": [{
      "value": "玉州区",
      "label": "玉州区"
    }, {
      "value": "北流市",
      "label": "北流市"
    }, {
      "value": "容县",
      "label": "容县"
    }, {
      "value": "陆川县",
      "label": "陆川县"
    }, {
      "value": "博白县",
      "label": "博白县"
    }, {
      "value": "兴业县",
      "label": "兴业县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "玉林市"
  }, {
    "value": "百色市",
    "area": ["右江区", "凌云县", "平果县", "西林县", "乐业县", "德保县", "田林县", "田阳县", "靖西县", "田东县", "那坡县", "隆林各族自治县", "其他"],
    "children": [{
      "value": "右江区",
      "label": "右江区"
    }, {
      "value": "凌云县",
      "label": "凌云县"
    }, {
      "value": "平果县",
      "label": "平果县"
    }, {
      "value": "西林县",
      "label": "西林县"
    }, {
      "value": "乐业县",
      "label": "乐业县"
    }, {
      "value": "德保县",
      "label": "德保县"
    }, {
      "value": "田林县",
      "label": "田林县"
    }, {
      "value": "田阳县",
      "label": "田阳县"
    }, {
      "value": "靖西县",
      "label": "靖西县"
    }, {
      "value": "田东县",
      "label": "田东县"
    }, {
      "value": "那坡县",
      "label": "那坡县"
    }, {
      "value": "隆林各族自治县",
      "label": "隆林各族自治县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "百色市"
  }, {
    "value": "贺州市",
    "area": ["八步区", "钟山县", "昭平县", "富川瑶族自治县", "其他"],
    "children": [{
      "value": "八步区",
      "label": "八步区"
    }, {
      "value": "钟山县",
      "label": "钟山县"
    }, {
      "value": "昭平县",
      "label": "昭平县"
    }, {
      "value": "富川瑶族自治县",
      "label": "富川瑶族自治县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "贺州市"
  }, {
    "value": "河池市",
    "area": ["金城江区", "宜州市", "天峨县", "凤山县", "南丹县", "东兰县", "都安瑶族自治县", "罗城仫佬族自治县", "巴马瑶族自治县", "环江毛南族自治县", "大化瑶族自治县", "其他"],
    "children": [{
      "value": "金城江区",
      "label": "金城江区"
    }, {
      "value": "宜州市",
      "label": "宜州市"
    }, {
      "value": "天峨县",
      "label": "天峨县"
    }, {
      "value": "凤山县",
      "label": "凤山县"
    }, {
      "value": "南丹县",
      "label": "南丹县"
    }, {
      "value": "东兰县",
      "label": "东兰县"
    }, {
      "value": "都安瑶族自治县",
      "label": "都安瑶族自治县"
    }, {
      "value": "罗城仫佬族自治县",
      "label": "罗城仫佬族自治县"
    }, {
      "value": "巴马瑶族自治县",
      "label": "巴马瑶族自治县"
    }, {
      "value": "环江毛南族自治县",
      "label": "环江毛南族自治县"
    }, {
      "value": "大化瑶族自治县",
      "label": "大化瑶族自治县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "河池市"
  }, {
    "value": "来宾市",
    "area": ["兴宾区", "合山市", "象州县", "武宣县", "忻城县", "金秀瑶族自治县", "其他"],
    "children": [{
      "value": "兴宾区",
      "label": "兴宾区"
    }, {
      "value": "合山市",
      "label": "合山市"
    }, {
      "value": "象州县",
      "label": "象州县"
    }, {
      "value": "武宣县",
      "label": "武宣县"
    }, {
      "value": "忻城县",
      "label": "忻城县"
    }, {
      "value": "金秀瑶族自治县",
      "label": "金秀瑶族自治县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "来宾市"
  }, {
    "value": "崇左市",
    "area": ["江州区", "凭祥市", "宁明县", "扶绥县", "龙州县", "大新县", "天等县", "其他"],
    "children": [{
      "value": "江州区",
      "label": "江州区"
    }, {
      "value": "凭祥市",
      "label": "凭祥市"
    }, {
      "value": "宁明县",
      "label": "宁明县"
    }, {
      "value": "扶绥县",
      "label": "扶绥县"
    }, {
      "value": "龙州县",
      "label": "龙州县"
    }, {
      "value": "大新县",
      "label": "大新县"
    }, {
      "value": "天等县",
      "label": "天等县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "崇左市"
  }, {
    "value": "其他市",
    "area": ["其他"],
    "children": [{
      "value": "其他",
      "label": "其他"
    }],
    "label": "其他市"
  }],
  "label": "广西"
}, {
  "value": "海南省",
  "children": [{
    "value": "海口市",
    "area": ["龙华区", "秀英区", "琼山区", "美兰区", "其他"],
    "children": [{
      "value": "龙华区",
      "label": "龙华区"
    }, {
      "value": "秀英区",
      "label": "秀英区"
    }, {
      "value": "琼山区",
      "label": "琼山区"
    }, {
      "value": "美兰区",
      "label": "美兰区"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "海口市"
  }, {
    "value": "三亚市",
    "area": ["三亚市", "其他"],
    "children": [{
      "value": "三亚市",
      "label": "三亚市"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "三亚市"
  }, {
    "value": "五指山市",
    "area": ["五指山"],
    "children": [{
      "value": "五指山",
      "label": "五指山"
    }],
    "label": "五指山市"
  }, {
    "value": "琼海市",
    "area": ["琼海"],
    "children": [{
      "value": "琼海",
      "label": "琼海"
    }],
    "label": "琼海市"
  }, {
    "value": "儋州市",
    "area": ["儋州"],
    "children": [{
      "value": "儋州",
      "label": "儋州"
    }],
    "label": "儋州市"
  }, {
    "value": "文昌市",
    "area": ["文昌"],
    "children": [{
      "value": "文昌",
      "label": "文昌"
    }],
    "label": "文昌市"
  }, {
    "value": "万宁市",
    "area": ["万宁"],
    "children": [{
      "value": "万宁",
      "label": "万宁"
    }],
    "label": "万宁市"
  }, {
    "value": "东方市",
    "area": ["东方"],
    "children": [{
      "value": "东方",
      "label": "东方"
    }],
    "label": "东方市"
  }, {
    "value": "澄迈县",
    "area": ["澄迈县"],
    "children": [{
      "value": "澄迈县",
      "label": "澄迈县"
    }],
    "label": "澄迈县"
  }, {
    "value": "定安县",
    "area": ["定安县"],
    "children": [{
      "value": "定安县",
      "label": "定安县"
    }],
    "label": "定安县"
  }, {
    "value": "屯昌县",
    "area": ["屯昌县"],
    "children": [{
      "value": "屯昌县",
      "label": "屯昌县"
    }],
    "label": "屯昌县"
  }, {
    "value": "临高县",
    "area": ["临高县"],
    "children": [{
      "value": "临高县",
      "label": "临高县"
    }],
    "label": "临高县"
  }, {
    "value": "白沙黎族自治县",
    "area": ["白沙黎族自治县"],
    "children": [{
      "value": "白沙黎族自治县",
      "label": "白沙黎族自治县"
    }],
    "label": "白沙黎族自治县"
  }, {
    "value": "昌江黎族自治县",
    "area": ["昌江黎族自治县"],
    "children": [{
      "value": "昌江黎族自治县",
      "label": "昌江黎族自治县"
    }],
    "label": "昌江黎族自治县"
  }, {
    "value": "乐东黎族自治县",
    "area": ["乐东黎族自治县"],
    "children": [{
      "value": "乐东黎族自治县",
      "label": "乐东黎族自治县"
    }],
    "label": "乐东黎族自治县"
  }, {
    "value": "陵水黎族自治县",
    "area": ["陵水黎族自治县"],
    "children": [{
      "value": "陵水黎族自治县",
      "label": "陵水黎族自治县"
    }],
    "label": "陵水黎族自治县"
  }, {
    "value": "保亭黎族苗族自治县",
    "area": ["保亭黎族苗族自治县"],
    "children": [{
      "value": "保亭黎族苗族自治县",
      "label": "保亭黎族苗族自治县"
    }],
    "label": "保亭黎族苗族自治县"
  }, {
    "value": "琼中黎族苗族自治县",
    "area": ["琼中黎族苗族自治县"],
    "children": [{
      "value": "琼中黎族苗族自治县",
      "label": "琼中黎族苗族自治县"
    }],
    "label": "琼中黎族苗族自治县"
  }, {
    "value": "其他",
    "area": ["其他"],
    "children": [{
      "value": "其他",
      "label": "其他"
    }],
    "label": "其他"
  }],
  "label": "海南省"
}, {
  "value": "重庆市",
  "children": [{
    "value": "重庆市",
    "area": ["渝中区", "大渡口区", "江北区", "南岸区", "北碚区", "渝北区", "巴南区", "长寿区", "双桥区", "沙坪坝区", "万盛区", "万州区", "涪陵区", "黔江区", "永川区", "合川区", "江津区", "九龙坡区", "南川区", "綦江县", "潼南县", "荣昌县", "璧山县", "大足县", "铜梁县", "梁平县", "开县", "忠县", "城口县", "垫江县", "武隆县", "丰都县", "奉节县", "云阳县", "巫溪县", "巫山县", "石柱土家族自治县", "秀山土家族苗族自治县", "酉阳土家族苗族自治县", "彭水苗族土家族自治县", "其他"],
    "children": [{
      "value": "渝中区",
      "label": "渝中区"
    }, {
      "value": "大渡口区",
      "label": "大渡口区"
    }, {
      "value": "江北区",
      "label": "江北区"
    }, {
      "value": "南岸区",
      "label": "南岸区"
    }, {
      "value": "北碚区",
      "label": "北碚区"
    }, {
      "value": "渝北区",
      "label": "渝北区"
    }, {
      "value": "巴南区",
      "label": "巴南区"
    }, {
      "value": "长寿区",
      "label": "长寿区"
    }, {
      "value": "双桥区",
      "label": "双桥区"
    }, {
      "value": "沙坪坝区",
      "label": "沙坪坝区"
    }, {
      "value": "万盛区",
      "label": "万盛区"
    }, {
      "value": "万州区",
      "label": "万州区"
    }, {
      "value": "涪陵区",
      "label": "涪陵区"
    }, {
      "value": "黔江区",
      "label": "黔江区"
    }, {
      "value": "永川区",
      "label": "永川区"
    }, {
      "value": "合川区",
      "label": "合川区"
    }, {
      "value": "江津区",
      "label": "江津区"
    }, {
      "value": "九龙坡区",
      "label": "九龙坡区"
    }, {
      "value": "南川区",
      "label": "南川区"
    }, {
      "value": "綦江县",
      "label": "綦江县"
    }, {
      "value": "潼南县",
      "label": "潼南县"
    }, {
      "value": "荣昌县",
      "label": "荣昌县"
    }, {
      "value": "璧山县",
      "label": "璧山县"
    }, {
      "value": "大足县",
      "label": "大足县"
    }, {
      "value": "铜梁县",
      "label": "铜梁县"
    }, {
      "value": "梁平县",
      "label": "梁平县"
    }, {
      "value": "开县",
      "label": "开县"
    }, {
      "value": "忠县",
      "label": "忠县"
    }, {
      "value": "城口县",
      "label": "城口县"
    }, {
      "value": "垫江县",
      "label": "垫江县"
    }, {
      "value": "武隆县",
      "label": "武隆县"
    }, {
      "value": "丰都县",
      "label": "丰都县"
    }, {
      "value": "奉节县",
      "label": "奉节县"
    }, {
      "value": "云阳县",
      "label": "云阳县"
    }, {
      "value": "巫溪县",
      "label": "巫溪县"
    }, {
      "value": "巫山县",
      "label": "巫山县"
    }, {
      "value": "石柱土家族自治县",
      "label": "石柱土家族自治县"
    }, {
      "value": "秀山土家族苗族自治县",
      "label": "秀山土家族苗族自治县"
    }, {
      "value": "酉阳土家族苗族自治县",
      "label": "酉阳土家族苗族自治县"
    }, {
      "value": "彭水苗族土家族自治县",
      "label": "彭水苗族土家族自治县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "重庆市"
  }],
  "label": "重庆市"
}, {
  "value": "四川省",
  "children": [{
    "value": "成都市",
    "area": ["青羊区", "锦江区", "金牛区", "武侯区", "成华区", "龙泉驿区", "青白江区", "新都区", "温江区", "都江堰市", "彭州市", "邛崃市", "崇州市", "金堂县", "郫县", "新津县", "双流县", "蒲江县", "大邑县", "其他"],
    "children": [{
      "value": "青羊区",
      "label": "青羊区"
    }, {
      "value": "锦江区",
      "label": "锦江区"
    }, {
      "value": "金牛区",
      "label": "金牛区"
    }, {
      "value": "武侯区",
      "label": "武侯区"
    }, {
      "value": "成华区",
      "label": "成华区"
    }, {
      "value": "龙泉驿区",
      "label": "龙泉驿区"
    }, {
      "value": "青白江区",
      "label": "青白江区"
    }, {
      "value": "新都区",
      "label": "新都区"
    }, {
      "value": "温江区",
      "label": "温江区"
    }, {
      "value": "都江堰市",
      "label": "都江堰市"
    }, {
      "value": "彭州市",
      "label": "彭州市"
    }, {
      "value": "邛崃市",
      "label": "邛崃市"
    }, {
      "value": "崇州市",
      "label": "崇州市"
    }, {
      "value": "金堂县",
      "label": "金堂县"
    }, {
      "value": "郫县",
      "label": "郫县"
    }, {
      "value": "新津县",
      "label": "新津县"
    }, {
      "value": "双流县",
      "label": "双流县"
    }, {
      "value": "蒲江县",
      "label": "蒲江县"
    }, {
      "value": "大邑县",
      "label": "大邑县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "成都市"
  }, {
    "value": "自贡市",
    "area": ["大安区", "自流井区", "贡井区", "沿滩区", "荣县", "富顺县", "其他"],
    "children": [{
      "value": "大安区",
      "label": "大安区"
    }, {
      "value": "自流井区",
      "label": "自流井区"
    }, {
      "value": "贡井区",
      "label": "贡井区"
    }, {
      "value": "沿滩区",
      "label": "沿滩区"
    }, {
      "value": "荣县",
      "label": "荣县"
    }, {
      "value": "富顺县",
      "label": "富顺县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "自贡市"
  }, {
    "value": "攀枝花市",
    "area": ["仁和区", "米易县", "盐边县", "东区", "西区", "其他"],
    "children": [{
      "value": "仁和区",
      "label": "仁和区"
    }, {
      "value": "米易县",
      "label": "米易县"
    }, {
      "value": "盐边县",
      "label": "盐边县"
    }, {
      "value": "东区",
      "label": "东区"
    }, {
      "value": "西区",
      "label": "西区"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "攀枝花市"
  }, {
    "value": "泸州市",
    "area": ["江阳区", "纳溪区", "龙马潭区", "泸县", "合江县", "叙永县", "古蔺县", "其他"],
    "children": [{
      "value": "江阳区",
      "label": "江阳区"
    }, {
      "value": "纳溪区",
      "label": "纳溪区"
    }, {
      "value": "龙马潭区",
      "label": "龙马潭区"
    }, {
      "value": "泸县",
      "label": "泸县"
    }, {
      "value": "合江县",
      "label": "合江县"
    }, {
      "value": "叙永县",
      "label": "叙永县"
    }, {
      "value": "古蔺县",
      "label": "古蔺县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "泸州市"
  }, {
    "value": "德阳市",
    "area": ["旌阳区", "广汉市", "什邡市", "绵竹市", "罗江县", "中江县", "其他"],
    "children": [{
      "value": "旌阳区",
      "label": "旌阳区"
    }, {
      "value": "广汉市",
      "label": "广汉市"
    }, {
      "value": "什邡市",
      "label": "什邡市"
    }, {
      "value": "绵竹市",
      "label": "绵竹市"
    }, {
      "value": "罗江县",
      "label": "罗江县"
    }, {
      "value": "中江县",
      "label": "中江县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "德阳市"
  }, {
    "value": "绵阳市",
    "area": ["涪城区", "游仙区", "江油市", "盐亭县", "三台县", "平武县", "安县", "梓潼县", "北川羌族自治县", "其他"],
    "children": [{
      "value": "涪城区",
      "label": "涪城区"
    }, {
      "value": "游仙区",
      "label": "游仙区"
    }, {
      "value": "江油市",
      "label": "江油市"
    }, {
      "value": "盐亭县",
      "label": "盐亭县"
    }, {
      "value": "三台县",
      "label": "三台县"
    }, {
      "value": "平武县",
      "label": "平武县"
    }, {
      "value": "安县",
      "label": "安县"
    }, {
      "value": "梓潼县",
      "label": "梓潼县"
    }, {
      "value": "北川羌族自治县",
      "label": "北川羌族自治县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "绵阳市"
  }, {
    "value": "广元市",
    "area": ["元坝区", "朝天区", "青川县", "旺苍县", "剑阁县", "苍溪县", "市中区", "其他"],
    "children": [{
      "value": "元坝区",
      "label": "元坝区"
    }, {
      "value": "朝天区",
      "label": "朝天区"
    }, {
      "value": "青川县",
      "label": "青川县"
    }, {
      "value": "旺苍县",
      "label": "旺苍县"
    }, {
      "value": "剑阁县",
      "label": "剑阁县"
    }, {
      "value": "苍溪县",
      "label": "苍溪县"
    }, {
      "value": "市中区",
      "label": "市中区"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "广元市"
  }, {
    "value": "遂宁市",
    "area": ["船山区", "安居区", "射洪县", "蓬溪县", "大英县", "其他"],
    "children": [{
      "value": "船山区",
      "label": "船山区"
    }, {
      "value": "安居区",
      "label": "安居区"
    }, {
      "value": "射洪县",
      "label": "射洪县"
    }, {
      "value": "蓬溪县",
      "label": "蓬溪县"
    }, {
      "value": "大英县",
      "label": "大英县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "遂宁市"
  }, {
    "value": "内江市",
    "area": ["市中区", "东兴区", "资中县", "隆昌县", "威远县", "其他"],
    "children": [{
      "value": "市中区",
      "label": "市中区"
    }, {
      "value": "东兴区",
      "label": "东兴区"
    }, {
      "value": "资中县",
      "label": "资中县"
    }, {
      "value": "隆昌县",
      "label": "隆昌县"
    }, {
      "value": "威远县",
      "label": "威远县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "内江市"
  }, {
    "value": "乐山市",
    "area": ["市中区", "五通桥区", "沙湾区", "金口河区", "峨眉山市", "夹江县", "井研县", "犍为县", "沐川县", "马边彝族自治县", "峨边彝族自治县", "其他"],
    "children": [{
      "value": "市中区",
      "label": "市中区"
    }, {
      "value": "五通桥区",
      "label": "五通桥区"
    }, {
      "value": "沙湾区",
      "label": "沙湾区"
    }, {
      "value": "金口河区",
      "label": "金口河区"
    }, {
      "value": "峨眉山市",
      "label": "峨眉山市"
    }, {
      "value": "夹江县",
      "label": "夹江县"
    }, {
      "value": "井研县",
      "label": "井研县"
    }, {
      "value": "犍为县",
      "label": "犍为县"
    }, {
      "value": "沐川县",
      "label": "沐川县"
    }, {
      "value": "马边彝族自治县",
      "label": "马边彝族自治县"
    }, {
      "value": "峨边彝族自治县",
      "label": "峨边彝族自治县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "乐山市"
  }, {
    "value": "南充",
    "area": ["顺庆区", "高坪区", "嘉陵区", "阆中市", "营山县", "蓬安县", "仪陇县", "南部县", "西充县", "其他"],
    "children": [{
      "value": "顺庆区",
      "label": "顺庆区"
    }, {
      "value": "高坪区",
      "label": "高坪区"
    }, {
      "value": "嘉陵区",
      "label": "嘉陵区"
    }, {
      "value": "阆中市",
      "label": "阆中市"
    }, {
      "value": "营山县",
      "label": "营山县"
    }, {
      "value": "蓬安县",
      "label": "蓬安县"
    }, {
      "value": "仪陇县",
      "label": "仪陇县"
    }, {
      "value": "南部县",
      "label": "南部县"
    }, {
      "value": "西充县",
      "label": "西充县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "南充"
  }, {
    "value": "眉山市",
    "area": ["东坡区", "仁寿县", "彭山县", "洪雅县", "丹棱县", "青神县", "其他"],
    "children": [{
      "value": "东坡区",
      "label": "东坡区"
    }, {
      "value": "仁寿县",
      "label": "仁寿县"
    }, {
      "value": "彭山县",
      "label": "彭山县"
    }, {
      "value": "洪雅县",
      "label": "洪雅县"
    }, {
      "value": "丹棱县",
      "label": "丹棱县"
    }, {
      "value": "青神县",
      "label": "青神县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "眉山市"
  }, {
    "value": "宜宾市",
    "area": ["翠屏区", "宜宾县", "兴文县", "南溪县", "珙县", "长宁县", "高县", "江安县", "筠连县", "屏山县", "其他"],
    "children": [{
      "value": "翠屏区",
      "label": "翠屏区"
    }, {
      "value": "宜宾县",
      "label": "宜宾县"
    }, {
      "value": "兴文县",
      "label": "兴文县"
    }, {
      "value": "南溪县",
      "label": "南溪县"
    }, {
      "value": "珙县",
      "label": "珙县"
    }, {
      "value": "长宁县",
      "label": "长宁县"
    }, {
      "value": "高县",
      "label": "高县"
    }, {
      "value": "江安县",
      "label": "江安县"
    }, {
      "value": "筠连县",
      "label": "筠连县"
    }, {
      "value": "屏山县",
      "label": "屏山县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "宜宾市"
  }, {
    "value": "广安市",
    "area": ["广安区", "华蓥市", "岳池县", "邻水县", "武胜县", "其他"],
    "children": [{
      "value": "广安区",
      "label": "广安区"
    }, {
      "value": "华蓥市",
      "label": "华蓥市"
    }, {
      "value": "岳池县",
      "label": "岳池县"
    }, {
      "value": "邻水县",
      "label": "邻水县"
    }, {
      "value": "武胜县",
      "label": "武胜县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "广安市"
  }, {
    "value": "达州市",
    "area": ["通川区", "万源市", "达县", "渠县", "宣汉县", "开江县", "大竹县", "其他"],
    "children": [{
      "value": "通川区",
      "label": "通川区"
    }, {
      "value": "万源市",
      "label": "万源市"
    }, {
      "value": "达县",
      "label": "达县"
    }, {
      "value": "渠县",
      "label": "渠县"
    }, {
      "value": "宣汉县",
      "label": "宣汉县"
    }, {
      "value": "开江县",
      "label": "开江县"
    }, {
      "value": "大竹县",
      "label": "大竹县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "达州市"
  }, {
    "value": "雅安市",
    "area": ["雨城区", "芦山县", "石棉县", "名山县", "天全县", "荥经县", "宝兴县", "汉源县", "其他"],
    "children": [{
      "value": "雨城区",
      "label": "雨城区"
    }, {
      "value": "芦山县",
      "label": "芦山县"
    }, {
      "value": "石棉县",
      "label": "石棉县"
    }, {
      "value": "名山县",
      "label": "名山县"
    }, {
      "value": "天全县",
      "label": "天全县"
    }, {
      "value": "荥经县",
      "label": "荥经县"
    }, {
      "value": "宝兴县",
      "label": "宝兴县"
    }, {
      "value": "汉源县",
      "label": "汉源县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "雅安市"
  }, {
    "value": "巴中市",
    "area": ["巴州区", "南江县", "平昌县", "通江县", "其他"],
    "children": [{
      "value": "巴州区",
      "label": "巴州区"
    }, {
      "value": "南江县",
      "label": "南江县"
    }, {
      "value": "平昌县",
      "label": "平昌县"
    }, {
      "value": "通江县",
      "label": "通江县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "巴中市"
  }, {
    "value": "资阳市",
    "area": ["雁江区", "简阳市", "安岳县", "乐至县", "其他"],
    "children": [{
      "value": "雁江区",
      "label": "雁江区"
    }, {
      "value": "简阳市",
      "label": "简阳市"
    }, {
      "value": "安岳县",
      "label": "安岳县"
    }, {
      "value": "乐至县",
      "label": "乐至县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "资阳市"
  }, {
    "value": "阿坝藏族羌族自治州",
    "area": ["马尔康县", "九寨沟县", "红原县", "汶川县", "阿坝县", "理县", "若尔盖县", "小金县", "黑水县", "金川县", "松潘县", "壤塘县", "茂县", "其他"],
    "children": [{
      "value": "马尔康县",
      "label": "马尔康县"
    }, {
      "value": "九寨沟县",
      "label": "九寨沟县"
    }, {
      "value": "红原县",
      "label": "红原县"
    }, {
      "value": "汶川县",
      "label": "汶川县"
    }, {
      "value": "阿坝县",
      "label": "阿坝县"
    }, {
      "value": "理县",
      "label": "理县"
    }, {
      "value": "若尔盖县",
      "label": "若尔盖县"
    }, {
      "value": "小金县",
      "label": "小金县"
    }, {
      "value": "黑水县",
      "label": "黑水县"
    }, {
      "value": "金川县",
      "label": "金川县"
    }, {
      "value": "松潘县",
      "label": "松潘县"
    }, {
      "value": "壤塘县",
      "label": "壤塘县"
    }, {
      "value": "茂县",
      "label": "茂县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "阿坝藏族羌族自治州"
  }, {
    "value": "甘孜藏族自治州",
    "area": ["康定县", "丹巴县", "炉霍县", "九龙县", "甘孜县", "雅江县", "新龙县", "道孚县", "白玉县", "理塘县", "德格县", "乡城县", "石渠县", "稻城县", "色达县", "巴塘县", "泸定县", "得荣县", "其他"],
    "children": [{
      "value": "康定县",
      "label": "康定县"
    }, {
      "value": "丹巴县",
      "label": "丹巴县"
    }, {
      "value": "炉霍县",
      "label": "炉霍县"
    }, {
      "value": "九龙县",
      "label": "九龙县"
    }, {
      "value": "甘孜县",
      "label": "甘孜县"
    }, {
      "value": "雅江县",
      "label": "雅江县"
    }, {
      "value": "新龙县",
      "label": "新龙县"
    }, {
      "value": "道孚县",
      "label": "道孚县"
    }, {
      "value": "白玉县",
      "label": "白玉县"
    }, {
      "value": "理塘县",
      "label": "理塘县"
    }, {
      "value": "德格县",
      "label": "德格县"
    }, {
      "value": "乡城县",
      "label": "乡城县"
    }, {
      "value": "石渠县",
      "label": "石渠县"
    }, {
      "value": "稻城县",
      "label": "稻城县"
    }, {
      "value": "色达县",
      "label": "色达县"
    }, {
      "value": "巴塘县",
      "label": "巴塘县"
    }, {
      "value": "泸定县",
      "label": "泸定县"
    }, {
      "value": "得荣县",
      "label": "得荣县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "甘孜藏族自治州"
  }, {
    "value": "凉山彝族自治州",
    "area": ["西昌市", "美姑县", "昭觉县", "金阳县", "甘洛县", "布拖县", "雷波县", "普格县", "宁南县", "喜德县", "会东县", "越西县", "会理县", "盐源县", "德昌县", "冕宁县", "木里藏族自治县", "其他"],
    "children": [{
      "value": "西昌市",
      "label": "西昌市"
    }, {
      "value": "美姑县",
      "label": "美姑县"
    }, {
      "value": "昭觉县",
      "label": "昭觉县"
    }, {
      "value": "金阳县",
      "label": "金阳县"
    }, {
      "value": "甘洛县",
      "label": "甘洛县"
    }, {
      "value": "布拖县",
      "label": "布拖县"
    }, {
      "value": "雷波县",
      "label": "雷波县"
    }, {
      "value": "普格县",
      "label": "普格县"
    }, {
      "value": "宁南县",
      "label": "宁南县"
    }, {
      "value": "喜德县",
      "label": "喜德县"
    }, {
      "value": "会东县",
      "label": "会东县"
    }, {
      "value": "越西县",
      "label": "越西县"
    }, {
      "value": "会理县",
      "label": "会理县"
    }, {
      "value": "盐源县",
      "label": "盐源县"
    }, {
      "value": "德昌县",
      "label": "德昌县"
    }, {
      "value": "冕宁县",
      "label": "冕宁县"
    }, {
      "value": "木里藏族自治县",
      "label": "木里藏族自治县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "凉山彝族自治州"
  }, {
    "value": "其他",
    "area": ["其他"],
    "children": [{
      "value": "其他",
      "label": "其他"
    }],
    "label": "其他"
  }],
  "label": "四川省"
}, {
  "value": "贵州省",
  "children": [{
    "value": "贵阳市",
    "area": ["南明区", "云岩区", "花溪区", "乌当区", "白云区", "小河区", "清镇市", "开阳县", "修文县", "息烽县", "其他"],
    "children": [{
      "value": "南明区",
      "label": "南明区"
    }, {
      "value": "云岩区",
      "label": "云岩区"
    }, {
      "value": "花溪区",
      "label": "花溪区"
    }, {
      "value": "乌当区",
      "label": "乌当区"
    }, {
      "value": "白云区",
      "label": "白云区"
    }, {
      "value": "小河区",
      "label": "小河区"
    }, {
      "value": "清镇市",
      "label": "清镇市"
    }, {
      "value": "开阳县",
      "label": "开阳县"
    }, {
      "value": "修文县",
      "label": "修文县"
    }, {
      "value": "息烽县",
      "label": "息烽县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "贵阳市"
  }, {
    "value": "六盘水市",
    "area": ["钟山区", "水城县", "盘县", "六枝特区", "其他"],
    "children": [{
      "value": "钟山区",
      "label": "钟山区"
    }, {
      "value": "水城县",
      "label": "水城县"
    }, {
      "value": "盘县",
      "label": "盘县"
    }, {
      "value": "六枝特区",
      "label": "六枝特区"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "六盘水市"
  }, {
    "value": "遵义市",
    "area": ["红花岗区", "汇川区", "赤水市", "仁怀市", "遵义县", "绥阳县", "桐梓县", "习水县", "凤冈县", "正安县", "余庆县", "湄潭县", "道真仡佬族苗族自治县", "务川仡佬族苗族自治县", "其他"],
    "children": [{
      "value": "红花岗区",
      "label": "红花岗区"
    }, {
      "value": "汇川区",
      "label": "汇川区"
    }, {
      "value": "赤水市",
      "label": "赤水市"
    }, {
      "value": "仁怀市",
      "label": "仁怀市"
    }, {
      "value": "遵义县",
      "label": "遵义县"
    }, {
      "value": "绥阳县",
      "label": "绥阳县"
    }, {
      "value": "桐梓县",
      "label": "桐梓县"
    }, {
      "value": "习水县",
      "label": "习水县"
    }, {
      "value": "凤冈县",
      "label": "凤冈县"
    }, {
      "value": "正安县",
      "label": "正安县"
    }, {
      "value": "余庆县",
      "label": "余庆县"
    }, {
      "value": "湄潭县",
      "label": "湄潭县"
    }, {
      "value": "道真仡佬族苗族自治县",
      "label": "道真仡佬族苗族自治县"
    }, {
      "value": "务川仡佬族苗族自治县",
      "label": "务川仡佬族苗族自治县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "遵义市"
  }, {
    "value": "安顺市",
    "area": ["西秀区", "普定县", "平坝县", "镇宁布依族苗族自治县", "紫云苗族布依族自治县", "关岭布依族苗族自治县", "其他"],
    "children": [{
      "value": "西秀区",
      "label": "西秀区"
    }, {
      "value": "普定县",
      "label": "普定县"
    }, {
      "value": "平坝县",
      "label": "平坝县"
    }, {
      "value": "镇宁布依族苗族自治县",
      "label": "镇宁布依族苗族自治县"
    }, {
      "value": "紫云苗族布依族自治县",
      "label": "紫云苗族布依族自治县"
    }, {
      "value": "关岭布依族苗族自治县",
      "label": "关岭布依族苗族自治县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "安顺市"
  }, {
    "value": "铜仁地区",
    "area": ["铜仁市", "德江县", "江口县", "思南县", "石阡县", "玉屏侗族自治县", "松桃苗族自治县", "印江土家族苗族自治县", "沿河土家族自治县", "万山特区", "其他"],
    "children": [{
      "value": "铜仁市",
      "label": "铜仁市"
    }, {
      "value": "德江县",
      "label": "德江县"
    }, {
      "value": "江口县",
      "label": "江口县"
    }, {
      "value": "思南县",
      "label": "思南县"
    }, {
      "value": "石阡县",
      "label": "石阡县"
    }, {
      "value": "玉屏侗族自治县",
      "label": "玉屏侗族自治县"
    }, {
      "value": "松桃苗族自治县",
      "label": "松桃苗族自治县"
    }, {
      "value": "印江土家族苗族自治县",
      "label": "印江土家族苗族自治县"
    }, {
      "value": "沿河土家族自治县",
      "label": "沿河土家族自治县"
    }, {
      "value": "万山特区",
      "label": "万山特区"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "铜仁地区"
  }, {
    "value": "毕节地区",
    "area": ["毕节市", "黔西县", "大方县", "织金县", "金沙县", "赫章县", "纳雍县", "威宁彝族回族苗族自治县", "其他"],
    "children": [{
      "value": "毕节市",
      "label": "毕节市"
    }, {
      "value": "黔西县",
      "label": "黔西县"
    }, {
      "value": "大方县",
      "label": "大方县"
    }, {
      "value": "织金县",
      "label": "织金县"
    }, {
      "value": "金沙县",
      "label": "金沙县"
    }, {
      "value": "赫章县",
      "label": "赫章县"
    }, {
      "value": "纳雍县",
      "label": "纳雍县"
    }, {
      "value": "威宁彝族回族苗族自治县",
      "label": "威宁彝族回族苗族自治县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "毕节地区"
  }, {
    "value": "黔西南布依族苗族自治州",
    "area": ["兴义市", "望谟县", "兴仁县", "普安县", "册亨县", "晴隆县", "贞丰县", "安龙县", "其他"],
    "children": [{
      "value": "兴义市",
      "label": "兴义市"
    }, {
      "value": "望谟县",
      "label": "望谟县"
    }, {
      "value": "兴仁县",
      "label": "兴仁县"
    }, {
      "value": "普安县",
      "label": "普安县"
    }, {
      "value": "册亨县",
      "label": "册亨县"
    }, {
      "value": "晴隆县",
      "label": "晴隆县"
    }, {
      "value": "贞丰县",
      "label": "贞丰县"
    }, {
      "value": "安龙县",
      "label": "安龙县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "黔西南布依族苗族自治州"
  }, {
    "value": "黔东南苗族侗族自治州",
    "area": ["凯里市", "施秉县", "从江县", "锦屏县", "镇远县", "麻江县", "台江县", "天柱县", "黄平县", "榕江县", "剑河县", "三穗县", "雷山县", "黎平县", "岑巩县", "丹寨县", "其他"],
    "children": [{
      "value": "凯里市",
      "label": "凯里市"
    }, {
      "value": "施秉县",
      "label": "施秉县"
    }, {
      "value": "从江县",
      "label": "从江县"
    }, {
      "value": "锦屏县",
      "label": "锦屏县"
    }, {
      "value": "镇远县",
      "label": "镇远县"
    }, {
      "value": "麻江县",
      "label": "麻江县"
    }, {
      "value": "台江县",
      "label": "台江县"
    }, {
      "value": "天柱县",
      "label": "天柱县"
    }, {
      "value": "黄平县",
      "label": "黄平县"
    }, {
      "value": "榕江县",
      "label": "榕江县"
    }, {
      "value": "剑河县",
      "label": "剑河县"
    }, {
      "value": "三穗县",
      "label": "三穗县"
    }, {
      "value": "雷山县",
      "label": "雷山县"
    }, {
      "value": "黎平县",
      "label": "黎平县"
    }, {
      "value": "岑巩县",
      "label": "岑巩县"
    }, {
      "value": "丹寨县",
      "label": "丹寨县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "黔东南苗族侗族自治州"
  }, {
    "value": "黔南布依族苗族自治州",
    "area": ["都匀市", "福泉市", "贵定县", "惠水县", "罗甸县", "瓮安县", "荔波县", "龙里县", "平塘县", "长顺县", "独山县", "三都水族自治县", "其他"],
    "children": [{
      "value": "都匀市",
      "label": "都匀市"
    }, {
      "value": "福泉市",
      "label": "福泉市"
    }, {
      "value": "贵定县",
      "label": "贵定县"
    }, {
      "value": "惠水县",
      "label": "惠水县"
    }, {
      "value": "罗甸县",
      "label": "罗甸县"
    }, {
      "value": "瓮安县",
      "label": "瓮安县"
    }, {
      "value": "荔波县",
      "label": "荔波县"
    }, {
      "value": "龙里县",
      "label": "龙里县"
    }, {
      "value": "平塘县",
      "label": "平塘县"
    }, {
      "value": "长顺县",
      "label": "长顺县"
    }, {
      "value": "独山县",
      "label": "独山县"
    }, {
      "value": "三都水族自治县",
      "label": "三都水族自治县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "黔南布依族苗族自治州"
  }, {
    "value": "其他",
    "area": ["其他"],
    "children": [{
      "value": "其他",
      "label": "其他"
    }],
    "label": "其他"
  }],
  "label": "贵州省"
}, {
  "value": "云南省",
  "children": [{
    "value": "昆明市",
    "area": ["盘龙区", "五华区", "官渡区", "西山区", "东川区", "安宁市", "呈贡县", "晋宁县", "富民县", "宜良县", "嵩明县", "石林彝族自治县", "禄劝彝族苗族自治县", "寻甸回族彝族自治县", "其他"],
    "children": [{
      "value": "盘龙区",
      "label": "盘龙区"
    }, {
      "value": "五华区",
      "label": "五华区"
    }, {
      "value": "官渡区",
      "label": "官渡区"
    }, {
      "value": "西山区",
      "label": "西山区"
    }, {
      "value": "东川区",
      "label": "东川区"
    }, {
      "value": "安宁市",
      "label": "安宁市"
    }, {
      "value": "呈贡县",
      "label": "呈贡县"
    }, {
      "value": "晋宁县",
      "label": "晋宁县"
    }, {
      "value": "富民县",
      "label": "富民县"
    }, {
      "value": "宜良县",
      "label": "宜良县"
    }, {
      "value": "嵩明县",
      "label": "嵩明县"
    }, {
      "value": "石林彝族自治县",
      "label": "石林彝族自治县"
    }, {
      "value": "禄劝彝族苗族自治县",
      "label": "禄劝彝族苗族自治县"
    }, {
      "value": "寻甸回族彝族自治县",
      "label": "寻甸回族彝族自治县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "昆明市"
  }, {
    "value": "曲靖市",
    "area": ["麒麟区", "宣威市", "马龙县", "沾益县", "富源县", "罗平县", "师宗县", "陆良县", "会泽县", "其他"],
    "children": [{
      "value": "麒麟区",
      "label": "麒麟区"
    }, {
      "value": "宣威市",
      "label": "宣威市"
    }, {
      "value": "马龙县",
      "label": "马龙县"
    }, {
      "value": "沾益县",
      "label": "沾益县"
    }, {
      "value": "富源县",
      "label": "富源县"
    }, {
      "value": "罗平县",
      "label": "罗平县"
    }, {
      "value": "师宗县",
      "label": "师宗县"
    }, {
      "value": "陆良县",
      "label": "陆良县"
    }, {
      "value": "会泽县",
      "label": "会泽县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "曲靖市"
  }, {
    "value": "玉溪市",
    "area": ["红塔区", "江川县", "澄江县", "通海县", "华宁县", "易门县", "峨山彝族自治县", "新平彝族傣族自治县", "元江哈尼族彝族傣族自治县", "其他"],
    "children": [{
      "value": "红塔区",
      "label": "红塔区"
    }, {
      "value": "江川县",
      "label": "江川县"
    }, {
      "value": "澄江县",
      "label": "澄江县"
    }, {
      "value": "通海县",
      "label": "通海县"
    }, {
      "value": "华宁县",
      "label": "华宁县"
    }, {
      "value": "易门县",
      "label": "易门县"
    }, {
      "value": "峨山彝族自治县",
      "label": "峨山彝族自治县"
    }, {
      "value": "新平彝族傣族自治县",
      "label": "新平彝族傣族自治县"
    }, {
      "value": "元江哈尼族彝族傣族自治县",
      "label": "元江哈尼族彝族傣族自治县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "玉溪市"
  }, {
    "value": "保山市",
    "area": ["隆阳区", "施甸县", "腾冲县", "龙陵县", "昌宁县", "其他"],
    "children": [{
      "value": "隆阳区",
      "label": "隆阳区"
    }, {
      "value": "施甸县",
      "label": "施甸县"
    }, {
      "value": "腾冲县",
      "label": "腾冲县"
    }, {
      "value": "龙陵县",
      "label": "龙陵县"
    }, {
      "value": "昌宁县",
      "label": "昌宁县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "保山市"
  }, {
    "value": "昭通市",
    "area": ["昭阳区", "鲁甸县", "巧家县", "盐津县", "大关县", "永善县", "绥江县", "镇雄县", "彝良县", "威信县", "水富县", "其他"],
    "children": [{
      "value": "昭阳区",
      "label": "昭阳区"
    }, {
      "value": "鲁甸县",
      "label": "鲁甸县"
    }, {
      "value": "巧家县",
      "label": "巧家县"
    }, {
      "value": "盐津县",
      "label": "盐津县"
    }, {
      "value": "大关县",
      "label": "大关县"
    }, {
      "value": "永善县",
      "label": "永善县"
    }, {
      "value": "绥江县",
      "label": "绥江县"
    }, {
      "value": "镇雄县",
      "label": "镇雄县"
    }, {
      "value": "彝良县",
      "label": "彝良县"
    }, {
      "value": "威信县",
      "label": "威信县"
    }, {
      "value": "水富县",
      "label": "水富县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "昭通市"
  }, {
    "value": "丽江市",
    "area": ["古城区", "永胜县", "华坪县", "玉龙纳西族自治县", "宁蒗彝族自治县", "其他"],
    "children": [{
      "value": "古城区",
      "label": "古城区"
    }, {
      "value": "永胜县",
      "label": "永胜县"
    }, {
      "value": "华坪县",
      "label": "华坪县"
    }, {
      "value": "玉龙纳西族自治县",
      "label": "玉龙纳西族自治县"
    }, {
      "value": "宁蒗彝族自治县",
      "label": "宁蒗彝族自治县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "丽江市"
  }, {
    "value": "普洱市",
    "area": ["思茅区", "普洱哈尼族彝族自治县", "墨江哈尼族自治县", "景东彝族自治县", "景谷傣族彝族自治县", "镇沅彝族哈尼族拉祜族自治县", "江城哈尼族彝族自治县", "孟连傣族拉祜族佤族自治县", "澜沧拉祜族自治县", "西盟佤族自治县", "其他"],
    "children": [{
      "value": "思茅区",
      "label": "思茅区"
    }, {
      "value": "普洱哈尼族彝族自治县",
      "label": "普洱哈尼族彝族自治县"
    }, {
      "value": "墨江哈尼族自治县",
      "label": "墨江哈尼族自治县"
    }, {
      "value": "景东彝族自治县",
      "label": "景东彝族自治县"
    }, {
      "value": "景谷傣族彝族自治县",
      "label": "景谷傣族彝族自治县"
    }, {
      "value": "镇沅彝族哈尼族拉祜族自治县",
      "label": "镇沅彝族哈尼族拉祜族自治县"
    }, {
      "value": "江城哈尼族彝族自治县",
      "label": "江城哈尼族彝族自治县"
    }, {
      "value": "孟连傣族拉祜族佤族自治县",
      "label": "孟连傣族拉祜族佤族自治县"
    }, {
      "value": "澜沧拉祜族自治县",
      "label": "澜沧拉祜族自治县"
    }, {
      "value": "西盟佤族自治县",
      "label": "西盟佤族自治县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "普洱市"
  }, {
    "value": "临沧市",
    "area": ["临翔区", "凤庆县", "云县", "永德县", "镇康县", "双江拉祜族佤族布朗族傣族自治县", "耿马傣族佤族自治县", "沧源佤族自治县", "其他"],
    "children": [{
      "value": "临翔区",
      "label": "临翔区"
    }, {
      "value": "凤庆县",
      "label": "凤庆县"
    }, {
      "value": "云县",
      "label": "云县"
    }, {
      "value": "永德县",
      "label": "永德县"
    }, {
      "value": "镇康县",
      "label": "镇康县"
    }, {
      "value": "双江拉祜族佤族布朗族傣族自治县",
      "label": "双江拉祜族佤族布朗族傣族自治县"
    }, {
      "value": "耿马傣族佤族自治县",
      "label": "耿马傣族佤族自治县"
    }, {
      "value": "沧源佤族自治县",
      "label": "沧源佤族自治县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "临沧市"
  }, {
    "value": "德宏傣族景颇族自治州",
    "area": ["潞西市", "瑞丽市", "梁河县", "盈江县", "陇川县", "其他"],
    "children": [{
      "value": "潞西市",
      "label": "潞西市"
    }, {
      "value": "瑞丽市",
      "label": "瑞丽市"
    }, {
      "value": "梁河县",
      "label": "梁河县"
    }, {
      "value": "盈江县",
      "label": "盈江县"
    }, {
      "value": "陇川县",
      "label": "陇川县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "德宏傣族景颇族自治州"
  }, {
    "value": "怒江傈僳族自治州",
    "area": ["泸水县", "福贡县", "贡山独龙族怒族自治县", "兰坪白族普米族自治县", "其他"],
    "children": [{
      "value": "泸水县",
      "label": "泸水县"
    }, {
      "value": "福贡县",
      "label": "福贡县"
    }, {
      "value": "贡山独龙族怒族自治县",
      "label": "贡山独龙族怒族自治县"
    }, {
      "value": "兰坪白族普米族自治县",
      "label": "兰坪白族普米族自治县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "怒江傈僳族自治州"
  }, {
    "value": "迪庆藏族自治州",
    "area": ["香格里拉县", "德钦县", "维西傈僳族自治县", "其他"],
    "children": [{
      "value": "香格里拉县",
      "label": "香格里拉县"
    }, {
      "value": "德钦县",
      "label": "德钦县"
    }, {
      "value": "维西傈僳族自治县",
      "label": "维西傈僳族自治县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "迪庆藏族自治州"
  }, {
    "value": "大理白族自治州",
    "area": ["大理市", "祥云县", "宾川县", "弥渡县", "永平县", "云龙县", "洱源县", "剑川县", "鹤庆县", "漾濞彝族自治县", "南涧彝族自治县", "巍山彝族回族自治县", "其他"],
    "children": [{
      "value": "大理市",
      "label": "大理市"
    }, {
      "value": "祥云县",
      "label": "祥云县"
    }, {
      "value": "宾川县",
      "label": "宾川县"
    }, {
      "value": "弥渡县",
      "label": "弥渡县"
    }, {
      "value": "永平县",
      "label": "永平县"
    }, {
      "value": "云龙县",
      "label": "云龙县"
    }, {
      "value": "洱源县",
      "label": "洱源县"
    }, {
      "value": "剑川县",
      "label": "剑川县"
    }, {
      "value": "鹤庆县",
      "label": "鹤庆县"
    }, {
      "value": "漾濞彝族自治县",
      "label": "漾濞彝族自治县"
    }, {
      "value": "南涧彝族自治县",
      "label": "南涧彝族自治县"
    }, {
      "value": "巍山彝族回族自治县",
      "label": "巍山彝族回族自治县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "大理白族自治州"
  }, {
    "value": "楚雄彝族自治州",
    "area": ["楚雄市", "双柏县", "牟定县", "南华县", "姚安县", "大姚县", "永仁县", "元谋县", "武定县", "禄丰县", "其他"],
    "children": [{
      "value": "楚雄市",
      "label": "楚雄市"
    }, {
      "value": "双柏县",
      "label": "双柏县"
    }, {
      "value": "牟定县",
      "label": "牟定县"
    }, {
      "value": "南华县",
      "label": "南华县"
    }, {
      "value": "姚安县",
      "label": "姚安县"
    }, {
      "value": "大姚县",
      "label": "大姚县"
    }, {
      "value": "永仁县",
      "label": "永仁县"
    }, {
      "value": "元谋县",
      "label": "元谋县"
    }, {
      "value": "武定县",
      "label": "武定县"
    }, {
      "value": "禄丰县",
      "label": "禄丰县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "楚雄彝族自治州"
  }, {
    "value": "红河哈尼族彝族自治州",
    "area": ["蒙自县", "个旧市", "开远市", "绿春县", "建水县", "石屏县", "弥勒县", "泸西县", "元阳县", "红河县", "金平苗族瑶族傣族自治县", "河口瑶族自治县", "屏边苗族自治县", "其他"],
    "children": [{
      "value": "蒙自县",
      "label": "蒙自县"
    }, {
      "value": "个旧市",
      "label": "个旧市"
    }, {
      "value": "开远市",
      "label": "开远市"
    }, {
      "value": "绿春县",
      "label": "绿春县"
    }, {
      "value": "建水县",
      "label": "建水县"
    }, {
      "value": "石屏县",
      "label": "石屏县"
    }, {
      "value": "弥勒县",
      "label": "弥勒县"
    }, {
      "value": "泸西县",
      "label": "泸西县"
    }, {
      "value": "元阳县",
      "label": "元阳县"
    }, {
      "value": "红河县",
      "label": "红河县"
    }, {
      "value": "金平苗族瑶族傣族自治县",
      "label": "金平苗族瑶族傣族自治县"
    }, {
      "value": "河口瑶族自治县",
      "label": "河口瑶族自治县"
    }, {
      "value": "屏边苗族自治县",
      "label": "屏边苗族自治县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "红河哈尼族彝族自治州"
  }, {
    "value": "文山壮族苗族自治州",
    "area": ["文山县", "砚山县", "西畴县", "麻栗坡县", "马关县", "丘北县", "广南县", "富宁县", "其他"],
    "children": [{
      "value": "文山县",
      "label": "文山县"
    }, {
      "value": "砚山县",
      "label": "砚山县"
    }, {
      "value": "西畴县",
      "label": "西畴县"
    }, {
      "value": "麻栗坡县",
      "label": "麻栗坡县"
    }, {
      "value": "马关县",
      "label": "马关县"
    }, {
      "value": "丘北县",
      "label": "丘北县"
    }, {
      "value": "广南县",
      "label": "广南县"
    }, {
      "value": "富宁县",
      "label": "富宁县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "文山壮族苗族自治州"
  }, {
    "value": "西双版纳傣族自治州",
    "area": ["景洪市", "勐海县", "勐腊县", "其他"],
    "children": [{
      "value": "景洪市",
      "label": "景洪市"
    }, {
      "value": "勐海县",
      "label": "勐海县"
    }, {
      "value": "勐腊县",
      "label": "勐腊县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "西双版纳傣族自治州"
  }, {
    "value": "其他",
    "area": ["其他"],
    "children": [{
      "value": "其他",
      "label": "其他"
    }],
    "label": "其他"
  }],
  "label": "云南省"
}, {
  "value": "西藏",
  "children": [{
    "value": "拉萨市",
    "area": ["城关区", "林周县", "当雄县", "尼木县", "曲水县", "堆龙德庆县", "达孜县", "墨竹工卡县", "其他"],
    "children": [{
      "value": "城关区",
      "label": "城关区"
    }, {
      "value": "林周县",
      "label": "林周县"
    }, {
      "value": "当雄县",
      "label": "当雄县"
    }, {
      "value": "尼木县",
      "label": "尼木县"
    }, {
      "value": "曲水县",
      "label": "曲水县"
    }, {
      "value": "堆龙德庆县",
      "label": "堆龙德庆县"
    }, {
      "value": "达孜县",
      "label": "达孜县"
    }, {
      "value": "墨竹工卡县",
      "label": "墨竹工卡县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "拉萨市"
  }, {
    "value": "那曲地区",
    "area": ["那曲县", "嘉黎县", "比如县", "聂荣县", "安多县", "申扎县", "索县", "班戈县", "巴青县", "尼玛县", "其他"],
    "children": [{
      "value": "那曲县",
      "label": "那曲县"
    }, {
      "value": "嘉黎县",
      "label": "嘉黎县"
    }, {
      "value": "比如县",
      "label": "比如县"
    }, {
      "value": "聂荣县",
      "label": "聂荣县"
    }, {
      "value": "安多县",
      "label": "安多县"
    }, {
      "value": "申扎县",
      "label": "申扎县"
    }, {
      "value": "索县",
      "label": "索县"
    }, {
      "value": "班戈县",
      "label": "班戈县"
    }, {
      "value": "巴青县",
      "label": "巴青县"
    }, {
      "value": "尼玛县",
      "label": "尼玛县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "那曲地区"
  }, {
    "value": "昌都地区",
    "area": ["昌都县", "江达县", "贡觉县", "类乌齐县", "丁青县", "察雅县", "八宿县", "左贡县", "芒康县", "洛隆县", "边坝县", "其他"],
    "children": [{
      "value": "昌都县",
      "label": "昌都县"
    }, {
      "value": "江达县",
      "label": "江达县"
    }, {
      "value": "贡觉县",
      "label": "贡觉县"
    }, {
      "value": "类乌齐县",
      "label": "类乌齐县"
    }, {
      "value": "丁青县",
      "label": "丁青县"
    }, {
      "value": "察雅县",
      "label": "察雅县"
    }, {
      "value": "八宿县",
      "label": "八宿县"
    }, {
      "value": "左贡县",
      "label": "左贡县"
    }, {
      "value": "芒康县",
      "label": "芒康县"
    }, {
      "value": "洛隆县",
      "label": "洛隆县"
    }, {
      "value": "边坝县",
      "label": "边坝县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "昌都地区"
  }, {
    "value": "林芝地区",
    "area": ["林芝县", "工布江达县", "米林县", "墨脱县", "波密县", "察隅县", "朗县", "其他"],
    "children": [{
      "value": "林芝县",
      "label": "林芝县"
    }, {
      "value": "工布江达县",
      "label": "工布江达县"
    }, {
      "value": "米林县",
      "label": "米林县"
    }, {
      "value": "墨脱县",
      "label": "墨脱县"
    }, {
      "value": "波密县",
      "label": "波密县"
    }, {
      "value": "察隅县",
      "label": "察隅县"
    }, {
      "value": "朗县",
      "label": "朗县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "林芝地区"
  }, {
    "value": "山南地区",
    "area": ["乃东县", "扎囊县", "贡嘎县", "桑日县", "琼结县", "曲松县", "措美县", "洛扎县", "加查县", "隆子县", "错那县", "浪卡子县", "其他"],
    "children": [{
      "value": "乃东县",
      "label": "乃东县"
    }, {
      "value": "扎囊县",
      "label": "扎囊县"
    }, {
      "value": "贡嘎县",
      "label": "贡嘎县"
    }, {
      "value": "桑日县",
      "label": "桑日县"
    }, {
      "value": "琼结县",
      "label": "琼结县"
    }, {
      "value": "曲松县",
      "label": "曲松县"
    }, {
      "value": "措美县",
      "label": "措美县"
    }, {
      "value": "洛扎县",
      "label": "洛扎县"
    }, {
      "value": "加查县",
      "label": "加查县"
    }, {
      "value": "隆子县",
      "label": "隆子县"
    }, {
      "value": "错那县",
      "label": "错那县"
    }, {
      "value": "浪卡子县",
      "label": "浪卡子县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "山南地区"
  }, {
    "value": "日喀则地区",
    "area": ["日喀则市", "南木林县", "江孜县", "定日县", "萨迦县", "拉孜县", "昂仁县", "谢通门县", "白朗县", "仁布县", "康马县", "定结县", "仲巴县", "亚东县", "吉隆县", "聂拉木县", "萨嘎县", "岗巴县", "其他"],
    "children": [{
      "value": "日喀则市",
      "label": "日喀则市"
    }, {
      "value": "南木林县",
      "label": "南木林县"
    }, {
      "value": "江孜县",
      "label": "江孜县"
    }, {
      "value": "定日县",
      "label": "定日县"
    }, {
      "value": "萨迦县",
      "label": "萨迦县"
    }, {
      "value": "拉孜县",
      "label": "拉孜县"
    }, {
      "value": "昂仁县",
      "label": "昂仁县"
    }, {
      "value": "谢通门县",
      "label": "谢通门县"
    }, {
      "value": "白朗县",
      "label": "白朗县"
    }, {
      "value": "仁布县",
      "label": "仁布县"
    }, {
      "value": "康马县",
      "label": "康马县"
    }, {
      "value": "定结县",
      "label": "定结县"
    }, {
      "value": "仲巴县",
      "label": "仲巴县"
    }, {
      "value": "亚东县",
      "label": "亚东县"
    }, {
      "value": "吉隆县",
      "label": "吉隆县"
    }, {
      "value": "聂拉木县",
      "label": "聂拉木县"
    }, {
      "value": "萨嘎县",
      "label": "萨嘎县"
    }, {
      "value": "岗巴县",
      "label": "岗巴县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "日喀则地区"
  }, {
    "value": "阿里地区",
    "area": ["噶尔县", "普兰县", "札达县", "日土县", "革吉县", "改则县", "措勤县", "其他"],
    "children": [{
      "value": "噶尔县",
      "label": "噶尔县"
    }, {
      "value": "普兰县",
      "label": "普兰县"
    }, {
      "value": "札达县",
      "label": "札达县"
    }, {
      "value": "日土县",
      "label": "日土县"
    }, {
      "value": "革吉县",
      "label": "革吉县"
    }, {
      "value": "改则县",
      "label": "改则县"
    }, {
      "value": "措勤县",
      "label": "措勤县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "阿里地区"
  }, {
    "value": "其他",
    "area": ["其他"],
    "children": [{
      "value": "其他",
      "label": "其他"
    }],
    "label": "其他"
  }],
  "label": "西藏"
}, {
  "value": "陕西省",
  "children": [{
    "value": "西安市",
    "area": ["莲湖区", "新城区", "碑林区", "雁塔区", "灞桥区", "未央区", "阎良区", "临潼区", "长安区", "高陵县", "蓝田县", "户县", "周至县", "其他"],
    "children": [{
      "value": "莲湖区",
      "label": "莲湖区"
    }, {
      "value": "新城区",
      "label": "新城区"
    }, {
      "value": "碑林区",
      "label": "碑林区"
    }, {
      "value": "雁塔区",
      "label": "雁塔区"
    }, {
      "value": "灞桥区",
      "label": "灞桥区"
    }, {
      "value": "未央区",
      "label": "未央区"
    }, {
      "value": "阎良区",
      "label": "阎良区"
    }, {
      "value": "临潼区",
      "label": "临潼区"
    }, {
      "value": "长安区",
      "label": "长安区"
    }, {
      "value": "高陵县",
      "label": "高陵县"
    }, {
      "value": "蓝田县",
      "label": "蓝田县"
    }, {
      "value": "户县",
      "label": "户县"
    }, {
      "value": "周至县",
      "label": "周至县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "西安市"
  }, {
    "value": "铜川市",
    "area": ["耀州区", "王益区", "印台区", "宜君县", "其他"],
    "children": [{
      "value": "耀州区",
      "label": "耀州区"
    }, {
      "value": "王益区",
      "label": "王益区"
    }, {
      "value": "印台区",
      "label": "印台区"
    }, {
      "value": "宜君县",
      "label": "宜君县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "铜川市"
  }, {
    "value": "宝鸡市",
    "area": ["渭滨区", "金台区", "陈仓区", "岐山县", "凤翔县", "陇县", "太白县", "麟游县", "扶风县", "千阳县", "眉县", "凤县", "其他"],
    "children": [{
      "value": "渭滨区",
      "label": "渭滨区"
    }, {
      "value": "金台区",
      "label": "金台区"
    }, {
      "value": "陈仓区",
      "label": "陈仓区"
    }, {
      "value": "岐山县",
      "label": "岐山县"
    }, {
      "value": "凤翔县",
      "label": "凤翔县"
    }, {
      "value": "陇县",
      "label": "陇县"
    }, {
      "value": "太白县",
      "label": "太白县"
    }, {
      "value": "麟游县",
      "label": "麟游县"
    }, {
      "value": "扶风县",
      "label": "扶风县"
    }, {
      "value": "千阳县",
      "label": "千阳县"
    }, {
      "value": "眉县",
      "label": "眉县"
    }, {
      "value": "凤县",
      "label": "凤县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "宝鸡市"
  }, {
    "value": "咸阳市",
    "area": ["秦都区", "渭城区", "杨陵区", "兴平市", "礼泉县", "泾阳县", "永寿县", "三原县", "彬县", "旬邑县", "长武县", "乾县", "武功县", "淳化县", "其他"],
    "children": [{
      "value": "秦都区",
      "label": "秦都区"
    }, {
      "value": "渭城区",
      "label": "渭城区"
    }, {
      "value": "杨陵区",
      "label": "杨陵区"
    }, {
      "value": "兴平市",
      "label": "兴平市"
    }, {
      "value": "礼泉县",
      "label": "礼泉县"
    }, {
      "value": "泾阳县",
      "label": "泾阳县"
    }, {
      "value": "永寿县",
      "label": "永寿县"
    }, {
      "value": "三原县",
      "label": "三原县"
    }, {
      "value": "彬县",
      "label": "彬县"
    }, {
      "value": "旬邑县",
      "label": "旬邑县"
    }, {
      "value": "长武县",
      "label": "长武县"
    }, {
      "value": "乾县",
      "label": "乾县"
    }, {
      "value": "武功县",
      "label": "武功县"
    }, {
      "value": "淳化县",
      "label": "淳化县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "咸阳市"
  }, {
    "value": "渭南市",
    "area": ["临渭区", "韩城市", "华阴市", "蒲城县", "潼关县", "白水县", "澄城县", "华县", "合阳县", "富平县", "大荔县", "其他"],
    "children": [{
      "value": "临渭区",
      "label": "临渭区"
    }, {
      "value": "韩城市",
      "label": "韩城市"
    }, {
      "value": "华阴市",
      "label": "华阴市"
    }, {
      "value": "蒲城县",
      "label": "蒲城县"
    }, {
      "value": "潼关县",
      "label": "潼关县"
    }, {
      "value": "白水县",
      "label": "白水县"
    }, {
      "value": "澄城县",
      "label": "澄城县"
    }, {
      "value": "华县",
      "label": "华县"
    }, {
      "value": "合阳县",
      "label": "合阳县"
    }, {
      "value": "富平县",
      "label": "富平县"
    }, {
      "value": "大荔县",
      "label": "大荔县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "渭南市"
  }, {
    "value": "延安市",
    "area": ["宝塔区", "安塞县", "洛川县", "子长县", "黄陵县", "延川县", "富县", "延长县", "甘泉县", "宜川县", "志丹县", "黄龙县", "吴起县", "其他"],
    "children": [{
      "value": "宝塔区",
      "label": "宝塔区"
    }, {
      "value": "安塞县",
      "label": "安塞县"
    }, {
      "value": "洛川县",
      "label": "洛川县"
    }, {
      "value": "子长县",
      "label": "子长县"
    }, {
      "value": "黄陵县",
      "label": "黄陵县"
    }, {
      "value": "延川县",
      "label": "延川县"
    }, {
      "value": "富县",
      "label": "富县"
    }, {
      "value": "延长县",
      "label": "延长县"
    }, {
      "value": "甘泉县",
      "label": "甘泉县"
    }, {
      "value": "宜川县",
      "label": "宜川县"
    }, {
      "value": "志丹县",
      "label": "志丹县"
    }, {
      "value": "黄龙县",
      "label": "黄龙县"
    }, {
      "value": "吴起县",
      "label": "吴起县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "延安市"
  }, {
    "value": "汉中市",
    "area": ["汉台区", "留坝县", "镇巴县", "城固县", "南郑县", "洋县", "宁强县", "佛坪县", "勉县", "西乡县", "略阳县", "其他"],
    "children": [{
      "value": "汉台区",
      "label": "汉台区"
    }, {
      "value": "留坝县",
      "label": "留坝县"
    }, {
      "value": "镇巴县",
      "label": "镇巴县"
    }, {
      "value": "城固县",
      "label": "城固县"
    }, {
      "value": "南郑县",
      "label": "南郑县"
    }, {
      "value": "洋县",
      "label": "洋县"
    }, {
      "value": "宁强县",
      "label": "宁强县"
    }, {
      "value": "佛坪县",
      "label": "佛坪县"
    }, {
      "value": "勉县",
      "label": "勉县"
    }, {
      "value": "西乡县",
      "label": "西乡县"
    }, {
      "value": "略阳县",
      "label": "略阳县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "汉中市"
  }, {
    "value": "榆林市",
    "area": ["榆阳区", "清涧县", "绥德县", "神木县", "佳县", "府谷县", "子洲县", "靖边县", "横山县", "米脂县", "吴堡县", "定边县", "其他"],
    "children": [{
      "value": "榆阳区",
      "label": "榆阳区"
    }, {
      "value": "清涧县",
      "label": "清涧县"
    }, {
      "value": "绥德县",
      "label": "绥德县"
    }, {
      "value": "神木县",
      "label": "神木县"
    }, {
      "value": "佳县",
      "label": "佳县"
    }, {
      "value": "府谷县",
      "label": "府谷县"
    }, {
      "value": "子洲县",
      "label": "子洲县"
    }, {
      "value": "靖边县",
      "label": "靖边县"
    }, {
      "value": "横山县",
      "label": "横山县"
    }, {
      "value": "米脂县",
      "label": "米脂县"
    }, {
      "value": "吴堡县",
      "label": "吴堡县"
    }, {
      "value": "定边县",
      "label": "定边县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "榆林市"
  }, {
    "value": "安康市",
    "area": ["汉滨区", "紫阳县", "岚皋县", "旬阳县", "镇坪县", "平利县", "石泉县", "宁陕县", "白河县", "汉阴县", "其他"],
    "children": [{
      "value": "汉滨区",
      "label": "汉滨区"
    }, {
      "value": "紫阳县",
      "label": "紫阳县"
    }, {
      "value": "岚皋县",
      "label": "岚皋县"
    }, {
      "value": "旬阳县",
      "label": "旬阳县"
    }, {
      "value": "镇坪县",
      "label": "镇坪县"
    }, {
      "value": "平利县",
      "label": "平利县"
    }, {
      "value": "石泉县",
      "label": "石泉县"
    }, {
      "value": "宁陕县",
      "label": "宁陕县"
    }, {
      "value": "白河县",
      "label": "白河县"
    }, {
      "value": "汉阴县",
      "label": "汉阴县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "安康市"
  }, {
    "value": "商洛市",
    "area": ["商州区", "镇安县", "山阳县", "洛南县", "商南县", "丹凤县", "柞水县", "其他"],
    "children": [{
      "value": "商州区",
      "label": "商州区"
    }, {
      "value": "镇安县",
      "label": "镇安县"
    }, {
      "value": "山阳县",
      "label": "山阳县"
    }, {
      "value": "洛南县",
      "label": "洛南县"
    }, {
      "value": "商南县",
      "label": "商南县"
    }, {
      "value": "丹凤县",
      "label": "丹凤县"
    }, {
      "value": "柞水县",
      "label": "柞水县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "商洛市"
  }, {
    "value": "其他",
    "area": ["其他"],
    "children": [{
      "value": "其他",
      "label": "其他"
    }],
    "label": "其他"
  }],
  "label": "陕西省"
}, {
  "value": "甘肃省",
  "children": [{
    "value": "兰州市",
    "area": ["城关区", "七里河区", "西固区", "安宁区", "红古区", "永登县", "皋兰县", "榆中县", "其他"],
    "children": [{
      "value": "城关区",
      "label": "城关区"
    }, {
      "value": "七里河区",
      "label": "七里河区"
    }, {
      "value": "西固区",
      "label": "西固区"
    }, {
      "value": "安宁区",
      "label": "安宁区"
    }, {
      "value": "红古区",
      "label": "红古区"
    }, {
      "value": "永登县",
      "label": "永登县"
    }, {
      "value": "皋兰县",
      "label": "皋兰县"
    }, {
      "value": "榆中县",
      "label": "榆中县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "兰州市"
  }, {
    "value": "嘉峪关市",
    "area": ["嘉峪关市", "其他"],
    "children": [{
      "value": "嘉峪关市",
      "label": "嘉峪关市"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "嘉峪关市"
  }, {
    "value": "金昌市",
    "area": ["金川区", "永昌县", "其他"],
    "children": [{
      "value": "金川区",
      "label": "金川区"
    }, {
      "value": "永昌县",
      "label": "永昌县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "金昌市"
  }, {
    "value": "白银市",
    "area": ["白银区", "平川区", "靖远县", "会宁县", "景泰县", "其他"],
    "children": [{
      "value": "白银区",
      "label": "白银区"
    }, {
      "value": "平川区",
      "label": "平川区"
    }, {
      "value": "靖远县",
      "label": "靖远县"
    }, {
      "value": "会宁县",
      "label": "会宁县"
    }, {
      "value": "景泰县",
      "label": "景泰县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "白银市"
  }, {
    "value": "天水市",
    "area": ["清水县", "秦安县", "甘谷县", "武山县", "张家川回族自治县", "北道区", "秦城区", "其他"],
    "children": [{
      "value": "清水县",
      "label": "清水县"
    }, {
      "value": "秦安县",
      "label": "秦安县"
    }, {
      "value": "甘谷县",
      "label": "甘谷县"
    }, {
      "value": "武山县",
      "label": "武山县"
    }, {
      "value": "张家川回族自治县",
      "label": "张家川回族自治县"
    }, {
      "value": "北道区",
      "label": "北道区"
    }, {
      "value": "秦城区",
      "label": "秦城区"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "天水市"
  }, {
    "value": "武威市",
    "area": ["凉州区", "民勤县", "古浪县", "天祝藏族自治县", "其他"],
    "children": [{
      "value": "凉州区",
      "label": "凉州区"
    }, {
      "value": "民勤县",
      "label": "民勤县"
    }, {
      "value": "古浪县",
      "label": "古浪县"
    }, {
      "value": "天祝藏族自治县",
      "label": "天祝藏族自治县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "武威市"
  }, {
    "value": "酒泉市",
    "area": ["肃州区", "玉门市", "敦煌市", "金塔县", "肃北蒙古族自治县", "阿克塞哈萨克族自治县", "安西县", "其他"],
    "children": [{
      "value": "肃州区",
      "label": "肃州区"
    }, {
      "value": "玉门市",
      "label": "玉门市"
    }, {
      "value": "敦煌市",
      "label": "敦煌市"
    }, {
      "value": "金塔县",
      "label": "金塔县"
    }, {
      "value": "肃北蒙古族自治县",
      "label": "肃北蒙古族自治县"
    }, {
      "value": "阿克塞哈萨克族自治县",
      "label": "阿克塞哈萨克族自治县"
    }, {
      "value": "安西县",
      "label": "安西县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "酒泉市"
  }, {
    "value": "张掖市",
    "area": ["甘州区", "民乐县", "临泽县", "高台县", "山丹县", "肃南裕固族自治县", "其他"],
    "children": [{
      "value": "甘州区",
      "label": "甘州区"
    }, {
      "value": "民乐县",
      "label": "民乐县"
    }, {
      "value": "临泽县",
      "label": "临泽县"
    }, {
      "value": "高台县",
      "label": "高台县"
    }, {
      "value": "山丹县",
      "label": "山丹县"
    }, {
      "value": "肃南裕固族自治县",
      "label": "肃南裕固族自治县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "张掖市"
  }, {
    "value": "庆阳市",
    "area": ["西峰区", "庆城县", "环县", "华池县", "合水县", "正宁县", "宁县", "镇原县", "其他"],
    "children": [{
      "value": "西峰区",
      "label": "西峰区"
    }, {
      "value": "庆城县",
      "label": "庆城县"
    }, {
      "value": "环县",
      "label": "环县"
    }, {
      "value": "华池县",
      "label": "华池县"
    }, {
      "value": "合水县",
      "label": "合水县"
    }, {
      "value": "正宁县",
      "label": "正宁县"
    }, {
      "value": "宁县",
      "label": "宁县"
    }, {
      "value": "镇原县",
      "label": "镇原县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "庆阳市"
  }, {
    "value": "平凉市",
    "area": ["崆峒区", "泾川县", "灵台县", "崇信县", "华亭县", "庄浪县", "静宁县", "其他"],
    "children": [{
      "value": "崆峒区",
      "label": "崆峒区"
    }, {
      "value": "泾川县",
      "label": "泾川县"
    }, {
      "value": "灵台县",
      "label": "灵台县"
    }, {
      "value": "崇信县",
      "label": "崇信县"
    }, {
      "value": "华亭县",
      "label": "华亭县"
    }, {
      "value": "庄浪县",
      "label": "庄浪县"
    }, {
      "value": "静宁县",
      "label": "静宁县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "平凉市"
  }, {
    "value": "定西市",
    "area": ["安定区", "通渭县", "临洮县", "漳县", "岷县", "渭源县", "陇西县", "其他"],
    "children": [{
      "value": "安定区",
      "label": "安定区"
    }, {
      "value": "通渭县",
      "label": "通渭县"
    }, {
      "value": "临洮县",
      "label": "临洮县"
    }, {
      "value": "漳县",
      "label": "漳县"
    }, {
      "value": "岷县",
      "label": "岷县"
    }, {
      "value": "渭源县",
      "label": "渭源县"
    }, {
      "value": "陇西县",
      "label": "陇西县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "定西市"
  }, {
    "value": "陇南市",
    "area": ["武都区", "成县", "宕昌县", "康县", "文县", "西和县", "礼县", "两当县", "徽县", "其他"],
    "children": [{
      "value": "武都区",
      "label": "武都区"
    }, {
      "value": "成县",
      "label": "成县"
    }, {
      "value": "宕昌县",
      "label": "宕昌县"
    }, {
      "value": "康县",
      "label": "康县"
    }, {
      "value": "文县",
      "label": "文县"
    }, {
      "value": "西和县",
      "label": "西和县"
    }, {
      "value": "礼县",
      "label": "礼县"
    }, {
      "value": "两当县",
      "label": "两当县"
    }, {
      "value": "徽县",
      "label": "徽县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "陇南市"
  }, {
    "value": "临夏回族自治州",
    "area": ["临夏市", "临夏县", "康乐县", "永靖县", "广河县", "和政县", "东乡族自治县", "积石山保安族东乡族撒拉族自治县", "其他"],
    "children": [{
      "value": "临夏市",
      "label": "临夏市"
    }, {
      "value": "临夏县",
      "label": "临夏县"
    }, {
      "value": "康乐县",
      "label": "康乐县"
    }, {
      "value": "永靖县",
      "label": "永靖县"
    }, {
      "value": "广河县",
      "label": "广河县"
    }, {
      "value": "和政县",
      "label": "和政县"
    }, {
      "value": "东乡族自治县",
      "label": "东乡族自治县"
    }, {
      "value": "积石山保安族东乡族撒拉族自治县",
      "label": "积石山保安族东乡族撒拉族自治县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "临夏回族自治州"
  }, {
    "value": "甘南藏族自治州",
    "area": ["合作市", "临潭县", "卓尼县", "舟曲县", "迭部县", "玛曲县", "碌曲县", "夏河县", "其他"],
    "children": [{
      "value": "合作市",
      "label": "合作市"
    }, {
      "value": "临潭县",
      "label": "临潭县"
    }, {
      "value": "卓尼县",
      "label": "卓尼县"
    }, {
      "value": "舟曲县",
      "label": "舟曲县"
    }, {
      "value": "迭部县",
      "label": "迭部县"
    }, {
      "value": "玛曲县",
      "label": "玛曲县"
    }, {
      "value": "碌曲县",
      "label": "碌曲县"
    }, {
      "value": "夏河县",
      "label": "夏河县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "甘南藏族自治州"
  }, {
    "value": "其他",
    "area": ["其他"],
    "children": [{
      "value": "其他",
      "label": "其他"
    }],
    "label": "其他"
  }],
  "label": "甘肃省"
}, {
  "value": "青海省",
  "children": [{
    "value": "西宁市",
    "area": ["城中区", "城东区", "城西区", "城北区", "湟源县", "湟中县", "大通回族土族自治县", "其他"],
    "children": [{
      "value": "城中区",
      "label": "城中区"
    }, {
      "value": "城东区",
      "label": "城东区"
    }, {
      "value": "城西区",
      "label": "城西区"
    }, {
      "value": "城北区",
      "label": "城北区"
    }, {
      "value": "湟源县",
      "label": "湟源县"
    }, {
      "value": "湟中县",
      "label": "湟中县"
    }, {
      "value": "大通回族土族自治县",
      "label": "大通回族土族自治县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "西宁市"
  }, {
    "value": "海东地区",
    "area": ["平安县", "乐都县", "民和回族土族自治县", "互助土族自治县", "化隆回族自治县", "循化撒拉族自治县", "其他"],
    "children": [{
      "value": "平安县",
      "label": "平安县"
    }, {
      "value": "乐都县",
      "label": "乐都县"
    }, {
      "value": "民和回族土族自治县",
      "label": "民和回族土族自治县"
    }, {
      "value": "互助土族自治县",
      "label": "互助土族自治县"
    }, {
      "value": "化隆回族自治县",
      "label": "化隆回族自治县"
    }, {
      "value": "循化撒拉族自治县",
      "label": "循化撒拉族自治县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "海东地区"
  }, {
    "value": "海北藏族自治州",
    "area": ["海晏县", "祁连县", "刚察县", "门源回族自治县", "其他"],
    "children": [{
      "value": "海晏县",
      "label": "海晏县"
    }, {
      "value": "祁连县",
      "label": "祁连县"
    }, {
      "value": "刚察县",
      "label": "刚察县"
    }, {
      "value": "门源回族自治县",
      "label": "门源回族自治县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "海北藏族自治州"
  }, {
    "value": "海南藏族自治州",
    "area": ["共和县", "同德县", "贵德县", "兴海县", "贵南县", "其他"],
    "children": [{
      "value": "共和县",
      "label": "共和县"
    }, {
      "value": "同德县",
      "label": "同德县"
    }, {
      "value": "贵德县",
      "label": "贵德县"
    }, {
      "value": "兴海县",
      "label": "兴海县"
    }, {
      "value": "贵南县",
      "label": "贵南县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "海南藏族自治州"
  }, {
    "value": "黄南藏族自治州",
    "area": ["同仁县", "尖扎县", "泽库县", "河南蒙古族自治县", "其他"],
    "children": [{
      "value": "同仁县",
      "label": "同仁县"
    }, {
      "value": "尖扎县",
      "label": "尖扎县"
    }, {
      "value": "泽库县",
      "label": "泽库县"
    }, {
      "value": "河南蒙古族自治县",
      "label": "河南蒙古族自治县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "黄南藏族自治州"
  }, {
    "value": "果洛藏族自治州",
    "area": ["玛沁县", "班玛县", "甘德县", "达日县", "久治县", "玛多县", "其他"],
    "children": [{
      "value": "玛沁县",
      "label": "玛沁县"
    }, {
      "value": "班玛县",
      "label": "班玛县"
    }, {
      "value": "甘德县",
      "label": "甘德县"
    }, {
      "value": "达日县",
      "label": "达日县"
    }, {
      "value": "久治县",
      "label": "久治县"
    }, {
      "value": "玛多县",
      "label": "玛多县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "果洛藏族自治州"
  }, {
    "value": "玉树藏族自治州",
    "area": ["玉树县", "杂多县", "称多县", "治多县", "囊谦县", "曲麻莱县", "其他"],
    "children": [{
      "value": "玉树县",
      "label": "玉树县"
    }, {
      "value": "杂多县",
      "label": "杂多县"
    }, {
      "value": "称多县",
      "label": "称多县"
    }, {
      "value": "治多县",
      "label": "治多县"
    }, {
      "value": "囊谦县",
      "label": "囊谦县"
    }, {
      "value": "曲麻莱县",
      "label": "曲麻莱县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "玉树藏族自治州"
  }, {
    "value": "海西蒙古族藏族自治州",
    "area": ["德令哈市", "格尔木市", "乌兰县", "都兰县", "天峻县", "其他"],
    "children": [{
      "value": "德令哈市",
      "label": "德令哈市"
    }, {
      "value": "格尔木市",
      "label": "格尔木市"
    }, {
      "value": "乌兰县",
      "label": "乌兰县"
    }, {
      "value": "都兰县",
      "label": "都兰县"
    }, {
      "value": "天峻县",
      "label": "天峻县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "海西蒙古族藏族自治州"
  }, {
    "value": "其他",
    "area": ["其他"],
    "children": [{
      "value": "其他",
      "label": "其他"
    }],
    "label": "其他"
  }],
  "label": "青海省"
}, {
  "value": "宁夏",
  "children": [{
    "value": "银川市",
    "area": ["兴庆区", "西夏区", "金凤区", "灵武市", "永宁县", "贺兰县", "其他"],
    "children": [{
      "value": "兴庆区",
      "label": "兴庆区"
    }, {
      "value": "西夏区",
      "label": "西夏区"
    }, {
      "value": "金凤区",
      "label": "金凤区"
    }, {
      "value": "灵武市",
      "label": "灵武市"
    }, {
      "value": "永宁县",
      "label": "永宁县"
    }, {
      "value": "贺兰县",
      "label": "贺兰县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "银川市"
  }, {
    "value": "石嘴山市",
    "area": ["大武口区", "惠农区", "平罗县", "其他"],
    "children": [{
      "value": "大武口区",
      "label": "大武口区"
    }, {
      "value": "惠农区",
      "label": "惠农区"
    }, {
      "value": "平罗县",
      "label": "平罗县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "石嘴山市"
  }, {
    "value": "吴忠市",
    "area": ["利通区", "青铜峡市", "盐池县", "同心县", "其他"],
    "children": [{
      "value": "利通区",
      "label": "利通区"
    }, {
      "value": "青铜峡市",
      "label": "青铜峡市"
    }, {
      "value": "盐池县",
      "label": "盐池县"
    }, {
      "value": "同心县",
      "label": "同心县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "吴忠市"
  }, {
    "value": "固原市",
    "area": ["原州区", "西吉县", "隆德县", "泾源县", "彭阳县", "其他"],
    "children": [{
      "value": "原州区",
      "label": "原州区"
    }, {
      "value": "西吉县",
      "label": "西吉县"
    }, {
      "value": "隆德县",
      "label": "隆德县"
    }, {
      "value": "泾源县",
      "label": "泾源县"
    }, {
      "value": "彭阳县",
      "label": "彭阳县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "固原市"
  }, {
    "value": "中卫市",
    "area": ["沙坡头区", "中宁县", "海原县", "其他"],
    "children": [{
      "value": "沙坡头区",
      "label": "沙坡头区"
    }, {
      "value": "中宁县",
      "label": "中宁县"
    }, {
      "value": "海原县",
      "label": "海原县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "中卫市"
  }, {
    "value": "其他",
    "area": ["其他"],
    "children": [{
      "value": "其他",
      "label": "其他"
    }],
    "label": "其他"
  }],
  "label": "宁夏"
}, {
  "value": "新疆",
  "children": [{
    "value": "乌鲁木齐市",
    "area": ["天山区", "沙依巴克区", "新市区", "水磨沟区", "头屯河区", "达坂城区", "东山区", "乌鲁木齐县", "其他"],
    "children": [{
      "value": "天山区",
      "label": "天山区"
    }, {
      "value": "沙依巴克区",
      "label": "沙依巴克区"
    }, {
      "value": "新市区",
      "label": "新市区"
    }, {
      "value": "水磨沟区",
      "label": "水磨沟区"
    }, {
      "value": "头屯河区",
      "label": "头屯河区"
    }, {
      "value": "达坂城区",
      "label": "达坂城区"
    }, {
      "value": "东山区",
      "label": "东山区"
    }, {
      "value": "乌鲁木齐县",
      "label": "乌鲁木齐县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "乌鲁木齐市"
  }, {
    "value": "克拉玛依市",
    "area": ["克拉玛依区", "独山子区", "白碱滩区", "乌尔禾区", "其他"],
    "children": [{
      "value": "克拉玛依区",
      "label": "克拉玛依区"
    }, {
      "value": "独山子区",
      "label": "独山子区"
    }, {
      "value": "白碱滩区",
      "label": "白碱滩区"
    }, {
      "value": "乌尔禾区",
      "label": "乌尔禾区"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "克拉玛依市"
  }, {
    "value": "吐鲁番地区",
    "area": ["吐鲁番市", "托克逊县", "鄯善县", "其他"],
    "children": [{
      "value": "吐鲁番市",
      "label": "吐鲁番市"
    }, {
      "value": "托克逊县",
      "label": "托克逊县"
    }, {
      "value": "鄯善县",
      "label": "鄯善县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "吐鲁番地区"
  }, {
    "value": "哈密地区",
    "area": ["哈密市", "伊吾县", "巴里坤哈萨克自治县", "其他"],
    "children": [{
      "value": "哈密市",
      "label": "哈密市"
    }, {
      "value": "伊吾县",
      "label": "伊吾县"
    }, {
      "value": "巴里坤哈萨克自治县",
      "label": "巴里坤哈萨克自治县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "哈密地区"
  }, {
    "value": "和田地区",
    "area": ["和田市", "和田县", "洛浦县", "民丰县", "皮山县", "策勒县", "于田县", "墨玉县", "其他"],
    "children": [{
      "value": "和田市",
      "label": "和田市"
    }, {
      "value": "和田县",
      "label": "和田县"
    }, {
      "value": "洛浦县",
      "label": "洛浦县"
    }, {
      "value": "民丰县",
      "label": "民丰县"
    }, {
      "value": "皮山县",
      "label": "皮山县"
    }, {
      "value": "策勒县",
      "label": "策勒县"
    }, {
      "value": "于田县",
      "label": "于田县"
    }, {
      "value": "墨玉县",
      "label": "墨玉县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "和田地区"
  }, {
    "value": "阿克苏地区",
    "area": ["阿克苏市", "温宿县", "沙雅县", "拜城县", "阿瓦提县", "库车县", "柯坪县", "新和县", "乌什县", "其他"],
    "children": [{
      "value": "阿克苏市",
      "label": "阿克苏市"
    }, {
      "value": "温宿县",
      "label": "温宿县"
    }, {
      "value": "沙雅县",
      "label": "沙雅县"
    }, {
      "value": "拜城县",
      "label": "拜城县"
    }, {
      "value": "阿瓦提县",
      "label": "阿瓦提县"
    }, {
      "value": "库车县",
      "label": "库车县"
    }, {
      "value": "柯坪县",
      "label": "柯坪县"
    }, {
      "value": "新和县",
      "label": "新和县"
    }, {
      "value": "乌什县",
      "label": "乌什县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "阿克苏地区"
  }, {
    "value": "喀什地区",
    "area": ["喀什市", "巴楚县", "泽普县", "伽师县", "叶城县", "岳普湖县", "疏勒县", "麦盖提县", "英吉沙县", "莎车县", "疏附县", "塔什库尔干塔吉克自治县", "其他"],
    "children": [{
      "value": "喀什市",
      "label": "喀什市"
    }, {
      "value": "巴楚县",
      "label": "巴楚县"
    }, {
      "value": "泽普县",
      "label": "泽普县"
    }, {
      "value": "伽师县",
      "label": "伽师县"
    }, {
      "value": "叶城县",
      "label": "叶城县"
    }, {
      "value": "岳普湖县",
      "label": "岳普湖县"
    }, {
      "value": "疏勒县",
      "label": "疏勒县"
    }, {
      "value": "麦盖提县",
      "label": "麦盖提县"
    }, {
      "value": "英吉沙县",
      "label": "英吉沙县"
    }, {
      "value": "莎车县",
      "label": "莎车县"
    }, {
      "value": "疏附县",
      "label": "疏附县"
    }, {
      "value": "塔什库尔干塔吉克自治县",
      "label": "塔什库尔干塔吉克自治县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "喀什地区"
  }, {
    "value": "克孜勒苏柯尔克孜自治州",
    "area": ["阿图什市", "阿合奇县", "乌恰县", "阿克陶县", "其他"],
    "children": [{
      "value": "阿图什市",
      "label": "阿图什市"
    }, {
      "value": "阿合奇县",
      "label": "阿合奇县"
    }, {
      "value": "乌恰县",
      "label": "乌恰县"
    }, {
      "value": "阿克陶县",
      "label": "阿克陶县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "克孜勒苏柯尔克孜自治州"
  }, {
    "value": "巴音郭楞蒙古自治州",
    "area": ["库尔勒市", "和静县", "尉犁县", "和硕县", "且末县", "博湖县", "轮台县", "若羌县", "焉耆回族自治县", "其他"],
    "children": [{
      "value": "库尔勒市",
      "label": "库尔勒市"
    }, {
      "value": "和静县",
      "label": "和静县"
    }, {
      "value": "尉犁县",
      "label": "尉犁县"
    }, {
      "value": "和硕县",
      "label": "和硕县"
    }, {
      "value": "且末县",
      "label": "且末县"
    }, {
      "value": "博湖县",
      "label": "博湖县"
    }, {
      "value": "轮台县",
      "label": "轮台县"
    }, {
      "value": "若羌县",
      "label": "若羌县"
    }, {
      "value": "焉耆回族自治县",
      "label": "焉耆回族自治县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "巴音郭楞蒙古自治州"
  }, {
    "value": "昌吉回族自治州",
    "area": ["昌吉市", "阜康市", "奇台县", "玛纳斯县", "吉木萨尔县", "呼图壁县", "木垒哈萨克自治县", "米泉市", "其他"],
    "children": [{
      "value": "昌吉市",
      "label": "昌吉市"
    }, {
      "value": "阜康市",
      "label": "阜康市"
    }, {
      "value": "奇台县",
      "label": "奇台县"
    }, {
      "value": "玛纳斯县",
      "label": "玛纳斯县"
    }, {
      "value": "吉木萨尔县",
      "label": "吉木萨尔县"
    }, {
      "value": "呼图壁县",
      "label": "呼图壁县"
    }, {
      "value": "木垒哈萨克自治县",
      "label": "木垒哈萨克自治县"
    }, {
      "value": "米泉市",
      "label": "米泉市"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "昌吉回族自治州"
  }, {
    "value": "博尔塔拉蒙古自治州",
    "area": ["博乐市", "精河县", "温泉县", "其他"],
    "children": [{
      "value": "博乐市",
      "label": "博乐市"
    }, {
      "value": "精河县",
      "label": "精河县"
    }, {
      "value": "温泉县",
      "label": "温泉县"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "博尔塔拉蒙古自治州"
  }, {
    "value": "石河子",
    "area": ["石河子"],
    "children": [{
      "value": "石河子",
      "label": "石河子"
    }],
    "label": "石河子"
  }, {
    "value": "阿拉尔",
    "area": ["阿拉尔"],
    "children": [{
      "value": "阿拉尔",
      "label": "阿拉尔"
    }],
    "label": "阿拉尔"
  }, {
    "value": "图木舒克",
    "area": ["图木舒克"],
    "children": [{
      "value": "图木舒克",
      "label": "图木舒克"
    }],
    "label": "图木舒克"
  }, {
    "value": "五家渠",
    "area": ["五家渠"],
    "children": [{
      "value": "五家渠",
      "label": "五家渠"
    }],
    "label": "五家渠"
  }, {
    "value": "伊犁哈萨克自治州",
    "area": ["伊宁市", "奎屯市", "伊宁县", "特克斯县", "尼勒克县", "昭苏县", "新源县", "霍城县", "巩留县", "察布查尔锡伯自治县", "塔城地区", "阿勒泰地区", "其他"],
    "children": [{
      "value": "伊宁市",
      "label": "伊宁市"
    }, {
      "value": "奎屯市",
      "label": "奎屯市"
    }, {
      "value": "伊宁县",
      "label": "伊宁县"
    }, {
      "value": "特克斯县",
      "label": "特克斯县"
    }, {
      "value": "尼勒克县",
      "label": "尼勒克县"
    }, {
      "value": "昭苏县",
      "label": "昭苏县"
    }, {
      "value": "新源县",
      "label": "新源县"
    }, {
      "value": "霍城县",
      "label": "霍城县"
    }, {
      "value": "巩留县",
      "label": "巩留县"
    }, {
      "value": "察布查尔锡伯自治县",
      "label": "察布查尔锡伯自治县"
    }, {
      "value": "塔城地区",
      "label": "塔城地区"
    }, {
      "value": "阿勒泰地区",
      "label": "阿勒泰地区"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "伊犁哈萨克自治州"
  }, {
    "value": "其他",
    "area": ["其他"],
    "children": [{
      "value": "其他",
      "label": "其他"
    }],
    "label": "其他"
  }],
  "label": "新疆"
}, {
  "value": "台湾省",
  "children": [{
    "value": "台北市",
    "area": ["内湖区", "南港区", "中正区", "万华区", "大同区", "中山区", "松山区", "大安区", "信义区", "文山区", "士林区", "北投区"],
    "children": [{
      "value": "内湖区",
      "label": "内湖区"
    }, {
      "value": "南港区",
      "label": "南港区"
    }, {
      "value": "中正区",
      "label": "中正区"
    }, {
      "value": "万华区",
      "label": "万华区"
    }, {
      "value": "大同区",
      "label": "大同区"
    }, {
      "value": "中山区",
      "label": "中山区"
    }, {
      "value": "松山区",
      "label": "松山区"
    }, {
      "value": "大安区",
      "label": "大安区"
    }, {
      "value": "信义区",
      "label": "信义区"
    }, {
      "value": "文山区",
      "label": "文山区"
    }, {
      "value": "士林区",
      "label": "士林区"
    }, {
      "value": "北投区",
      "label": "北投区"
    }],
    "label": "台北市"
  }, {
    "value": "新北市",
    "area": ["板桥区", "汐止区", "新店区", "其他"],
    "children": [{
      "value": "板桥区",
      "label": "板桥区"
    }, {
      "value": "汐止区",
      "label": "汐止区"
    }, {
      "value": "新店区",
      "label": "新店区"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "新北市"
  }, {
    "value": "桃园市",
    "area": ["其他"],
    "children": [{
      "value": "其他",
      "label": "其他"
    }],
    "label": "桃园市"
  }, {
    "value": "台中市",
    "area": ["其他"],
    "children": [{
      "value": "其他",
      "label": "其他"
    }],
    "label": "台中市"
  }, {
    "value": "台南市",
    "area": ["其他"],
    "children": [{
      "value": "其他",
      "label": "其他"
    }],
    "label": "台南市"
  }, {
    "value": "高雄市",
    "area": ["其他"],
    "children": [{
      "value": "其他",
      "label": "其他"
    }],
    "label": "高雄市"
  }],
  "label": "台湾省"
}, {
  "value": "澳门",
  "children": [{
    "value": "澳门",
    "area": ["花地玛堂区", "圣安多尼堂区", "大堂区", "望德堂区", "风顺堂区", "嘉模堂区", "圣方济各堂区", "路凼", "其他"],
    "children": [{
      "value": "花地玛堂区",
      "label": "花地玛堂区"
    }, {
      "value": "圣安多尼堂区",
      "label": "圣安多尼堂区"
    }, {
      "value": "大堂区",
      "label": "大堂区"
    }, {
      "value": "望德堂区",
      "label": "望德堂区"
    }, {
      "value": "风顺堂区",
      "label": "风顺堂区"
    }, {
      "value": "嘉模堂区",
      "label": "嘉模堂区"
    }, {
      "value": "圣方济各堂区",
      "label": "圣方济各堂区"
    }, {
      "value": "路凼",
      "label": "路凼"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "澳门"
  }],
  "label": "澳门"
}, {
  "value": "香港",
  "children": [{
    "value": "香港",
    "area": ["深水埗区", "油尖旺区", "九龙城区", "黄大仙区", "观塘区", "北区", "大埔区", "沙田区", "西贡区", "元朗区", "屯门区", "荃湾区", "葵青区", "离岛区", "中西区", "湾仔区", "东区", "南区", "其他"],
    "children": [{
      "value": "深水埗区",
      "label": "深水埗区"
    }, {
      "value": "油尖旺区",
      "label": "油尖旺区"
    }, {
      "value": "九龙城区",
      "label": "九龙城区"
    }, {
      "value": "黄大仙区",
      "label": "黄大仙区"
    }, {
      "value": "观塘区",
      "label": "观塘区"
    }, {
      "value": "北区",
      "label": "北区"
    }, {
      "value": "大埔区",
      "label": "大埔区"
    }, {
      "value": "沙田区",
      "label": "沙田区"
    }, {
      "value": "西贡区",
      "label": "西贡区"
    }, {
      "value": "元朗区",
      "label": "元朗区"
    }, {
      "value": "屯门区",
      "label": "屯门区"
    }, {
      "value": "荃湾区",
      "label": "荃湾区"
    }, {
      "value": "葵青区",
      "label": "葵青区"
    }, {
      "value": "离岛区",
      "label": "离岛区"
    }, {
      "value": "中西区",
      "label": "中西区"
    }, {
      "value": "湾仔区",
      "label": "湾仔区"
    }, {
      "value": "东区",
      "label": "东区"
    }, {
      "value": "南区",
      "label": "南区"
    }, {
      "value": "其他",
      "label": "其他"
    }],
    "label": "香港"
  }],
  "label": "香港"
}];

export const area = [
  { label: '中国', value: '+86' },
  { label: '中国香港', value: '+852' },
  { label: '中国澳门', value: '+853' },
  { label: '中国台湾', value: '+886' },
  { label: '美国', value: '+1' },
  { label: '日本', value: '+81' },
  { label: '韩国', value: '+82' },
  { label: '马来西亚', value: '+60' },
  { label: '新加坡', value: '+65' },
  { label: '越南', value: '+84' },
  { label: '澳大利亚', value: '+61' },
  { label: '加拿大', value: '+1' },
  { label: '英国', value: '+44' },
  { label: '法国', value: '+33' },
  { label: '俄罗斯', value: '+7' },
  { label: '德国', value: '+49' },
  { label: '泰国', value: '+66' },
  { label: '印度', value: '+91' },
  { label: '菲律宾', value: '+63' },
  { label: '巴西', value: '+55' },
  { label: '印度尼西亚', value: '+62' },
  { label: '意大利', value: '+39' },
  { label: '土耳其', value: '+90' },
  { label: '新西兰', value: '+64' },
]
export default privacyData;
